var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 57.48 48.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0.01,
    width: 57.47,
    height: 48.05
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_151-2",
    "data-name": "Group 151-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3748",
    "data-name": "Path 3748",
    className: "cls-3",
    d: "M9.28,44.91a.27.27,0,0,1,.38.06v0a2.11,2.11,0,0,0,2,.93c1,0,1.52-.46,1.52-1.35a1.24,1.24,0,0,0-.4-1c-.28-.2-.28-.2-1.62-.6-2-.58-2.78-1.52-2.78-3.41A3,3,0,0,1,11,36.22a2.58,2.58,0,0,1,.68,0,3.29,3.29,0,0,1,3.12,1.61.29.29,0,0,1-.07.37L13.58,39A.27.27,0,0,1,13.2,39h0a1.81,1.81,0,0,0-1.59-.81,1.14,1.14,0,0,0-1.25,1,.89.89,0,0,0,0,.23c0,.87.41,1.24,1.81,1.65a5.33,5.33,0,0,1,2,.86,3,3,0,0,1,.95,2.54,3.45,3.45,0,0,1-.8,2.52,3.74,3.74,0,0,1-2.73.92,4.73,4.73,0,0,1-2.72-.76,2.89,2.89,0,0,1-.87-1,.27.27,0,0,1,.08-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3749",
    "data-name": "Path 3749",
    className: "cls-3",
    d: "M9.28,44.91a.27.27,0,0,1,.38.06v0a2.11,2.11,0,0,0,2,.93c1,0,1.52-.46,1.52-1.35a1.24,1.24,0,0,0-.4-1c-.28-.2-.28-.2-1.62-.6-2-.58-2.78-1.52-2.78-3.41A3,3,0,0,1,11,36.22a2.58,2.58,0,0,1,.68,0,3.29,3.29,0,0,1,3.12,1.61.29.29,0,0,1-.07.37L13.58,39A.27.27,0,0,1,13.2,39h0a1.81,1.81,0,0,0-1.59-.81,1.14,1.14,0,0,0-1.25,1,.89.89,0,0,0,0,.23c0,.87.41,1.24,1.81,1.65a5.33,5.33,0,0,1,2,.86,3,3,0,0,1,.95,2.54,3.45,3.45,0,0,1-.8,2.52,3.74,3.74,0,0,1-2.73.92,4.73,4.73,0,0,1-2.72-.76,2.89,2.89,0,0,1-.87-1,.27.27,0,0,1,.08-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3750",
    "data-name": "Path 3750",
    className: "cls-3",
    d: "M9.16,44.85c.06,0,0,0,0-.05s0,.05,0,.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3751",
    "data-name": "Path 3751",
    className: "cls-3",
    d: "M8.26,45.57v0l-.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3752",
    "data-name": "Path 3752",
    className: "cls-3",
    d: "M8.22,46.55a1,1,0,0,0-.13-.22L8,46.18A.28.28,0,0,1,7.94,46v0a.24.24,0,0,1,0-.12.33.33,0,0,0,0,.24.69.69,0,0,0,.1.19l.18.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3753",
    "data-name": "Path 3753",
    className: "cls-3",
    d: "M8.56,47.05l-.1-.1,0,0,.08.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3754",
    "data-name": "Path 3754",
    className: "cls-3",
    d: "M8.48,47c-.09-.09,0,.06,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3755",
    "data-name": "Path 3755",
    className: "cls-3",
    d: "M8.91,47.32l-.14-.08s.14.11.09.08c.14.09.12.06.05,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3756",
    "data-name": "Path 3756",
    className: "cls-3",
    d: "M9.05,47.38l-.07,0,.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3757",
    "data-name": "Path 3757",
    className: "cls-3",
    d: "M8.83,47.25l.15.09a.09.09,0,0,0-.07,0s0,0-.08,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3758",
    "data-name": "Path 3758",
    className: "cls-3",
    d: "M8.75,47.19c-.06-.07-.14-.14,0,0-.11-.09-.16-.13-.16-.12a1,1,0,0,0,.18.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3759",
    "data-name": "Path 3759",
    className: "cls-3",
    d: "M8.29,46.57l-.06-.1-.06-.07a.66.66,0,0,0,.12.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3760",
    "data-name": "Path 3760",
    className: "cls-3",
    d: "M9.77,47.77l0-.05-.11,0a1.29,1.29,0,0,1,.16.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3761",
    "data-name": "Path 3761",
    className: "cls-3",
    d: "M9.72,47.72l.16,0c-.14,0-.17-.06-.16,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3762",
    "data-name": "Path 3762",
    className: "cls-3",
    d: "M9.09,47.36l-.25-.13c.1.05.2.11.3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3763",
    "data-name": "Path 3763",
    className: "cls-3",
    d: "M10.4,47.94h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3764",
    "data-name": "Path 3764",
    className: "cls-3",
    d: "M10.82,48c-.07,0,.1,0,0,0h.31a1.88,1.88,0,0,1-.33-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3765",
    "data-name": "Path 3765",
    className: "cls-3",
    d: "M11.3,48.05h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3766",
    "data-name": "Path 3766",
    className: "cls-3",
    d: "M10.16,47.84l.12.06-.06,0-.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3767",
    "data-name": "Path 3767",
    className: "cls-3",
    d: "M10.23,47.86h0l.14,0-.15,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3768",
    "data-name": "Path 3768",
    className: "cls-3",
    d: "M10.14,47.84h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3769",
    "data-name": "Path 3769",
    className: "cls-3",
    d: "M9.48,47.58c.1,0,.29.09.11,0s0,0-.11,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3770",
    "data-name": "Path 3770",
    className: "cls-3",
    d: "M10.07,47.79l-.17,0s0,0,0,0l.19,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3771",
    "data-name": "Path 3771",
    className: "cls-3",
    d: "M10.16,47.81l-.09,0,.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3772",
    "data-name": "Path 3772",
    className: "cls-3",
    d: "M11,48h.25L11,48s-.06,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3773",
    "data-name": "Path 3773",
    className: "cls-3",
    d: "M10.62,48h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3775",
    "data-name": "Path 3775",
    className: "cls-3",
    d: "M10.93,48l-.17,0L11,48h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3776",
    "data-name": "Path 3776",
    className: "cls-3",
    d: "M11.56,48.05l-.13,0,.13,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3777",
    "data-name": "Path 3777",
    className: "cls-3",
    d: "M10.66,48h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3778",
    "data-name": "Path 3778",
    className: "cls-3",
    d: "M10.66,48h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3779",
    "data-name": "Path 3779",
    className: "cls-3",
    d: "M12.46,47.83a.82.82,0,0,1-.38.06c-.17,0-.05.09.1.11l.18,0c-.06,0-.39,0-.25,0a1.51,1.51,0,0,1,.3,0c-.1,0,.29-.08.23-.11l-.2,0s.07,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3780",
    "data-name": "Path 3780",
    className: "cls-3",
    d: "M11.84,48H12c.12,0,.15,0,.16,0l-.36,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3781",
    "data-name": "Path 3781",
    className: "cls-3",
    d: "M11.44,48c.06,0,.24,0,.13-.05a1.32,1.32,0,0,0-.28,0c.35,0-.1,0,.15,0h-.19l.18,0h0c.1,0,0,0,0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3782",
    "data-name": "Path 3782",
    className: "cls-3",
    d: "M9.78,47.6h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3783",
    "data-name": "Path 3783",
    className: "cls-3",
    d: "M9.91,47.66a.28.28,0,0,1-.13,0c-.06,0,0,0,0,0s-.16,0,0,0h0l.27.12-.15-.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3784",
    "data-name": "Path 3784",
    className: "cls-3",
    d: "M10.67,47.89l.28,0-.14,0h0c-.15,0-.12,0-.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3785",
    "data-name": "Path 3785",
    className: "cls-3",
    d: "M12.23,48l0,0,.17-.05-.13,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3786",
    "data-name": "Path 3786",
    className: "cls-3",
    d: "M12.6,48v0l.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3787",
    "data-name": "Path 3787",
    className: "cls-3",
    d: "M13.14,36.57l-.07,0,.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3788",
    "data-name": "Path 3788",
    className: "cls-3",
    d: "M13.66,36.83h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3789",
    "data-name": "Path 3789",
    className: "cls-3",
    d: "M12.92,41.17c-.11-.06-.23-.13-.22-.1l0,0,.2.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3790",
    "data-name": "Path 3790",
    className: "cls-3",
    d: "M12.34,38.28l0,0h-.09l.12,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3791",
    "data-name": "Path 3791",
    className: "cls-3",
    d: "M12.45,38.23l.15.08-.15-.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3792",
    "data-name": "Path 3792",
    className: "cls-3",
    d: "M10,36.68l-.07.06c.13-.07.07,0,.07-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3793",
    "data-name": "Path 3793",
    className: "cls-3",
    d: "M15.21,45.44a2.38,2.38,0,0,0,0-.26.75.75,0,0,0,0,.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3794",
    "data-name": "Path 3794",
    className: "cls-3",
    d: "M13.45,36.45l-.07,0,.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3795",
    "data-name": "Path 3795",
    className: "cls-3",
    d: "M15.28,44.87v.06a2.18,2.18,0,0,1,0,.25,1.08,1.08,0,0,0,0-.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3796",
    "data-name": "Path 3796",
    className: "cls-3",
    d: "M13.19,45.2v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3797",
    "data-name": "Path 3797",
    className: "cls-3",
    d: "M10.1,45.34l.1.08-.1-.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3798",
    "data-name": "Path 3798",
    className: "cls-3",
    d: "M14,47.43h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3799",
    "data-name": "Path 3799",
    className: "cls-3",
    d: "M13.65,47.55l0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3801",
    "data-name": "Path 3801",
    className: "cls-3",
    d: "M13.92,47.49l.09-.05-.09.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3802",
    "data-name": "Path 3802",
    className: "cls-3",
    d: "M13.94,47.49l-.06,0,.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3803",
    "data-name": "Path 3803",
    className: "cls-3",
    d: "M14.12,47.37l-.11.07h0l.09-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3804",
    "data-name": "Path 3804",
    className: "cls-3",
    d: "M8.82,41.37h0c0,.06,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3805",
    "data-name": "Path 3805",
    className: "cls-3",
    d: "M10.93,40.68h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3806",
    "data-name": "Path 3806",
    className: "cls-3",
    d: "M10.68,40.52a1.32,1.32,0,0,1,.25.16l0-.11-.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3807",
    "data-name": "Path 3807",
    className: "cls-3",
    d: "M11.77,36.34l.19,0c-.23,0-.4,0-.21,0,0,0,.2,0,.38,0s.37,0,.38,0l.12,0h-.07a.54.54,0,0,0,.22,0,.63.63,0,0,1,.27,0c.1,0,.17.08.1.06l.23.08c.07,0,0,0,0,0l.33.17h0l.21.1c.07.07-.05,0,0,0L14,37c.05.06-.09,0-.2-.12.11.17.16.08.42.4l-.14-.13c.06.11.17.21.28.4,0-.05-.23-.37-.07-.22a1.63,1.63,0,0,0,.17.2s.06.1.13.23h0a.28.28,0,0,0,.06.08l0,0s0,0,0,.05a.08.08,0,0,1,0,.09,0,0,0,0,1-.05,0c-.23.17.19-.09-.08.13a4.71,4.71,0,0,0-.56.44c-.14.09,0,0,0,0l-.11.11s0,0,0,0,0,0-.15.16L13.6,39a.29.29,0,0,1-.13,0,.28.28,0,0,1-.13,0l-.05,0-.07-.07c0-.05,0,0,0,0L13,38.61a1.14,1.14,0,0,0-.23-.15,1.56,1.56,0,0,0-.2-.16c.15.12-.07,0-.26,0l.13.08-.3-.09s0,0,.05,0h-.05c-.1,0-.05,0,0,0l.1,0c.07,0,.15,0,.14,0l-.1,0h0l-.1,0-.06,0h0a1.58,1.58,0,0,0-.42-.09,2.22,2.22,0,0,0-.45.07,1.41,1.41,0,0,0-.52.26c.08-.09,0,0,0-.08l.25-.12a.79.79,0,0,1,.34-.1c-.13,0-.1,0-.07,0a1.46,1.46,0,0,0-.43.18s-.1,0-.2.1c.06,0,0,0-.09.14a1,1,0,0,0-.18.31s0,0,.1-.24a.42.42,0,0,0-.12.26l-.06.28s0-.07,0-.1,0,.17,0,.25,0,.14,0,.11V39.3a1.79,1.79,0,0,0,.08.69.72.72,0,0,0,.27.37.14.14,0,0,1-.09,0,1.4,1.4,0,0,0,.58.27c-.06,0,.08.19-.19.07a1.66,1.66,0,0,0,.33.16s-.1-.11,0-.07a1.58,1.58,0,0,0,.36.2c-.08,0,0,0,.16,0,0,0,0,.06-.06.05l.33,0c-.08,0,0,0,0,.08s.28.08.36.1l-.13-.06c.36.12.38,0,.73.15,0,0-.13,0,.05.1a1.79,1.79,0,0,1,.72.12l0,0a1.67,1.67,0,0,1,.23.12,3.56,3.56,0,0,0-.38-.12l-.44-.1a.88.88,0,0,0,.22.1c.06,0-.11,0-.17,0a4.09,4.09,0,0,1,.42.2s.08,0,.17.06.16.09.16.07a2.82,2.82,0,0,0-.46-.23s.31,0,.59.26c.06.06-.09,0-.09,0a1.39,1.39,0,0,1,.27.21l-.12-.08c.12.13.25.18.35.38s.08.22.1.22.06-.21.13-.15a1,1,0,0,1,.09.22A2.29,2.29,0,0,1,15,43c0,.13-.13-.17-.12-.05s0,.06.06.09,0,0,0,.14.08.36.05.08a1.59,1.59,0,0,1,.07.38c0-.06.1.18.12.36l0,0a6.77,6.77,0,0,1,0,.9s0,.19,0,.12a1.34,1.34,0,0,1,0,.2c-.05.2,0-.23,0-.08a1.39,1.39,0,0,1,0,.41,1.31,1.31,0,0,0,.08-.48s.06.27,0,.62-.07.12-.07.17c-.09.25-.13.36-.16.46a.85.85,0,0,1-.21.37c-.13.13,0,0-.08,0,.1-.14.19-.28.28-.43l-.1.16.13-.28c-.09.16-.18.32-.29.48a2,2,0,0,1-.53.52c-.05.05-.15.12-.1.1l.1-.08c.11-.05-.18.17,0,.08a1.64,1.64,0,0,1-.54.32h-.05a.78.78,0,0,0,.21-.09c-.08.07-.36.12-.45.19l.17,0a2.08,2.08,0,0,1-.59.21c.11,0,.05,0,.21,0-.07,0,.07,0,.2-.08s.24-.08.13-.06a2.6,2.6,0,0,0,.47-.16s-.07,0,.1-.06l0,0h0l-.09,0,.39-.3c.09-.07,0,0,0,0a.52.52,0,0,0,.1-.11s.24-.18.06,0l.17-.17a1.72,1.72,0,0,0,.28-.37c.06-.1.11-.26.08-.17a3.62,3.62,0,0,0,.13-.35h0a7.4,7.4,0,0,0,.22-1.14c0-.13,0-.25,0-.46l0,0a4.58,4.58,0,0,0,0-.53,1.6,1.6,0,0,0,0-.49,5.7,5.7,0,0,0-.16-.55h0a2.06,2.06,0,0,0-.3-.54v0l-.24-.3a2.67,2.67,0,0,0-.36-.31.6.6,0,0,1,.13.09,1.71,1.71,0,0,0-.5-.32c-.18-.08-.37-.14-.52-.22a1.17,1.17,0,0,1-.2-.06h0l-.11-.05.09.05-.26-.08,0,0h0c-.09,0-.08,0,0,0l-.12,0c-.07-.06-.25-.06-.34-.13s-.47-.13-.53-.11,0,0,0,0l-.29-.11,0,0-.22-.06c-.12-.08-.16-.12,0-.07L11,40.46l-.09-.05-.2-.16h0a.56.56,0,0,1-.17-.26,1.31,1.31,0,0,1-.06-.27,2.06,2.06,0,0,1,0-.43,1.31,1.31,0,0,1,.12-.48.77.77,0,0,1,.29-.33c-.06,0,0,0,.06-.07s.17-.06.17-.08.11,0,0,0a2.16,2.16,0,0,1,.62-.09s-.06,0,0,0h.12s0,0-.09,0a1.31,1.31,0,0,0,.28,0,.12.12,0,0,0,.08,0l.33.1s.11.08-.06,0a1.92,1.92,0,0,1,.31.18l.23.18.12.13a1.63,1.63,0,0,0,.17.2.34.34,0,0,0,.3.07h-.08a.67.67,0,0,0,.18-.07l.2-.13h0c.37-.24.14-.12.52-.36h0s.09-.08.19-.15l.17-.1.17-.14-.09.06A.45.45,0,0,0,14.9,38a.31.31,0,0,0,0-.19.19.19,0,0,0,0-.07l0,0,.06.07c-.18-.34-.05,0-.22-.26,0,0,.08,0,0-.12a1.14,1.14,0,0,0-.24-.25l-.18-.17-.17-.15c0,.05.07.09,0,0a2.07,2.07,0,0,0-.62-.38l0,0a2.65,2.65,0,0,0-.57-.15,1,1,0,0,0-.51-.11c-.22,0-.41,0-.41,0h-.46a1.73,1.73,0,0,0-.32,0l-.18,0c-.07,0,0,0,0,0l-.45.09a2.32,2.32,0,0,0-.36.16h0a.75.75,0,0,1-.13.06l-.24.12-.27.17a2.73,2.73,0,0,0-.25.23l0,0-.27.29-.23.33a1.15,1.15,0,0,0-.2.52l-.06.31c.12-.39,0,.07.08-.08l0,.12,0,.11c0,.05,0,.06,0,0v0s0,.08-.07.21a2.73,2.73,0,0,1-.05.27,5.92,5.92,0,0,0,0,1.19,3.2,3.2,0,0,0,.29,1.13v-.1a2.56,2.56,0,0,0,.11.24c0,.06,0,.1-.07-.07a.7.7,0,0,0,.19.26c.21.32-.12-.09-.05,0l.1.13,0,0c.08.1.11.09.26.26s0,.07.08.11l.06.06.27.21-.09-.1c.12.08.26.18.14.07l.24.17a2.75,2.75,0,0,0,.38.2c.27.13.55.21.61.24a5.2,5.2,0,0,1,.63.18c-.06,0-.09-.07.12,0-.1,0,.37.13.51.23-.06,0,.08,0,.21,0s.25.09.15,0c.15.08,0,0,.1.1a1.51,1.51,0,0,1,.26.18A1,1,0,0,1,13,44a1.51,1.51,0,0,1,.1.7s0-.07,0,0A2.41,2.41,0,0,1,13,45a.17.17,0,0,0,0,.1.34.34,0,0,1-.06.15s0-.05,0,0a.85.85,0,0,1-.22.28,1.17,1.17,0,0,1-.3.19,2.11,2.11,0,0,1-.74.14,2.09,2.09,0,0,1-1.43-.4c.1.09,0,0-.06,0s0,0,0,0a2,2,0,0,1-.28-.31.79.79,0,0,1-.17-.2.37.37,0,0,0-.15-.13.15.15,0,0,0-.11,0,.44.44,0,0,1,.16.06c-.11,0,0,0,0,.09s.08.18.05.18.15.19.26.31a.92.92,0,0,0,.42.28c.07,0-.06,0,0,0l.37.14h0a2.94,2.94,0,0,0,.67.13,3,3,0,0,0,.73,0h0l.23,0c.07,0,0,0-.12,0s-.19,0-.12,0a1.13,1.13,0,0,0,.54-.13,2,2,0,0,0,.44-.32c.12-.18-.06,0,.06-.14l0-.05v0c.06-.13.09-.2.11-.2a.65.65,0,0,0,0,.13,1.16,1.16,0,0,0,.08-.32c0-.12,0-.22,0-.25l0,.2a1.93,1.93,0,0,0-.11-.92,1,1,0,0,0-.3-.39l-.18-.13a.88.88,0,0,0-.2-.09l0,0-.35-.12-.38-.13h0a2.06,2.06,0,0,1-.32-.07c.12,0-.19-.09-.05-.06a2.1,2.1,0,0,0-.5-.09l-.05,0a1.16,1.16,0,0,1-.32-.08c.18,0-.12-.07.08,0a3.52,3.52,0,0,1-.79-.39c-.1,0,0,0,.07.08s.2.11.15.08-.18,0-.29-.12a.5.5,0,0,1-.17-.15l-.28-.27s0,0,0,0a1.7,1.7,0,0,1-.29-.31c-.08-.06-.13-.17-.17-.17a2.43,2.43,0,0,0,.2.25,1.44,1.44,0,0,1-.4-.54,1.28,1.28,0,0,1,.1.15,1.89,1.89,0,0,1-.11-.25c.05,0,.17.37.33.5,0,0-.08-.11-.12-.17s-.06-.1,0-.06a.64.64,0,0,1-.14-.22L8.69,41a.77.77,0,0,0-.07-.16h0a.64.64,0,0,1-.06-.18.24.24,0,0,0,.06.11.9.9,0,0,1-.07-.27,2.36,2.36,0,0,0,0-.28c.06.39,0,.09,0,.26a.79.79,0,0,1,0-.4,2.17,2.17,0,0,0,0-.44c0,.07,0,.28,0,.16a1.62,1.62,0,0,1,0-.31c0-.36,0,.06,0-.1s0-.18,0-.34h0c.06-.41-.05-.12,0-.49v.16l0-.19,0,0a.67.67,0,0,1,0-.24,2.11,2.11,0,0,1,.08-.22s0,0,0-.21,0,0,0,0l.06-.13a.58.58,0,0,1-.08.22s0,.06,0,.07l.1-.2.08-.18a.41.41,0,0,1,0,.09c0-.06,0-.12.08-.17l.09-.17s0,0,0,0a.41.41,0,0,0,0-.09l.08-.1s0,0-.07.17l.21-.28s.15-.1.12-.07a2.49,2.49,0,0,1,.6-.42l.09,0,.17-.07.17,0,.38-.1H11c.23,0-.23,0,.15-.08s.1,0,.2,0l.27,0a1.45,1.45,0,0,1,.36,0h-.23m2.55,1s-.13-.1-.15-.14.09.07.15.14m-2.4.76.18,0-.18,0m2.74,8.68h0c.09-.1.06-.07,0,0m-.18.2s0,0,0,0l.1-.12-.1.1M9.22,42.1l0,0c.1.08.07.06,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3808",
    "data-name": "Path 3808",
    className: "cls-3",
    d: "M12.44,38.23l0,0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3809",
    "data-name": "Path 3809",
    className: "cls-3",
    d: "M10.06,36.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3810",
    "data-name": "Path 3810",
    className: "cls-3",
    d: "M14.88,43.09a.44.44,0,0,1,0-.1s0,0,0,.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3811",
    "data-name": "Path 3811",
    className: "cls-3",
    d: "M13.28,47.81l.16-.07-.15,0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3812",
    "data-name": "Path 3812",
    className: "cls-3",
    d: "M11.79,47.9h-.07c.11,0,.18,0,.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3813",
    "data-name": "Path 3813",
    className: "cls-3",
    d: "M13.1,47.78a.59.59,0,0,0-.23,0h0s.1,0,.21,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3814",
    "data-name": "Path 3814",
    className: "cls-3",
    d: "M12.84,47.84l-.11,0s0,0,.11,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3815",
    "data-name": "Path 3815",
    className: "cls-3",
    d: "M14.24,47.26c-.05,0,0,.05-.05.06s.28-.28.05-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3816",
    "data-name": "Path 3816",
    className: "cls-3",
    d: "M13,47.74h0l.06,0-.11,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3817",
    "data-name": "Path 3817",
    className: "cls-3",
    d: "M13.86,47.4l-.17.09,0,0a.72.72,0,0,0,.21-.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3818",
    "data-name": "Path 3818",
    className: "cls-3",
    d: "M13.65,47.52a.6.6,0,0,0-.14.07l.14-.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3819",
    "data-name": "Path 3819",
    className: "cls-3",
    d: "M13.24,47.66l0,0,.13,0-.18.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3820",
    "data-name": "Path 3820",
    className: "cls-3",
    d: "M15,45.8c0-.07,0-.14,0-.2s0,0,0,.1,0,.13,0,.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3821",
    "data-name": "Path 3821",
    className: "cls-3",
    d: "M14.76,46.35a.18.18,0,0,1,.05-.07l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3822",
    "data-name": "Path 3822",
    className: "cls-3",
    d: "M15,45.8s0-.29,0,0c0,0,0,.21,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3823",
    "data-name": "Path 3823",
    className: "cls-3",
    d: "M14.84,42.77l0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3824",
    "data-name": "Path 3824",
    className: "cls-3",
    d: "M12.66,41.36c.23.08.07,0,.27.07s-.17-.07-.11-.06c-.14,0-.21-.06-.16,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3825",
    "data-name": "Path 3825",
    className: "cls-3",
    d: "M12.82,41.37h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3826",
    "data-name": "Path 3826",
    className: "cls-3",
    d: "M9.76,44.9a.5.5,0,0,0-.17-.15.52.52,0,0,1,.11.1l.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3827",
    "data-name": "Path 3827",
    className: "cls-3",
    d: "M9.38,44.78l-.05,0a.27.27,0,0,0-.1.08.28.28,0,0,1,.16-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3828",
    "data-name": "Path 3828",
    className: "cls-3",
    d: "M14.52,37.74h0a.27.27,0,0,0-.06-.12l0,.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3829",
    "data-name": "Path 3829",
    className: "cls-3",
    d: "M13,36.54h0l-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3830",
    "data-name": "Path 3830",
    className: "cls-3",
    d: "M11.25,36.42h.22c-.15,0-.25,0-.22,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3831",
    "data-name": "Path 3831",
    className: "cls-3",
    d: "M18.48,38.37h-2a.27.27,0,0,1-.27-.27V36.66a.27.27,0,0,1,.27-.27h6.7a.27.27,0,0,1,.28.27V38.1a.27.27,0,0,1-.28.27h-2a.27.27,0,0,0-.28.28v8.79a.28.28,0,0,1-.27.28H19a.28.28,0,0,1-.27-.28V38.65a.28.28,0,0,0-.28-.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3832",
    "data-name": "Path 3832",
    className: "cls-3",
    d: "M18.48,38.37h-2a.27.27,0,0,1-.27-.27V36.66a.27.27,0,0,1,.27-.27h6.7a.27.27,0,0,1,.28.27V38.1a.27.27,0,0,1-.28.27h-2a.27.27,0,0,0-.28.28v8.79a.28.28,0,0,1-.27.28H19a.28.28,0,0,1-.27-.28V38.65a.28.28,0,0,0-.28-.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3833",
    "data-name": "Path 3833",
    className: "cls-3",
    d: "M18.5,38.5s0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3834",
    "data-name": "Path 3834",
    className: "cls-3",
    d: "M18.68,39.14v0l0,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3835",
    "data-name": "Path 3835",
    className: "cls-3",
    d: "M18.68,40a3.23,3.23,0,0,0,0-.44v0l0-.06c0,.18,0,.41,0,.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3836",
    "data-name": "Path 3836",
    className: "cls-3",
    d: "M18.6,40.4s0,.1,0-.1v.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3837",
    "data-name": "Path 3837",
    className: "cls-3",
    d: "M18.6,40.32c0-.09,0,.06,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3838",
    "data-name": "Path 3838",
    className: "cls-3",
    d: "M18.61,40.72v-.11s0,.12,0,.09,0,.09,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3839",
    "data-name": "Path 3839",
    className: "cls-3",
    d: "M18.64,40.83v-.06a.13.13,0,0,0,0,.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3840",
    "data-name": "Path 3840",
    className: "cls-3",
    d: "M18.62,40.64v.13s0,0,0-.06,0,0,0-.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3841",
    "data-name": "Path 3841",
    className: "cls-3",
    d: "M18.62,40.58c0-.07,0-.15,0,0,0-.22,0-.19,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3842",
    "data-name": "Path 3842",
    className: "cls-3",
    d: "M18.72,40v-.09l0-.07s0,.16,0,.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3843",
    "data-name": "Path 3843",
    className: "cls-3",
    d: "M18.59,41.43s0,0,0,0V41.3a.68.68,0,0,1,0,.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3844",
    "data-name": "Path 3844",
    className: "cls-3",
    d: "M18.62,41.39v.12c0-.11,0-.13,0-.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3845",
    "data-name": "Path 3845",
    className: "cls-3",
    d: "M18.67,40.85l0-.21,0,.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3846",
    "data-name": "Path 3846",
    className: "cls-3",
    d: "M18.59,41.92l0-.07,0,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3847",
    "data-name": "Path 3847",
    className: "cls-3",
    d: "M18.59,42.24c0-.06,0,.07,0,0a1.64,1.64,0,0,0,0,.23,1.93,1.93,0,0,1,0-.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3848",
    "data-name": "Path 3848",
    className: "cls-3",
    d: "M18.6,42.6a.5.5,0,0,0,0-.12s0,.08,0,.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3849",
    "data-name": "Path 3849",
    className: "cls-3",
    d: "M18.63,41.73a.16.16,0,0,0,0,.1l0,0v-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3851",
    "data-name": "Path 3851",
    className: "cls-3",
    d: "M18.63,41.72h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3852",
    "data-name": "Path 3852",
    className: "cls-3",
    d: "M18.66,41.18c0,.08,0,.23,0,.08s0,0,0-.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3853",
    "data-name": "Path 3853",
    className: "cls-3",
    d: "M18.66,41.65v-.13s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3854",
    "data-name": "Path 3854",
    className: "cls-3",
    d: "M18.66,41.72v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3855",
    "data-name": "Path 3855",
    className: "cls-3",
    d: "M18.62,42.37a1.15,1.15,0,0,1,0,.19c0-.08,0-.16,0-.23s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    className: "cls-3",
    d: "M18.64,42.31a.48.48,0,0,0,0-.12v.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    className: "cls-3",
    d: "M18.61,42.79s0-.06,0-.1a.34.34,0,0,0,0,.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    className: "cls-3",
    d: "M18.62,42.11s0,.06,0,.08a.34.34,0,0,0,0-.1v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    className: "cls-3",
    d: "M18.77,43.48a.58.58,0,0,1,0-.29c0-.13-.08,0-.11.06s0,0,0,.14c0,0,0-.29,0-.18a.62.62,0,0,1,0,.23c0-.08,0,.22.07.18v-.15s0,.05,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    className: "cls-3",
    d: "M18.64,43v0l0,.18a.69.69,0,0,0,0,.12V43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3864",
    "data-name": "Path 3864",
    className: "cls-3",
    d: "M18.64,42.7s0,.17.05.09a.64.64,0,0,0,0-.2c0,.26,0-.08,0,.11a.61.61,0,0,0,0-.14s0,.09,0,.13h0c0,.08,0,0,0,0h0v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    className: "cls-3",
    d: "M18.75,41.4h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    "data-name": "Path 3866",
    className: "cls-3",
    d: "M18.73,41.51a.38.38,0,0,1,0-.1c0-.06,0,0,0,0s0-.13,0,0v0a.78.78,0,0,1,0,.22.5.5,0,0,0,.05-.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3867",
    "data-name": "Path 3867",
    className: "cls-3",
    d: "M18.69,42.11v.22l0-.11h0c0-.13,0-.1,0-.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    "data-name": "Path 3868",
    className: "cls-3",
    d: "M18.62,43.29l0,0,0,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3869",
    "data-name": "Path 3869",
    className: "cls-3",
    d: "M18.62,43.57h0l0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3870",
    "data-name": "Path 3870",
    className: "cls-3",
    d: "M21.44,38.25h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    className: "cls-3",
    d: "M20.93,38.3v0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    "data-name": "Path 3872",
    className: "cls-3",
    d: "M21,46.83c0-.09.05-.2,0-.18l0,0v.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3873",
    "data-name": "Path 3873",
    className: "cls-3",
    d: "M20.84,42.11v0l0,.06,0-.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3874",
    "data-name": "Path 3874",
    className: "cls-3",
    d: "M20.75,42.05v-.12s0,.06,0,.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3875",
    "data-name": "Path 3875",
    className: "cls-3",
    d: "M23.27,37.72l0-.08c0,.12,0,.07,0,.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3876",
    "data-name": "Path 3876",
    className: "cls-3",
    d: "M18.63,46.44a1.56,1.56,0,0,0,0,.2c0-.1,0-.17,0-.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3877",
    "data-name": "Path 3877",
    className: "cls-3",
    d: "M21.26,38.48h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3878",
    "data-name": "Path 3878",
    className: "cls-3",
    d: "M18.62,46.87v-.23a.88.88,0,0,0,0,.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3880",
    "data-name": "Path 3880",
    className: "cls-3",
    d: "M17.71,38.47h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3882",
    "data-name": "Path 3882",
    className: "cls-3",
    d: "M18.7,44.41a0,0,0,0,0,0,0,0,0,0,0,1,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3884",
    "data-name": "Path 3884",
    className: "cls-3",
    d: "M18.63,44.61a.17.17,0,0,1,0,.07.26.26,0,0,1,0-.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3885",
    "data-name": "Path 3885",
    className: "cls-3",
    d: "M18.62,44.62v0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3887",
    "data-name": "Path 3887",
    className: "cls-3",
    d: "M20.41,36.45h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3889",
    "data-name": "Path 3889",
    className: "cls-3",
    d: "M20.73,45.07a.5.5,0,0,1,0,.21l.06-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3890",
    "data-name": "Path 3890",
    className: "cls-3",
    d: "M22.54,38.24l-.15,0c.18,0,.32,0,.17,0s-.58,0-.6.07h0c-.2,0-.15,0-.4,0-.08,0-.14,0-.08,0l-.2,0c-.05,0,0,0,0,0h-.15a.36.36,0,0,0-.2.06h0a.39.39,0,0,0-.13.2c0,.09,0-.05,0,0a.46.46,0,0,0,0,.2s0,0,0,0a.34.34,0,0,1,0-.2.24.24,0,0,0-.07.21.76.76,0,0,1,0,.3v-.15a2.6,2.6,0,0,0-.05.39s.07-.35.08-.17a1.48,1.48,0,0,0,0,.21s0,.09,0,.21h0a1.06,1.06,0,0,0,0,.19.29.29,0,0,1-.05.2c0,.23,0-.15.05.11a3.25,3.25,0,0,0,0,.54c0,.14,0,0,0,0l0,.11s0,0,0,0,0,0,0,.16-.05.32,0,.5,0,0,0,0,0,.29.05.44l0,.18c0-.13,0,0,.08.19a1,1,0,0,1,0-.12v.24s0,0,0,0v0c0,.09,0,0-.05,0l0-.08c0-.06,0-.12-.06-.1s0,.05,0,.07h0a.17.17,0,0,0,0,.07l0,0,0,0,0,.31a4,4,0,0,1,.1.77c0-.09,0,0-.07,0a2.36,2.36,0,0,0,0-.46c0,.1,0,.07,0,0l0,.33s0,.07,0,.15,0,.25.05.38,0,0,0-.19c0,.18.06.24,0,.41,0,0,0,0,0-.07s0,.32,0,.26v0a3.44,3.44,0,0,0,0,.85.1.1,0,0,1-.06,0l.14.47s-.12.12-.14-.1a1.22,1.22,0,0,0,0,.27s.05-.11.05,0,0,.21-.05.31c0-.06.06,0,.06.11s-.06,0-.06,0l.05.26c0-.07,0,0-.06,0a2.62,2.62,0,0,1,0,.29v-.11c0,.29.08.28.08.57,0,0-.07-.09-.08,0a1.62,1.62,0,0,1,.08.2.75.75,0,0,1,.05.16.36.36,0,0,1,0,.1.45.45,0,0,1,0,.11l-.05,0a.33.33,0,0,1-.17.16.32.32,0,0,0,.15-.28c0-.12-.06-.25-.08-.34a.59.59,0,0,0,0,.19s0-.09,0-.14v.26l0,0s0,0,0,.07-.07,0-.07.05a.16.16,0,0,0,.14-.18s.05,0,0,.11a.39.39,0,0,1-.08.1.37.37,0,0,1-.18,0c-.06,0,.05-.06.05-.07a1.27,1.27,0,0,1-.28,0l.12,0a3,3,0,0,1-.42,0c-.06,0-.18,0-.19,0s.12.16.05.19l-.39-.06c-.1,0,.15-.07.06-.1l-.08,0c-.06,0,0,0-.11,0s-.28,0-.07,0H19l-.08,0s0,0-.07,0a.23.23,0,0,1-.15-.15s0,0,0,0c0-.28,0-.43,0-.69,0,0,0-.15,0-.1a.77.77,0,0,1,0-.15c0-.16,0,.18,0,.06s0-.22,0-.32a1.15,1.15,0,0,0,0,.37s-.09-.2-.11-.47,0-.09,0-.13c0-.4-.08-.34-.05-.68,0-.13.06,0,.08,0a3.84,3.84,0,0,1,0,.39v-.14a.91.91,0,0,1,0,.23c0-.11,0-.68,0-1,0,0,0-.15,0-.1v.1c0,.09,0-.19,0-.06a1.86,1.86,0,0,1,0-.47l0,0a.55.55,0,0,0,0,.18c0-.08,0-.29,0-.37l0,.13a2.49,2.49,0,0,1,0-.47c0,.08,0,0,0,.16,0-.1,0,.42,0,.26,0,.12,0,.21-.05.37,0,0,0-.06,0,.08v0h0s0-.05,0-.07,0,.29,0,.36,0,0,0,0l0,.12s0,.22-.05,0v.18a1.82,1.82,0,0,0,0,.33c0,.08,0,.21,0,.14V46h0a6.31,6.31,0,0,1,0,.87c0,.11,0,.22,0,.34l0,0v.3s0,0,0,.08a.41.41,0,0,0,.05.09.29.29,0,0,0,.15.16.3.3,0,0,0,.16.05h.12c.16,0,.32,0,.42,0v0l.45,0v0a1.31,1.31,0,0,1,.28,0h.35a.43.43,0,0,0,.16-.05.36.36,0,0,0,.18-.25.66.66,0,0,0,0-.14.41.41,0,0,0,0-.11,1.34,1.34,0,0,1,0-.2v-.26s0,.05,0,.08a1.48,1.48,0,0,0,0-.2l0,0v0c0-.07,0-.06,0,0s0-.07,0-.1,0-.2,0-.28,0-.37-.06-.41,0,0,0,0a1,1,0,0,0,0-.24l0,0,0-.18c0-.11,0-.15.05,0a4.17,4.17,0,0,0-.05-.44h0a2.26,2.26,0,0,1,0-.26c0-.18,0-.88,0-1.34-.05.08,0-.22,0-.24s0-.09,0,0a3,3,0,0,0,0-.52s0,0,0,0v-.1s0,0,0,.07c0-.24,0-.26-.09-.28a.5.5,0,0,0,0-.27s0-.11,0,0a3.13,3.13,0,0,0,0-.53.29.29,0,0,0,0-.13v-.34c0-.08,0-.16,0-.3h0c0-.34,0-.15,0-.49l0,0c-.05,0,0-.3,0-.49v.07a2.93,2.93,0,0,1,.07-.41s0,0,0,.07c0-.28,0,0,0-.24,0,0,0,.05,0-.09a1.1,1.1,0,0,0,0-.26c0-.06,0-.12,0-.18a.61.61,0,0,1,0-.14s0,.05,0,0a.15.15,0,0,1,.13-.12l.23,0h0l.44,0c.11.08.71,0,.71,0H23l.15,0c.06,0,0,0,0,0a.36.36,0,0,0,.23-.13.39.39,0,0,0,.07-.16.76.76,0,0,0,0-.15l0-.17,0,0c0-.08,0-.48,0-.8a.06.06,0,0,1,0,0v-.29a.49.49,0,0,0,0-.17.34.34,0,0,0-.07-.19.39.39,0,0,0-.32-.14.32.32,0,0,0-.16,0l-.23,0c.3,0-.05,0,.08.05-.12,0-.32,0-.17,0h0c0-.05-.39,0-.38-.05l-1.76,0,.06,0h-.2c-.05,0-.07,0,.07,0a.49.49,0,0,0-.24,0c-.28,0,.11,0,0,0h-.09a1.18,1.18,0,0,1-.27,0c-.1,0-.05,0-.1,0h-.31l.1,0c-.11,0-.24,0-.12,0a9.57,9.57,0,0,0-1,0,2.75,2.75,0,0,1-.5,0c.05,0,.08,0-.09,0,.06-.06-.3,0-.43-.07.12,0-.46,0-.28,0-.13,0,0,0-.11,0h-.53a.32.32,0,0,0-.17,0,.38.38,0,0,0-.25.3v.16s0-.06,0,0L16,37c0,.08.06.07,0,.22,0,0,0,0,0,0,0,.2,0,.4,0,.59v.31a.38.38,0,0,0,.23.3l.18,0h.45l.6,0c-.11,0,0,0,0,0s0,0,0,0l.33,0c.06,0,.36,0,.4,0h-.11c.14,0-.2-.09-.18-.14-.15.05-.41-.06-.67,0-.06,0,.05,0,0,0a1,1,0,0,1-.29,0h-.49l-.21,0a.19.19,0,0,1-.11-.14l0,0a.66.66,0,0,1,0-.14c0-.06,0,0,0,.08s0,.1,0,.08,0-.27,0-.4a1.25,1.25,0,0,1,0-.38c0-.15,0,0,0-.1V37.2a.29.29,0,0,1,0-.16v.1c0-.13,0-.37,0-.41v0a.45.45,0,0,1,0-.12.19.19,0,0,1,.07-.08l.05,0h.06c.23,0,.46,0,.66,0h0c.31,0,.24,0,.58,0h0a1,1,0,0,1,.25,0c-.08,0,.16,0,.05,0a2.63,2.63,0,0,0,.39-.06h.05a1,1,0,0,1,.25,0c-.14,0,.11,0-.05,0,.35,0,.53,0,.69,0s-.31,0-.22,0c-.07,0,.14,0,.25,0a2.63,2.63,0,0,0,.48.06h-.06c.1,0,.21,0,.34,0s.17,0,.19,0H20a1.87,1.87,0,0,1,.53,0l-.14,0c.07,0,.13,0,.21,0s-.32,0-.48,0c.08,0,.3,0,.22,0,.12-.06.28,0,.48,0l0,0,.15,0-.1,0c.16,0,.3,0,.45,0-.31,0-.07,0-.2,0,.39,0,.23.06.66.05-.06,0-.22,0-.13,0a1,1,0,0,1,.24,0c.29,0,0,0,.08,0s.14,0,.27,0v0c.33,0,.09,0,.38,0l-.12,0h.15l0,0a1.61,1.61,0,0,1,.38,0s0,0,.16,0,0,0,0,0l.07,0h-.12l-.06,0h.13s.05,0,.06,0,0,0,0,0a.17.17,0,0,1,.06.06.2.2,0,0,1,0,.11s0,0,0,0,0,.1,0,.19,0,0-.05-.14l0,.28s0,.15,0,.11c0,.16,0,.39,0,.6a.17.17,0,0,1,0,.07v.29a.21.21,0,0,1-.07.14l-.07,0c-.18,0,.18,0-.13,0s-.08,0-.15,0a1.35,1.35,0,0,1-.49,0,1.08,1.08,0,0,1,.18,0M20.72,39a.86.86,0,0,1,0-.16c0,.05,0,.09,0,.16m.06,3.41a.34.34,0,0,1,0-.14.61.61,0,0,1,0,.14m-2.16,2.91h0c0,.1,0,.06,0,0m0-.2s0,0,0,0v.11a.34.34,0,0,0,0-.1m1.13-8.86h0c-.09,0-.07,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3891",
    "data-name": "Path 3891",
    className: "cls-3",
    d: "M20.76,42.06a0,0,0,0,1,0,0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3892",
    "data-name": "Path 3892",
    className: "cls-3",
    d: "M23.28,37.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3893",
    "data-name": "Path 3893",
    className: "cls-3",
    d: "M19.42,47.62h.08s0,0-.08,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3894",
    "data-name": "Path 3894",
    className: "cls-3",
    d: "M18.6,44.08v.13a.37.37,0,0,1,0-.11s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3895",
    "data-name": "Path 3895",
    className: "cls-3",
    d: "M18.76,43V42.9h0c0,.08,0,.14,0,.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3896",
    "data-name": "Path 3896",
    className: "cls-3",
    d: "M18.69,44s0-.09,0-.18v0s0,.07,0,.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3897",
    "data-name": "Path 3897",
    className: "cls-3",
    d: "M18.69,43.76v-.08s0,0,0,.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3898",
    "data-name": "Path 3898",
    className: "cls-3",
    d: "M18.63,44.89s0,0,0,0,0,.29,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3899",
    "data-name": "Path 3899",
    className: "cls-3",
    d: "M18.75,43.89l0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3900",
    "data-name": "Path 3900",
    className: "cls-3",
    d: "M18.73,44.6v-.14a.1.1,0,0,1,0,0v.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3901",
    "data-name": "Path 3901",
    className: "cls-3",
    d: "M18.73,44.42v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3902",
    "data-name": "Path 3902",
    className: "cls-3",
    d: "M18.76,44.09v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3903",
    "data-name": "Path 3903",
    className: "cls-3",
    d: "M18.73,46.15v.16s0,0,0-.08,0-.1,0-.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3904",
    "data-name": "Path 3904",
    className: "cls-3",
    d: "M18.8,45.68a.64.64,0,0,0,0,.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3905",
    "data-name": "Path 3905",
    className: "cls-3",
    d: "M18.81,46.14s0,.23,0,0c0,0,0-.18,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3906",
    "data-name": "Path 3906",
    className: "cls-3",
    d: "M19.67,47.7h0v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3907",
    "data-name": "Path 3907",
    className: "cls-3",
    d: "M20.71,46.69c0,.19,0,0,0,.21s0-.14,0-.09c0-.11,0-.17,0-.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3908",
    "data-name": "Path 3908",
    className: "cls-3",
    d: "M20.75,46.81v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3909",
    "data-name": "Path 3909",
    className: "cls-3",
    d: "M18.15,38.5h.12l-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3910",
    "data-name": "Path 3910",
    className: "cls-3",
    d: "M18.38,38.46l0,0,.07,0h-.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3911",
    "data-name": "Path 3911",
    className: "cls-3",
    d: "M20.67,39.37h0a.34.34,0,0,0,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3912",
    "data-name": "Path 3912",
    className: "cls-3",
    d: "M21.6,38.22h0l.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3913",
    "data-name": "Path 3913",
    className: "cls-3",
    d: "M23,38.18h-.18c.13,0,.2,0,.18,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3914",
    "data-name": "Path 3914",
    className: "cls-3",
    d: "M24.65,40.72c0-1.7.22-2.62.82-3.35a4.07,4.07,0,0,1,5.76.07l.11.12A5.36,5.36,0,0,1,32,40.72v2.66c0,1.7-.22,2.62-.82,3.35a4.07,4.07,0,0,1-5.76-.07l-.11-.12a5.42,5.42,0,0,1-.67-3.15Zm5.27.21c0-2.07-.4-2.75-1.58-2.75s-1.59.68-1.59,2.75v2.25c0,2.06.39,2.74,1.57,2.74s1.6-.68,1.6-2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3915",
    "data-name": "Path 3915",
    className: "cls-3",
    d: "M24.65,40.72c0-1.7.22-2.62.82-3.35a4.07,4.07,0,0,1,5.76.07l.11.12A5.36,5.36,0,0,1,32,40.72v2.66c0,1.7-.22,2.62-.82,3.35a4.07,4.07,0,0,1-5.76-.07l-.11-.12a5.42,5.42,0,0,1-.67-3.15Zm5.27.21c0-2.07-.4-2.75-1.58-2.75s-1.59.68-1.59,2.75v2.25c0,2.06.39,2.74,1.57,2.74s1.6-.68,1.6-2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3916",
    "data-name": "Path 3916",
    className: "cls-3",
    d: "M29.79,41s0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3917",
    "data-name": "Path 3917",
    className: "cls-3",
    d: "M29.84,41.41h0l0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3918",
    "data-name": "Path 3918",
    className: "cls-3",
    d: "M29.84,41.85s0-.16,0-.24h0l0,0a2.53,2.53,0,0,1,0,.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3919",
    "data-name": "Path 3919",
    className: "cls-3",
    d: "M29.76,42.08s0,.05,0,0h0v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3920",
    "data-name": "Path 3920",
    className: "cls-3",
    d: "M29.76,42s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3921",
    "data-name": "Path 3921",
    className: "cls-3",
    d: "M29.77,42.25v-.06s0,.06,0,0,0,.05,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3922",
    "data-name": "Path 3922",
    className: "cls-3",
    d: "M29.8,42.3v0a0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3923",
    "data-name": "Path 3923",
    className: "cls-3",
    d: "M29.78,42.21v.06s0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3924",
    "data-name": "Path 3924",
    className: "cls-3",
    d: "M29.79,42.17s0-.08,0,0c0-.11,0-.1,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3925",
    "data-name": "Path 3925",
    className: "cls-3",
    d: "M29.88,41.87v-.08s0,.08,0,.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3926",
    "data-name": "Path 3926",
    className: "cls-3",
    d: "M29.75,42.62l0,0v-.05s0,.07,0,.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3927",
    "data-name": "Path 3927",
    className: "cls-3",
    d: "M29.78,42.6l0,.07c0-.06,0-.08,0-.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3928",
    "data-name": "Path 3928",
    className: "cls-3",
    d: "M29.84,42.32l0-.11,0,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3929",
    "data-name": "Path 3929",
    className: "cls-3",
    d: "M29.75,42.88l0,0,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3930",
    "data-name": "Path 3930",
    className: "cls-3",
    d: "M29.75,43.05s0,0,0,0a.27.27,0,0,0,0,.12.28.28,0,0,1,0-.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3931",
    "data-name": "Path 3931",
    className: "cls-3",
    d: "M29.76,43.23a.43.43,0,0,0,0,0,.07.07,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3932",
    "data-name": "Path 3932",
    className: "cls-3",
    d: "M29.79,42.78a.08.08,0,0,0,0,0l0,0v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3935",
    "data-name": "Path 3935",
    className: "cls-3",
    d: "M29.82,42.49s0,.12,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3936",
    "data-name": "Path 3936",
    className: "cls-3",
    d: "M29.82,42.74v-.07s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3937",
    "data-name": "Path 3937",
    className: "cls-3",
    d: "M29.83,42.77v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3938",
    "data-name": "Path 3938",
    className: "cls-3",
    d: "M29.79,43.11a.38.38,0,0,1,0,.1s0-.08,0-.12,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3941",
    "data-name": "Path 3941",
    className: "cls-3",
    d: "M29.81,43.09a.15.15,0,0,0,0-.07v.07h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3942",
    "data-name": "Path 3942",
    className: "cls-3",
    d: "M29.77,43.34a.08.08,0,0,1,0-.05.11.11,0,0,0,0,.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3944",
    "data-name": "Path 3944",
    className: "cls-3",
    d: "M29.78,43s0,0,0,0V43h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3945",
    "data-name": "Path 3945",
    className: "cls-3",
    d: "M29.92,43.7s0-.08,0-.15-.08,0-.12,0,0,0,0,.07,0-.15.05-.09,0,.07,0,.12,0,.12.07.1V43.7s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3946",
    "data-name": "Path 3946",
    className: "cls-3",
    d: "M29.8,43.45v0l0,.1a.14.14,0,0,0,0,.06.61.61,0,0,1,0-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3947",
    "data-name": "Path 3947",
    className: "cls-3",
    d: "M29.8,43.29s0,.09.05.05,0-.06,0-.11c0,.13,0,0,0,.06v-.07s0,0,0,.07h0s0,0,0,0h0v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3948",
    "data-name": "Path 3948",
    className: "cls-3",
    d: "M29.91,42.6h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3949",
    "data-name": "Path 3949",
    className: "cls-3",
    d: "M29.9,42.66a0,0,0,0,1,0,0s0,0,0,0,0-.07,0,0h0a.56.56,0,0,1,0,.12.18.18,0,0,0,.05-.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3950",
    "data-name": "Path 3950",
    className: "cls-3",
    d: "M29.85,43v.11l0-.05h0c0-.07,0-.06,0-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3951",
    "data-name": "Path 3951",
    className: "cls-3",
    d: "M29.78,43.6l0,0,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3952",
    "data-name": "Path 3952",
    className: "cls-3",
    d: "M29.77,43.74h0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3953",
    "data-name": "Path 3953",
    className: "cls-3",
    d: "M26.63,41.56v0a0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3954",
    "data-name": "Path 3954",
    className: "cls-3",
    d: "M26.63,41.8h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3955",
    "data-name": "Path 3955",
    className: "cls-3",
    d: "M27.81,45.73s-.07-.07-.07,0v0l.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3956",
    "data-name": "Path 3956",
    className: "cls-3",
    d: "M26.76,43.78v0l0,0v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3957",
    "data-name": "Path 3957",
    className: "cls-3",
    d: "M26.67,43.75v-.07a.2.2,0,0,0,0,.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3958",
    "data-name": "Path 3958",
    className: "cls-3",
    d: "M26.62,40.23l0,0c0,.07,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3959",
    "data-name": "Path 3959",
    className: "cls-3",
    d: "M29.51,45.17a.35.35,0,0,0-.05.08s.06-.06.05-.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3960",
    "data-name": "Path 3960",
    className: "cls-3",
    d: "M26.86,41.65a0,0,0,0,0,0,0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3961",
    "data-name": "Path 3961",
    className: "cls-3",
    d: "M29.4,45.34h0a.35.35,0,0,1,.05-.08.13.13,0,0,0-.06.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3963",
    "data-name": "Path 3963",
    className: "cls-3",
    d: "M29.81,40.52v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3965",
    "data-name": "Path 3965",
    className: "cls-3",
    d: "M29.82,44.18s0,0,0,0v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3967",
    "data-name": "Path 3967",
    className: "cls-3",
    d: "M29.74,44.27l0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3968",
    "data-name": "Path 3968",
    className: "cls-3",
    d: "M29.72,44.28v0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3969",
    "data-name": "Path 3969",
    className: "cls-3",
    d: "M29.71,44.36v0h0v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3970",
    "data-name": "Path 3970",
    className: "cls-3",
    d: "M27.6,38.24h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3972",
    "data-name": "Path 3972",
    className: "cls-3",
    d: "M27,45.35a.14.14,0,0,1,.08.09l0-.06-.11,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3973",
    "data-name": "Path 3973",
    className: "cls-3",
    d: "M26.62,41l0,.07c0-.1,0-.16-.05-.09s0,.31.08.32l0,0v0c0,.1.05.08,0,.21s0,.08,0,0l0,.1s0,0,0,0v.15h0l0,.1s0,0,0,0l0,.09s0,0,0-.1,0,.07,0,.24V42c0,.05,0,.12-.05.21s.06-.18.08-.09a.21.21,0,0,0,0,.11s0,0,0,.11h0c0,.07,0,.06,0,.1a.13.13,0,0,1-.05.11c0,.12,0-.08.05.06a.88.88,0,0,0,0,.28c0,.07,0,0,0,0l0,.06s0,0,0,0,0,0,0,.09-.05.16,0,.26,0,0,0,0a1.05,1.05,0,0,0,.06.24l0,.1c0-.08.06,0,.09.1a.25.25,0,0,0,0-.07l0,.13,0,0v0s0,0-.05,0l0,0s0-.06-.06-.05a.06.06,0,0,0,0,0h0s0,0,0,0l0,0h0a.91.91,0,0,0,0,.17,1.72,1.72,0,0,1,.14.4s0,0-.07,0,0-.15,0-.25c0,.05,0,0,0,0l0,.17s0,0,0,.09.06.12.09.19,0,0,0-.09c0,.1.08.11.07.21s0,0,0,0,.05.17,0,.14v0c0,.14.14.42.2.41H27a.57.57,0,0,0,.13.08l.12.07s-.06.13-.15,0a.38.38,0,0,0,.1.12s0-.08,0-.06a.89.89,0,0,0,.08.17s0-.05.09,0,0,.05-.05,0l.14,0s0,0,0,.07.11.06.15.07l0,0a.23.23,0,0,0,.16,0h.16s-.07.06,0,.08a1.17,1.17,0,0,1,.31-.12l0,0,.1,0-.16.09-.19.06c.06,0,0,0,.1,0s-.05,0-.08,0a.76.76,0,0,0,.21,0s.16,0,.15,0l-.22,0s.13-.09.27-.08,0,.06,0,.07l.15,0-.06,0c.08,0,.12,0,.22,0s.11,0,.11,0a.16.16,0,0,1-.06-.18h.21c.06,0-.06.09,0,.1s0,0,0,0,0,0,.07,0,.15-.06,0,0l.16-.07s0-.1.07-.16h0a1.58,1.58,0,0,0,.15-.12.76.76,0,0,0,.11-.14s.06-.06.06,0a.29.29,0,0,1,0-.09c.06-.06,0,.09,0,.05a1.2,1.2,0,0,1,0-.17s-.06.12-.08.18,0-.13,0-.27,0,0,0,0a.25.25,0,0,0,0-.19.41.41,0,0,1,0-.16c0-.06.05,0,.08,0s-.05.13-.07.19l0-.07a.23.23,0,0,1,0,.12.65.65,0,0,0,.07-.21c0-.1.05-.21.06-.3s0-.08,0-.06v0c0,.05,0-.1,0,0a.53.53,0,0,1,0-.25l0,0a.15.15,0,0,0,0,.09s.06-.14,0-.19l0,.07a1.09,1.09,0,0,1,0-.26s0,0,0,.08,0,.22,0,.14,0,.11-.07.19,0,0,0,0v0h0s0,0,0,0a1.28,1.28,0,0,1,0,.19s0,0,0,0,0,0,0,.06-.06.1-.06,0v.09a.49.49,0,0,0-.05.16s0,.11,0,.07a.68.68,0,0,1,0,.14h0a.79.79,0,0,1-.18.38.41.41,0,0,1-.1.13h0s-.14.08-.14.12a.27.27,0,0,0-.15.05.67.67,0,0,1-.18.07v0l-.21.06v0H28.3s0,0,.06,0a.45.45,0,0,0-.23,0,.5.5,0,0,1-.21,0l-.07,0h0l0,0,0,0-.1,0v0h0s0,0,0,0h-.05s-.1,0-.11-.08a.18.18,0,0,1-.1,0s-.08,0-.1,0h0l-.08-.08v0l-.09,0c0-.06,0-.08,0-.05a.75.75,0,0,1-.15-.16h0s-.07-.08-.06-.12a2.86,2.86,0,0,0-.07-.28,1.18,1.18,0,0,1,0-.2,1.23,1.23,0,0,1,0-.2c-.05.06,0-.11,0-.12s0,0,0,0c0-.12,0-.18,0-.26s0,0,0,0,0,0,0-.05,0,0,0,0-.06-.13-.1-.14a.14.14,0,0,0,0-.14s0-.06,0,0,0-.27,0-.27v-.25s0-.08,0-.16h0c0-.18,0-.08,0-.25h0c-.06,0,0-.16,0-.26l0,0c0-.05.07-.15.08-.21s0,0,0,0c0-.15,0,0,0-.13s.05,0,.05,0-.06-.21,0-.32,0,0,0,0,.05-.22,0-.29h0a1.57,1.57,0,0,0,0-.23c.08-.06,0-.37,0-.37v-.19h0a.34.34,0,0,0,0-.2s0,0,0,0a.74.74,0,0,0,0-.33h0a3.68,3.68,0,0,0,.05-.42v0a1.59,1.59,0,0,1,.06-.3c0-.09,0-.17,0-.21v-.13c0,.16,0,0-.06,0s.07-.15.05-.07h0s0,0,.06-.08,0-.1.05-.09a1.14,1.14,0,0,1,.23-.38,1,1,0,0,1,.33-.25l-.05,0,.09,0s0,0,0,0,.1-.06.1-.06,0,0,0,0l.05,0h0a.23.23,0,0,1,.12-.06c.05,0,0,0,.05,0h.16l-.06,0c.06,0,.12,0,.06,0a1.32,1.32,0,0,0,.28,0h.16l.09,0a.54.54,0,0,1,.25,0s0,0,.05,0,.14.08.16.16,0,0,.08,0,.09.06.07,0,0,0,0,.07a1,1,0,0,1,.3.44s0,0,0,0v.12s.07,0,.06.1,0,0,0,0a3.65,3.65,0,0,1,.12,1.23c0-.05,0,0,0,0s0,0,0,0a1.1,1.1,0,0,1,0,.18s0,.18,0,.2V40.8c0,.07.08-.1.13-.1s.06-.22,0-.36,0,0,0,0a.2.2,0,0,1,0-.15h0c0-.22,0-.32,0-.57l0,0v-.1c-.05,0,0,.15,0,.1s-.06-.37,0-.42,0,0,0,0v0h0c0-.06,0-.09,0-.1s0,0,0,0a.9.9,0,0,0-.08-.21.19.19,0,0,1,0,.08,1.3,1.3,0,0,0-.08-.17.54.54,0,0,0-.1-.16.87.87,0,0,0-.27-.27v0l-.13-.09-.15-.08h0a.32.32,0,0,1-.14,0s-.08-.05,0-.05c-.18,0-.09,0-.22,0l0,0a.33.33,0,0,1-.14,0c.08,0-.06,0,0,0a.89.89,0,0,0-.23,0,.16.16,0,0,1-.15,0c-.08.06.17,0,.12,0s-.07,0-.13,0a.57.57,0,0,0-.26,0h0c-.06,0-.11.05-.19,0s-.09,0-.09.07l.13,0a1.26,1.26,0,0,1-.26.13l.06-.05s-.06,0-.11.05,0-.05.09-.07l.15-.07c-.05,0-.15.08-.13,0s-.15.06-.22.16v0l-.06.07,0-.06-.11.08a.41.41,0,0,0-.1.09c.13-.14.05,0,.12-.06-.13.19-.14,0-.28.27,0,0,.09-.1.07,0a.27.27,0,0,1-.1.11c-.07.15,0,0,0,.06s0,.07,0,.14h0c-.07.17,0,.06,0,.21,0,0,0,0,0-.08s0,.06,0,.09l0,0a.52.52,0,0,1,0,.21s0,0,0,.1,0,0,0,.07a.08.08,0,0,1,0-.1s0,0,0,0a1.16,1.16,0,0,0,0,.18.08.08,0,0,1,0,0v.16s0,0,0,0a.34.34,0,0,1,0,.1s0,0,0-.08v.16s0,.07,0,.05a1.71,1.71,0,0,1,0,.32.06.06,0,0,1,0,0,1.16,1.16,0,0,0,0,.32l0,.07c0,.1.05-.09.06.07s0,0,0,.08a.46.46,0,0,1,0,.26V41m0,1.18s0-.07,0-.08,0,0,0,.08M26.7,44a.09.09,0,0,1,0-.07.09.09,0,0,1,0,.07m3,.7h0s0,0,0,0m0-.1h0a.06.06,0,0,1,0,.06s0,0,0,0m-1.75-6.25h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3974",
    "data-name": "Path 3974",
    className: "cls-3",
    d: "M26.68,43.75h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3976",
    "data-name": "Path 3976",
    className: "cls-3",
    d: "M29,45.94h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3977",
    "data-name": "Path 3977",
    className: "cls-3",
    d: "M29.74,44v.06a.13.13,0,0,1,0-.06s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3978",
    "data-name": "Path 3978",
    className: "cls-3",
    d: "M29.91,43.43v0h0s0,.07,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3979",
    "data-name": "Path 3979",
    className: "cls-3",
    d: "M29.82,44s0-.05,0-.09h0s0,0,0,.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3980",
    "data-name": "Path 3980",
    className: "cls-3",
    d: "M29.84,43.85V43.8s0,0,0,.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3981",
    "data-name": "Path 3981",
    className: "cls-3",
    d: "M29.72,44.43s0,0,0,0,0,.15,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3982",
    "data-name": "Path 3982",
    className: "cls-3",
    d: "M29.89,43.92h0l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3983",
    "data-name": "Path 3983",
    className: "cls-3",
    d: "M29.84,44.29l0-.08s0,0,0,0,0,.1,0,.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3984",
    "data-name": "Path 3984",
    className: "cls-3",
    d: "M29.85,44.19v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3985",
    "data-name": "Path 3985",
    className: "cls-3",
    d: "M29.89,44v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3986",
    "data-name": "Path 3986",
    className: "cls-3",
    d: "M29.66,45.08l0,.08s0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3987",
    "data-name": "Path 3987",
    className: "cls-3",
    d: "M29.8,44.86l0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3988",
    "data-name": "Path 3988",
    className: "cls-3",
    d: "M29.73,45.1s0,.12,0,0,0-.09,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3989",
    "data-name": "Path 3989",
    className: "cls-3",
    d: "M28.8,45.89h0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3990",
    "data-name": "Path 3990",
    className: "cls-3",
    d: "M27.66,46c.1,0,0,0,.13,0s-.08,0-.05,0-.09,0-.08,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3991",
    "data-name": "Path 3991",
    className: "cls-3",
    d: "M27.74,46h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3992",
    "data-name": "Path 3992",
    className: "cls-3",
    d: "M29.79,40.75v.07l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3993",
    "data-name": "Path 3993",
    className: "cls-3",
    d: "M29.83,40.87l0,0,0,0a.06.06,0,0,1,0-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3994",
    "data-name": "Path 3994",
    className: "cls-3",
    d: "M26.57,42.33h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3995",
    "data-name": "Path 3995",
    className: "cls-3",
    d: "M26.6,41.47v0l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3996",
    "data-name": "Path 3996",
    className: "cls-3",
    d: "M26.56,40.75v.1c0-.07,0-.1,0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3997",
    "data-name": "Path 3997",
    className: "cls-3",
    d: "M24.53,40.76s0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3998",
    "data-name": "Path 3998",
    className: "cls-3",
    d: "M24.58,41.54h0l0,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3999",
    "data-name": "Path 3999",
    className: "cls-3",
    d: "M24.58,42.28a2.67,2.67,0,0,0,0-.4v0l0-.06c0,.16,0,.36,0,.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4000",
    "data-name": "Path 4000",
    className: "cls-3",
    d: "M24.5,42.67s0,.09,0-.09v.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4001",
    "data-name": "Path 4001",
    className: "cls-3",
    d: "M24.5,42.6c0-.08,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4002",
    "data-name": "Path 4002",
    className: "cls-3",
    d: "M24.51,43v-.1s0,.12,0,.08,0,.08,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4003",
    "data-name": "Path 4003",
    className: "cls-3",
    d: "M24.54,43.05v0a.11.11,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4004",
    "data-name": "Path 4004",
    className: "cls-3",
    d: "M24.52,42.88V43s0,0,0,0,0,0,0-.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4005",
    "data-name": "Path 4005",
    className: "cls-3",
    d: "M24.52,42.82c0-.06,0-.13,0,0,0-.2,0-.16,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4006",
    "data-name": "Path 4006",
    className: "cls-3",
    d: "M24.62,42.32v-.15a.72.72,0,0,0,0,.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4007",
    "data-name": "Path 4007",
    className: "cls-3",
    d: "M24.49,43.59s0,0,0,0v-.08a.33.33,0,0,1,0,.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4008",
    "data-name": "Path 4008",
    className: "cls-3",
    d: "M24.52,43.55l0,.11c0-.1,0-.12,0-.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4009",
    "data-name": "Path 4009",
    className: "cls-3",
    d: "M24.58,43.07l0-.19,0,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4010",
    "data-name": "Path 4010",
    className: "cls-3",
    d: "M24.5,44l0-.07,0,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4011",
    "data-name": "Path 4011",
    className: "cls-3",
    d: "M24.52,44.31s0,.07,0,0a.65.65,0,0,0,0,.2.81.81,0,0,1,0-.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4012",
    "data-name": "Path 4012",
    className: "cls-3",
    d: "M24.56,44.64l0-.1,0,.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4013",
    "data-name": "Path 4013",
    className: "cls-3",
    d: "M24.54,43.85a.15.15,0,0,0,0,.09l0,0v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4015",
    "data-name": "Path 4015",
    className: "cls-3",
    d: "M24.54,43.84h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4016",
    "data-name": "Path 4016",
    className: "cls-3",
    d: "M24.56,43.36c0,.07,0,.2,0,.07s0,0,0-.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4017",
    "data-name": "Path 4017",
    className: "cls-3",
    d: "M24.56,43.79v-.12s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4018",
    "data-name": "Path 4018",
    className: "cls-3",
    d: "M24.57,43.85v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4019",
    "data-name": "Path 4019",
    className: "cls-3",
    d: "M24.56,44.43l0,.17a1.49,1.49,0,0,0,0-.21s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4022",
    "data-name": "Path 4022",
    className: "cls-3",
    d: "M24.58,44.38a.36.36,0,0,0,0-.11s0,.08,0,.12,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4023",
    "data-name": "Path 4023",
    className: "cls-3",
    d: "M24.59,44.81v-.09a.14.14,0,0,0,0,.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4025",
    "data-name": "Path 4025",
    className: "cls-3",
    d: "M24.55,44.2a.19.19,0,0,0,0,.07l0-.09v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4026",
    "data-name": "Path 4026",
    className: "cls-3",
    d: "M24.85,45.39a.43.43,0,0,1-.07-.25c0-.11-.08,0-.1.08s0,0,.06.12c0-.05,0-.27,0-.17a.44.44,0,0,1,0,.2c0-.06.08.19.11.15l0-.13s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4027",
    "data-name": "Path 4027",
    className: "cls-3",
    d: "M24.64,45v.12l0,.1a2,2,0,0,0,0-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4028",
    "data-name": "Path 4028",
    className: "cls-3",
    d: "M24.6,44.73s0,.15.07.07a.69.69,0,0,0-.05-.18c0,.23,0-.06,0,.1a.49.49,0,0,1,0-.12v.12h0a1.57,1.57,0,0,0,0,.23,2,2,0,0,1,0-.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4029",
    "data-name": "Path 4029",
    className: "cls-3",
    d: "M24.65,43.56h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4030",
    "data-name": "Path 4030",
    className: "cls-3",
    d: "M24.64,43.65a.14.14,0,0,1,0-.09c0-.05,0,0,0,0s0-.11,0,0v0a1.77,1.77,0,0,1,0,.2.31.31,0,0,0,.05-.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4031",
    "data-name": "Path 4031",
    className: "cls-3",
    d: "M24.61,44.19l0,.2v-.1h0c0-.11,0-.08,0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4032",
    "data-name": "Path 4032",
    className: "cls-3",
    d: "M24.67,45.26l0,0,.06.1,0-.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4033",
    "data-name": "Path 4033",
    className: "cls-3",
    d: "M24.73,45.51h0l0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4034",
    "data-name": "Path 4034",
    className: "cls-3",
    d: "M31.89,40.64v0a.07.07,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4035",
    "data-name": "Path 4035",
    className: "cls-3",
    d: "M31.89,41.05h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4036",
    "data-name": "Path 4036",
    className: "cls-3",
    d: "M29.86,47.82c.08,0,.19,0,.17,0h0l-.13,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4037",
    "data-name": "Path 4037",
    className: "cls-3",
    d: "M32,44.4v0l0,0V44.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4038",
    "data-name": "Path 4038",
    className: "cls-3",
    d: "M31.88,44.34l0-.1a.41.41,0,0,0,0,.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4039",
    "data-name": "Path 4039",
    className: "cls-3",
    d: "M31.62,38.47l-.05,0c0,.09,0,0,.05,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4040",
    "data-name": "Path 4040",
    className: "cls-3",
    d: "M26.27,47.59l.16.09c-.08,0-.13-.1-.16-.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4041",
    "data-name": "Path 4041",
    className: "cls-3",
    d: "M32.12,40.8a.12.12,0,0,0,0,0s0,.06,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4042",
    "data-name": "Path 4042",
    className: "cls-3",
    d: "M26.63,47.76l0,0-.16-.06a.5.5,0,0,0,.2.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4043",
    "data-name": "Path 4043",
    className: "cls-3",
    d: "M25.31,37.82v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4044",
    "data-name": "Path 4044",
    className: "cls-3",
    d: "M24.57,40v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4045",
    "data-name": "Path 4045",
    className: "cls-3",
    d: "M25.11,46.48s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4046",
    "data-name": "Path 4046",
    className: "cls-3",
    d: "M25.06,46.2h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4047",
    "data-name": "Path 4047",
    className: "cls-3",
    d: "M27.18,47.78h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4048",
    "data-name": "Path 4048",
    className: "cls-3",
    d: "M25.08,46.4l0,.07a.13.13,0,0,0,0-.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4049",
    "data-name": "Path 4049",
    className: "cls-3",
    d: "M25.08,46.41l0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4050",
    "data-name": "Path 4050",
    className: "cls-3",
    d: "M25.16,46.54a.35.35,0,0,1-.05-.08v0l0,.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4052",
    "data-name": "Path 4052",
    className: "cls-3",
    d: "M30.91,46.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4053",
    "data-name": "Path 4053",
    className: "cls-3",
    d: "M31,46.76a.33.33,0,0,1-.11.15H31a.77.77,0,0,0,0-.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4054",
    "data-name": "Path 4054",
    className: "cls-3",
    d: "M31.85,39.67l0,.14c0-.16,0-.27-.06-.15s0,.51.11.52v0c0,.17.05.12,0,.34s0,.13,0,.08l0,.17s0,0,0,0v.26h0l0,.17c0,.06,0,0,0,0l0,.14c0,.06,0-.06,0-.16-.07.14,0,.12,0,.42v-.14a2,2,0,0,0,0,.35s.06-.31.07-.15a1.09,1.09,0,0,0,0,.18s0,.09,0,.19h0a.85.85,0,0,0,0,.17.23.23,0,0,1,0,.18c0,.2,0-.14,0,.1a2.57,2.57,0,0,0,0,.48c0,.12,0,0,0,0l0,.1s0,0,0,0,0,0,0,.14-.05.28,0,.45,0,0,0,0a3.63,3.63,0,0,0,0,.39l0,.16c0-.12.06,0,.07.17a.93.93,0,0,0,0-.1v.21s0,0,0,0v0c0,.08,0,0,0,0l0-.08c0-.05,0-.1-.05-.09v.12l0,0,0,0-.05.27a2.66,2.66,0,0,1,0,.69c0-.09,0,0-.07,0a1.4,1.4,0,0,0,.07-.4c0,.08,0,.06,0,0a2.83,2.83,0,0,1,0,.29s0,0-.07.12,0,0,0,.11l-.07.22s0,0,0-.16c-.09.13,0,.21-.1.34a.25.25,0,0,0,0-.07c0,.09-.12.26-.11.21l0,0-.22.38a1.35,1.35,0,0,0-.15.26.19.19,0,0,1,0-.07,2.83,2.83,0,0,1-.17.4s-.16,0,0-.16a1.29,1.29,0,0,0-.17.16s.1,0,.07,0l-.24.12c.05,0,0,.06,0,.11s0,0,0-.07l-.15.17s0-.05-.07,0l-.22.11.09,0a.67.67,0,0,0-.21.13.57.57,0,0,1-.22.11s.05-.09-.07-.06a1,1,0,0,1-.44.25h-.05l-.17,0c.11,0,.39-.18.53-.26l-.16,0c-.05,0,.07,0,.11,0l-.32,0s-.24.06-.23.08l.35-.07s-.19.13-.42.14c-.06,0,0-.07,0-.08a1,1,0,0,1-.24,0l.1,0c-.13,0-.21,0-.37,0s-.15,0-.16,0,.1.16,0,.19l-.35-.07c-.08,0,.14-.07.07-.1l-.08,0c-.05,0,0,0-.1,0s-.25,0-.06,0l-.26,0s-.14.06-.26,0l0,0a3.06,3.06,0,0,1-.58-.2s-.11-.07-.06-.06l-.13,0c-.11-.09.14.06.06,0s0,0-.1,0l-.16-.07s.05,0,.11.08l.18.07s-.2,0-.42-.11,0-.08-.08-.09l-.28-.19a.67.67,0,0,1-.21-.2c-.06-.11,0,0,0-.07s.15.19.23.26l-.09-.1a1.07,1.07,0,0,1,.16.14l-.26-.28a3.08,3.08,0,0,1-.3-.41s-.08-.1-.07-.07l.05.08c0,.08-.12-.13-.07,0a1.2,1.2,0,0,1-.22-.36l0,0a.2.2,0,0,0,.06.14s-.07-.25-.14-.31L25,46a1.38,1.38,0,0,1-.18-.39c0,.08,0,0,0,.15,0,0,0,0,.07.13s.06.16.06.08a1.78,1.78,0,0,0,.09.33s0,0,.05.06l0,0h0s0,0,0-.06a.64.64,0,0,1,.1.13l.1.14c0,.06,0,0,0,0l.07.07s.09.19,0,0a.64.64,0,0,0,.1.13.91.91,0,0,0,.2.24c.05.06.15.11.1.08a1.49,1.49,0,0,0,.2.15h0a5.3,5.3,0,0,0,.7.4l.3.1,0,0a2.09,2.09,0,0,0,.36.08,2.32,2.32,0,0,0,.7.1v0a1.89,1.89,0,0,0,.41,0v0c.13,0,.35,0,.57,0h-.11a3.51,3.51,0,0,0,.78-.12l.14,0h0l.17-.07,0,0h0c.07,0,.05,0,0,0l.08,0c.06,0,.16-.08.24-.08s.29-.19.29-.25,0,0,0,0a.55.55,0,0,0,.17-.14h0a1.1,1.1,0,0,0,.09-.14c.09,0,.12-.08.07,0a1.94,1.94,0,0,0,.23-.33v0a1.27,1.27,0,0,1,.13-.19,1.57,1.57,0,0,0,.28-.44,4.77,4.77,0,0,0,.26-.66c-.07.07.07-.18,0-.21s0-.08,0,0a1.82,1.82,0,0,0,.06-.46s0,0,0,0a.25.25,0,0,1,0-.09s0,0,0,.06c0-.21,0-.24-.06-.26a.39.39,0,0,0,0-.24s0-.1,0,0a1.77,1.77,0,0,0,0-.46.28.28,0,0,0,0-.13c0-.17,0-.18,0-.35v.05c0-.07,0-.14,0-.27h0a3.1,3.1,0,0,1,0-.43h0c-.05,0,0-.26,0-.44v.07c0-.1.07-.27.08-.36s0,0,0,.06c0-.25,0,0,0-.22,0,0,0,0,0-.08a4.89,4.89,0,0,1,0-.54s0,.08,0,0a1.93,1.93,0,0,0,0-.48v0a2.58,2.58,0,0,0,0-.39c.09-.1-.07-.63,0-.64l0-.31h0a1,1,0,0,0-.07-.34s0,0,0,0a1.42,1.42,0,0,0-.15-.56l0,0a2.39,2.39,0,0,0-.26-.67l0,0c-.09-.14-.18-.32-.28-.46s-.19-.26-.26-.27L30.9,37c.2.2-.06,0,0,.09-.08-.07-.19-.21-.08-.12h0c.07,0-.26-.23-.24-.24a3.51,3.51,0,0,0-1.5-.56l0,0-.17,0c-.06,0-.06,0,.06,0a.41.41,0,0,0-.22,0c-.25,0,.1,0,0,0h-.08a.69.69,0,0,1-.25,0c-.1,0-.05,0-.08,0h-.29l.09,0c-.1,0-.21,0-.11,0a1.29,1.29,0,0,0-.48,0l-.45.06c-.13.05-.27.08-.43.13,0,0,.08,0-.06.06,0-.08-.27.07-.4.09.06,0,0,0-.12.09s-.15.11-.07.08c-.11.07,0,0-.11,0l-.37.31a3.23,3.23,0,0,0-.35.4s.05,0,0,0l-.14.14c0,.06,0,.08-.09.18s0,0,0,0a2.91,2.91,0,0,0-.37,1c-.08.36-.11.72-.17,1.08,0-.1,0,0,0,0s0,0,0,0,0,.2-.05.3,0,.32,0,.35v-.1c0,.13.08-.17.13-.15,0-.14.08-.37,0-.6,0,0,0,0,0,0a.57.57,0,0,1,0-.26h0a4.13,4.13,0,0,1,.19-.9l0,0a.58.58,0,0,1,.05-.14c0-.11-.06.23-.08.14a1.4,1.4,0,0,0,.13-.34.83.83,0,0,1,.16-.29c.06-.11,0,0,0-.09l0,0v0c.05-.07.08-.1.1-.1l0,.08c.07-.09.17-.27.2-.3l-.08.1a3.13,3.13,0,0,1,.36-.44,5.08,5.08,0,0,1,.43-.38h0a1.07,1.07,0,0,1,.21-.13l.23-.1h0a.61.61,0,0,1,.2-.09c-.07,0,.14,0,.05,0a1.77,1.77,0,0,0,.31-.15h.05a.47.47,0,0,1,.21-.06c-.12,0,.1,0,0,.05.31,0,.46-.09.6,0s-.27,0-.19,0,.12,0,.22,0a3,3,0,0,0,.42.06h.25c.06,0,.15,0,.17,0h-.23a1.24,1.24,0,0,1,.47,0H29a1.1,1.1,0,0,1,.18,0s-.27,0-.41,0c.06,0,.26,0,.19,0,.1-.05.24,0,.41,0v0h.13l-.1,0a1.64,1.64,0,0,1,.38.1c-.26-.07-.05-.05-.16-.09a.38.38,0,0,1,.25.09,1.15,1.15,0,0,0,.27.14c-.05,0-.17-.09-.1-.07a.78.78,0,0,1,.18.11c.22.11,0,0,.08,0s.11.05.21.1l0,0c.22.18.1,0,.29.17l-.1,0,.1.08h0a.73.73,0,0,1,.24.22s.05,0,.13.08,0,0,.07.11a.19.19,0,0,1-.11-.12l-.05,0a1.54,1.54,0,0,0,.18.23.1.1,0,0,1,0-.05l.18.19s0,0,0,0a1.13,1.13,0,0,1,.1.13s0,0-.1-.08l.14.2s0,.12,0,.1a3.82,3.82,0,0,1,.21.46l0,.06c0,.17.05.32.11.51l0,.12c0,.16,0-.16.08.1s0,.07,0,.14a1.25,1.25,0,0,1,.07.43c0-.06,0-.1,0-.16m0,2a.38.38,0,0,1,0-.15s0,.08,0,.15m0,3a.43.43,0,0,1,0-.12.5.5,0,0,1,0,.12m-6.41,2.26h0m-.11-.15h0l.07.08a.24.24,0,0,0-.06-.08m3.05-10.68h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4055",
    "data-name": "Path 4055",
    className: "cls-3",
    d: "M31.89,44.35s0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4056",
    "data-name": "Path 4056",
    className: "cls-3",
    d: "M31.62,38.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4057",
    "data-name": "Path 4057",
    className: "cls-3",
    d: "M27.9,47.78h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4058",
    "data-name": "Path 4058",
    className: "cls-3",
    d: "M24.85,46a.47.47,0,0,0,0,.1.17.17,0,0,1,0-.1s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4059",
    "data-name": "Path 4059",
    className: "cls-3",
    d: "M24.75,45a.07.07,0,0,0,0-.05h0c0,.07,0,.12,0,.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4060",
    "data-name": "Path 4060",
    className: "cls-3",
    d: "M24.89,45.83s0-.08,0-.16v0s0,.06,0,.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4061",
    "data-name": "Path 4061",
    className: "cls-3",
    d: "M24.84,45.66a.24.24,0,0,0,0-.08s0,0,0,.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4062",
    "data-name": "Path 4062",
    className: "cls-3",
    d: "M25.23,46.62s0,0-.05,0,.18.2.05,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4063",
    "data-name": "Path 4063",
    className: "cls-3",
    d: "M24.93,45.75v0l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4064",
    "data-name": "Path 4064",
    className: "cls-3",
    d: "M25.17,46.34a.61.61,0,0,1-.05-.12l0,0a.64.64,0,0,0,.08.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4065",
    "data-name": "Path 4065",
    className: "cls-3",
    d: "M25.09,46.2a.51.51,0,0,0,0-.1,1,1,0,0,0,0,.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4066",
    "data-name": "Path 4066",
    className: "cls-3",
    d: "M25,45.91v0L25,46s0-.08,0-.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4067",
    "data-name": "Path 4067",
    className: "cls-3",
    d: "M26.09,47.37l.13.07s0,0-.06,0-.08,0-.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4068",
    "data-name": "Path 4068",
    className: "cls-3",
    d: "M25.81,47.05l0,.05,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4069",
    "data-name": "Path 4069",
    className: "cls-3",
    d: "M26.13,47.29s.17.09,0,0-.13-.07,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4070",
    "data-name": "Path 4070",
    className: "cls-3",
    d: "M28.11,47.87h0v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4071",
    "data-name": "Path 4071",
    className: "cls-3",
    d: "M29.9,47.53c-.16,0,0,0-.17.07s.12,0,.08,0,.14-.06.09-.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4072",
    "data-name": "Path 4072",
    className: "cls-3",
    d: "M29.81,47.6l0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4073",
    "data-name": "Path 4073",
    className: "cls-3",
    d: "M24.53,40.42v.11l0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4074",
    "data-name": "Path 4074",
    className: "cls-3",
    d: "M24.57,40.63l0,0,0,.07v-.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4075",
    "data-name": "Path 4075",
    className: "cls-3",
    d: "M31.83,42h0a.28.28,0,0,0,0-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4076",
    "data-name": "Path 4076",
    className: "cls-3",
    d: "M31.86,40.51v0l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4077",
    "data-name": "Path 4077",
    className: "cls-3",
    d: "M31.74,39.32a.8.8,0,0,0,0,.15c0-.1,0-.17,0-.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4078",
    "data-name": "Path 4078",
    className: "cls-3",
    d: "M35.79,47.72H34.24a.28.28,0,0,1-.27-.28V36.66a.27.27,0,0,1,.27-.27h3.41a3,3,0,0,1,2.52.82,3.59,3.59,0,0,1,.7,2.51c0,1.81-.43,2.75-1.49,3.2a.27.27,0,0,0-.14.36h0l1.8,4a.27.27,0,0,1-.14.36.23.23,0,0,1-.11,0h-1.7a.27.27,0,0,1-.26-.18l-1.68-4.16a.28.28,0,0,0-.26-.17h-.55a.27.27,0,0,0-.28.27v4a.27.27,0,0,1-.27.27m1.68-6.37c1,0,1.34-.42,1.34-1.51s-.37-1.51-1.36-1.51H36.3a.28.28,0,0,0-.28.28v2.46a.28.28,0,0,0,.28.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4079",
    "data-name": "Path 4079",
    className: "cls-3",
    d: "M35.79,47.72H34.24a.28.28,0,0,1-.27-.28V36.66a.27.27,0,0,1,.27-.27h3.41a3,3,0,0,1,2.52.82,3.59,3.59,0,0,1,.7,2.51c0,1.81-.43,2.75-1.49,3.2a.27.27,0,0,0-.14.36h0l1.8,4a.27.27,0,0,1-.14.36.23.23,0,0,1-.11,0h-1.7a.27.27,0,0,1-.26-.18l-1.68-4.16a.28.28,0,0,0-.26-.17h-.55a.27.27,0,0,0-.28.27v4a.27.27,0,0,1-.27.27m1.68-6.37c1,0,1.34-.42,1.34-1.51s-.37-1.51-1.36-1.51H36.3a.28.28,0,0,0-.28.28v2.46a.28.28,0,0,0,.28.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4080",
    "data-name": "Path 4080",
    className: "cls-3",
    d: "M37.46,41.21s0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4081",
    "data-name": "Path 4081",
    className: "cls-3",
    d: "M37.21,41.26h0l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4082",
    "data-name": "Path 4082",
    className: "cls-3",
    d: "M37,41.26s.09,0,.13,0h0l0,0H37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4083",
    "data-name": "Path 4083",
    className: "cls-3",
    d: "M36.85,41.18s0,0,0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4084",
    "data-name": "Path 4084",
    className: "cls-3",
    d: "M36.87,41.19s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4085",
    "data-name": "Path 4085",
    className: "cls-3",
    d: "M36.76,41.19h0s0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4086",
    "data-name": "Path 4086",
    className: "cls-3",
    d: "M36.73,41.22h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4087",
    "data-name": "Path 4087",
    className: "cls-3",
    d: "M36.78,41.2h0s0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4088",
    "data-name": "Path 4088",
    className: "cls-3",
    d: "M36.8,41.21s0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4089",
    "data-name": "Path 4089",
    className: "cls-3",
    d: "M37,41.3h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4090",
    "data-name": "Path 4090",
    className: "cls-3",
    d: "M36.55,41.17l0,0h0l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4091",
    "data-name": "Path 4091",
    className: "cls-3",
    d: "M36.57,41.2l0,0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4092",
    "data-name": "Path 4092",
    className: "cls-3",
    d: "M36.72,41.26l.06,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4093",
    "data-name": "Path 4093",
    className: "cls-3",
    d: "M36.41,41.17h0l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4094",
    "data-name": "Path 4094",
    className: "cls-3",
    d: "M36.32,41.18s0,0,0,0,0,0,0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4095",
    "data-name": "Path 4095",
    className: "cls-3",
    d: "M36.26,41.18h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4096",
    "data-name": "Path 4096",
    className: "cls-3",
    d: "M36.47,41.21l0,0v0h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4099",
    "data-name": "Path 4099",
    className: "cls-3",
    d: "M36.63,41.24s-.07,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4100",
    "data-name": "Path 4100",
    className: "cls-3",
    d: "M36.49,41.24h0a0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4101",
    "data-name": "Path 4101",
    className: "cls-3",
    d: "M36.47,41.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4102",
    "data-name": "Path 4102",
    className: "cls-3",
    d: "M36.29,41.21h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4105",
    "data-name": "Path 4105",
    className: "cls-3",
    d: "M36.3,41.23h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4106",
    "data-name": "Path 4106",
    className: "cls-3",
    d: "M36.24,41.18v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4108",
    "data-name": "Path 4108",
    className: "cls-3",
    d: "M36.36,41.21h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4109",
    "data-name": "Path 4109",
    className: "cls-3",
    d: "M36,41.17a.08.08,0,0,1,.06.07s.07-.05.09-.09h0s0,.06,0,.05,0,0,0-.05-.05,0-.08,0l0,0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4110",
    "data-name": "Path 4110",
    className: "cls-3",
    d: "M36.19,41.19h0v0h0l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4111",
    "data-name": "Path 4111",
    className: "cls-3",
    d: "M36.24,41.21s-.05,0,0,0,0,0,0,0,0,0,0,0h0l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4112",
    "data-name": "Path 4112",
    className: "cls-3",
    d: "M36.56,41.33h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4113",
    "data-name": "Path 4113",
    className: "cls-3",
    d: "M36.53,41.32h0s0,0,0,0,0,0,0,0h0s-.06,0-.06,0a.21.21,0,0,0,0,.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4114",
    "data-name": "Path 4114",
    className: "cls-3",
    d: "M36.36,41.28H36.3l0,0v0h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4115",
    "data-name": "Path 4115",
    className: "cls-3",
    d: "M36.18,41.14h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4116",
    "data-name": "Path 4116",
    className: "cls-3",
    d: "M36.16,41.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4118",
    "data-name": "Path 4118",
    className: "cls-3",
    d: "M37.74,38.22h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4119",
    "data-name": "Path 4119",
    className: "cls-3",
    d: "M36.15,39.17s.05-.06,0-.06h0v.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4120",
    "data-name": "Path 4120",
    className: "cls-3",
    d: "M36.65,38.32h0l0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4121",
    "data-name": "Path 4121",
    className: "cls-3",
    d: "M36.67,38.23h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4122",
    "data-name": "Path 4122",
    className: "cls-3",
    d: "M38.6,38.56h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4123",
    "data-name": "Path 4123",
    className: "cls-3",
    d: "M36.14,40.32a.13.13,0,0,0,0-.06s0,.05,0,.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4124",
    "data-name": "Path 4124",
    className: "cls-3",
    d: "M37.79,38.46h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4125",
    "data-name": "Path 4125",
    className: "cls-3",
    d: "M36.15,40.19v0s0,0,0,0a0,0,0,0,0,0-.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4127",
    "data-name": "Path 4127",
    className: "cls-3",
    d: "M37.69,41.23h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4129",
    "data-name": "Path 4129",
    className: "cls-3",
    d: "M36.07,40.9h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4131",
    "data-name": "Path 4131",
    className: "cls-3",
    d: "M36.15,40.84v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4132",
    "data-name": "Path 4132",
    className: "cls-3",
    d: "M36.16,40.84h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4133",
    "data-name": "Path 4133",
    className: "cls-3",
    d: "M36.16,40.79v0h0v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4134",
    "data-name": "Path 4134",
    className: "cls-3",
    d: "M38.87,39.8h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4136",
    "data-name": "Path 4136",
    className: "cls-3",
    d: "M35.9,38.66a0,0,0,0,1,0,.06l.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4137",
    "data-name": "Path 4137",
    className: "cls-3",
    d: "M38.21,38.32l0,0c.07,0,.1,0,.07,0s-.06,0-.1,0-.1,0-.1,0l0,0h0c-.05,0-.06,0-.13,0s0,0,0,0h-.06s0,0,0,0h-.09l-.06,0s0,0,0,0h0s0,0,.06,0-.05,0-.14,0h0s-.06,0-.11,0,.1.06,0,.08h-.06s0,0-.07,0v0s0,0,0,0,0,0-.06-.05.05,0,0,0a.25.25,0,0,0-.15,0s0,0,0,0l0,0s0,0,0,0,0,0,0,0-.09,0-.15,0,0,0,0,0a.67.67,0,0,0-.12.06l0,0s0,0-.06.08l0,0-.07,0s0,0,0,0h0s0,0,0-.05l0,0s0,0,0-.06h0v0l0,0,0,0h0l-.09,0a.55.55,0,0,1-.22.1s0,0,0-.07.08,0,.13,0,0,0,0,0l-.09,0s0,0-.05,0-.09,0-.12.08,0,0,0-.05a.06.06,0,0,0-.07,0,.08.08,0,0,1,0,0s0,0,0,0-.09.08-.09.05h0a.34.34,0,0,0-.08.17.11.11,0,0,0,0,.08s0,0,0,0h-.07l.15.13s-.13,0-.15,0a.11.11,0,0,0,0,.08s.06,0,.06,0,0,0-.06.09.07,0,.07,0h-.07L36,39s0,0-.06,0,0,.07,0,.09v0c0,.08.08.08.08.16s-.08,0-.08,0,.14.09.16.16h0l0,.06-.17-.18s0,0,0,0,0,0,0,0v.11s0,.08.06.08l0-.12a.13.13,0,0,1,.09.14s-.06,0-.07,0a.11.11,0,0,1,0,.08l0,0s0,.07,0,.12,0,0,0,0a.25.25,0,0,1,.19,0l-.06.11s-.07,0-.1,0l0,0s0,0,0,0,0,.09,0,0,0,.05,0,.09S36,40,36,40h0c0,.08,0,.12,0,.2s0,0,0,0a.08.08,0,0,1,0,0s0-.05,0,0,0,.06,0,.1,0-.08,0-.11.09.06.11.13,0,0,0,0,.07.1,0,.2-.05,0-.07,0,0-.08,0-.11v0a.15.15,0,0,1,0-.07s0,.2,0,.29,0,0,0,0v0s0,0,0,0a.19.19,0,0,1,0,.13h0s0,0,0,0,0,.08,0,.11l0,0,0,.06a.08.08,0,0,1,0,0v0s0,0,0,0,0-.12,0-.08,0-.06.05-.1,0,0,0,0h0l0,0s0-.09,0-.1,0,0,0,0l0,0s0-.06,0,0v0a.12.12,0,0,0,0-.1s0-.06,0,0v-.08h0a.7.7,0,0,1,0-.25.17.17,0,0,1,0-.1h0s0-.1,0-.11,0-.17,0-.23h0a.62.62,0,0,0,0-.13h0a1.62,1.62,0,0,1,0-.18s0,0,0,0,0-.17,0-.25a0,0,0,0,1,0,0h0v0a0,0,0,0,0,0,0,.43.43,0,0,0,0-.05h0s0,0,0,0v0s0,0,0-.08,0-.1-.06-.11,0,0,0,0a.08.08,0,0,0,0-.07h0l0,0s0,0,0,0,0-.06,0-.12h0s0-.06,0-.07,0,0,.08-.1a.13.13,0,0,1,.14,0c0-.06.06,0,.06,0s0,0,0,0,.1,0,.15,0,0,0,0,0h0s0,0,0,0,.08,0,.08-.08,0,0,.08,0,0,0,0,0,.15,0,.15,0h.13s.05,0,.09,0h0c.1,0,0,0,.14,0v0c0-.05.08,0,.14,0h0s.08.07.11.08h0c.08,0,0,0,.07,0s0,0,0,.05.11-.06.16,0,0,0,0,0,.11.06.14,0h0s.1,0,.13,0,0,.05.1.05.08,0,.07,0l.09,0h0a.12.12,0,0,0,.1,0s0,0,0,0a.24.24,0,0,0,.15.09v0s0,0,0,.07a.61.61,0,0,0,.07.1h0c.08.06,0,.22.12.23l0,.05c0-.08,0,0,0,0s0,.09,0,0h0c-.05,0,0,.11,0,.12a2.64,2.64,0,0,1,0,.49l0,0v.05s0,0,0,0,0,.07,0,.07,0,0,0,0v0h0s0,0,0,.07,0,0,0,0V40l0,0s0,.07,0,0,0,.08-.05.15a.59.59,0,0,1,0,.13.22.22,0,0,1,0,.14s0,0,0,0,0,.07-.11.09,0,.12,0,.09,0,0-.05,0-.1.16-.16.23,0,0,0,0h-.07s0,0,0,0l0,0-.29.13a.61.61,0,0,1-.33,0s0,0,0,0,0,0,0,0l-.1,0s-.1,0-.1,0h0s.05.08.05.13.13,0,.2,0,0,0,0,0a.11.11,0,0,1,.08,0h0l.16,0,.16,0h0s-.08,0-.07,0,.2-.09.25-.07,0,0,0,0h0v0a0,0,0,0,1,.06,0l0,0c.05,0,.08-.09.1-.09l0,0a.82.82,0,0,0,.21-.36h0c0-.09,0-.06.06-.17h0a.09.09,0,0,1,0-.07s0,0,0,0,0-.06,0-.13h0a.08.08,0,0,1,0-.08s0,0,0,0,0-.15,0-.2,0,.09,0,.06,0,0,0-.07.07-.05.07-.14v0s0-.06,0-.1,0,0,0,0v.07s0-.08,0-.15a.05.05,0,0,1,0,0s0,0,0-.06,0,.09,0,.14,0-.09,0-.07,0-.08,0-.14h0a.06.06,0,0,1,0,0l0,0s0-.09,0-.14,0,0,0,.07.06-.07,0-.2,0,.06,0,0a.24.24,0,0,1,0-.08c0-.08,0,0,0,0s0,0,0-.07h0c0-.1-.06,0-.06-.11l0,0v0h0a.2.2,0,0,1,0-.11s0,0-.06,0,0,0,0,0,0,0,0,0h0a.21.21,0,0,0,0-.1v0l-.07-.08h0l0,0s0,0,.06,0l-.06-.07s0-.06,0-.05-.11-.08-.14-.15h0s0-.05-.06-.07a.21.21,0,0,0-.1-.06v0c-.06,0,0,.07-.07,0s0,0,0-.06a.2.2,0,0,1-.16,0l.06,0m-.68-.1s0,0,.05,0,0,0-.05,0m-1,.06h0m-.41,2.35h0s0,0,0,0m0,.06h0s0,0,0,0,0,0,0,0M38.69,40h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4138",
    "data-name": "Path 4138",
    className: "cls-3",
    d: "M36.67,38.24h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4140",
    "data-name": "Path 4140",
    className: "cls-3",
    d: "M35.92,39.79v0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4141",
    "data-name": "Path 4141",
    className: "cls-3",
    d: "M36.17,41v0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4142",
    "data-name": "Path 4142",
    className: "cls-3",
    d: "M36.13,41.28h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4143",
    "data-name": "Path 4143",
    className: "cls-3",
    d: "M36.09,41s0,0,0,0h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4144",
    "data-name": "Path 4144",
    className: "cls-3",
    d: "M36.08,41.08v0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4145",
    "data-name": "Path 4145",
    className: "cls-3",
    d: "M36.14,40.76s0,0,0,0,0-.09,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4146",
    "data-name": "Path 4146",
    className: "cls-3",
    d: "M36,41.05h0l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4147",
    "data-name": "Path 4147",
    className: "cls-3",
    d: "M36,40.84v0s0,0,0,0,0-.06,0-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4148",
    "data-name": "Path 4148",
    className: "cls-3",
    d: "M36,40.9v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4149",
    "data-name": "Path 4149",
    className: "cls-3",
    d: "M36,41h0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4150",
    "data-name": "Path 4150",
    className: "cls-3",
    d: "M36.05,40.39v0s0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4151",
    "data-name": "Path 4151",
    className: "cls-3",
    d: "M36,40.54s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4152",
    "data-name": "Path 4152",
    className: "cls-3",
    d: "M36,40.4s0-.06,0,0,0,.05,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4153",
    "data-name": "Path 4153",
    className: "cls-3",
    d: "M36,39.72v0h.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4154",
    "data-name": "Path 4154",
    className: "cls-3",
    d: "M35.88,39.12c0,.06,0,0,0,.07s0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4155",
    "data-name": "Path 4155",
    className: "cls-3",
    d: "M35.92,39.16v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4156",
    "data-name": "Path 4156",
    className: "cls-3",
    d: "M37.57,41.21h0l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4157",
    "data-name": "Path 4157",
    className: "cls-3",
    d: "M37.5,41.25v0l0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4158",
    "data-name": "Path 4158",
    className: "cls-3",
    d: "M37.44,38.15h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4159",
    "data-name": "Path 4159",
    className: "cls-3",
    d: "M37.93,38.21h0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4160",
    "data-name": "Path 4160",
    className: "cls-3",
    d: "M38.36,38.32l0,0s0,.06,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4161",
    "data-name": "Path 4161",
    className: "cls-3",
    d: "M35.86,47.83c-.09,0-.06,0-.07,0s.1,0,.09,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4162",
    "data-name": "Path 4162",
    className: "cls-3",
    d: "M36.14,46.77h0l0-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4163",
    "data-name": "Path 4163",
    className: "cls-3",
    d: "M36.14,45.78a3.11,3.11,0,0,0,0,.53v0l0,.08c0-.22,0-.49,0-.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4164",
    "data-name": "Path 4164",
    className: "cls-3",
    d: "M36.22,45.25s0-.12,0,.12v-.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4165",
    "data-name": "Path 4165",
    className: "cls-3",
    d: "M36.22,45.35c0,.1,0-.07,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4166",
    "data-name": "Path 4166",
    className: "cls-3",
    d: "M36.21,44.87V45s0-.15,0-.1c0-.14,0-.11,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4167",
    "data-name": "Path 4167",
    className: "cls-3",
    d: "M36.18,44.74v.07a.15.15,0,0,0,0-.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4168",
    "data-name": "Path 4168",
    className: "cls-3",
    d: "M36.2,45v-.15s0,0,0,.07,0,0,0,.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4169",
    "data-name": "Path 4169",
    className: "cls-3",
    d: "M36.19,45c0,.08,0,.18,0,0,0,.27,0,.23,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4170",
    "data-name": "Path 4170",
    className: "cls-3",
    d: "M36.1,45.73v.18a1.16,1.16,0,0,0,0-.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4171",
    "data-name": "Path 4171",
    className: "cls-3",
    d: "M36.23,44s0,.05,0,.06v.1a.9.9,0,0,1,0-.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4172",
    "data-name": "Path 4172",
    className: "cls-3",
    d: "M36.2,44.07l0-.15c0,.13,0,.16,0,.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4173",
    "data-name": "Path 4173",
    className: "cls-3",
    d: "M36.14,44.71l0,.25,0-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4174",
    "data-name": "Path 4174",
    className: "cls-3",
    d: "M36.23,43.46v0h0v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4175",
    "data-name": "Path 4175",
    className: "cls-3",
    d: "M36.34,43.37a0,0,0,0,0,0,0h0s0,0,0,0l.28,0a1.51,1.51,0,0,1-.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4176",
    "data-name": "Path 4176",
    className: "cls-3",
    d: "M36.77,43.36l-.14,0,.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4177",
    "data-name": "Path 4177",
    className: "cls-3",
    d: "M36.19,43.66a.5.5,0,0,0,0-.12l0,.06v.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4179",
    "data-name": "Path 4179",
    className: "cls-3",
    d: "M36.19,43.67h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4180",
    "data-name": "Path 4180",
    className: "cls-3",
    d: "M36.16,44.32c0-.09,0-.28,0-.1s0,0,0,.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4181",
    "data-name": "Path 4181",
    className: "cls-3",
    d: "M36.16,43.75v.16s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4182",
    "data-name": "Path 4182",
    className: "cls-3",
    d: "M36.15,43.67v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4183",
    "data-name": "Path 4183",
    className: "cls-3",
    d: "M36.49,43.34h-.05s0,0,.05,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4184",
    "data-name": "Path 4184",
    className: "cls-3",
    d: "M36.24,43.37h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4186",
    "data-name": "Path 4186",
    className: "cls-3",
    d: "M36.43,43.32h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4187",
    "data-name": "Path 4187",
    className: "cls-3",
    d: "M37,43.36l-.06,0,.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4189",
    "data-name": "Path 4189",
    className: "cls-3",
    d: "M36.26,43.36l.05,0-.06,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4190",
    "data-name": "Path 4190",
    className: "cls-3",
    d: "M37.4,43.94a.72.72,0,0,1-.15-.32c-.07-.14-.1,0-.08.12s0,0,.09.14c0-.06-.11-.34,0-.22a.79.79,0,0,1,.08.26c0-.09.14.24.15.18l-.08-.17s0,.06,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4191",
    "data-name": "Path 4191",
    className: "cls-3",
    d: "M37.05,43.46v-.05l0,.09,0,.12a.43.43,0,0,0,.07.12l-.12-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4192",
    "data-name": "Path 4192",
    className: "cls-3",
    d: "M36.9,43.33s.13,0,.08,0a.11.11,0,0,0-.08,0h0l-.1,0c.31,0-.08,0,.14,0h0s0,0,0,0h0a.17.17,0,0,1,.16.07.17.17,0,0,0-.14-.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4193",
    "data-name": "Path 4193",
    className: "cls-3",
    d: "M36.07,44.05h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4194",
    "data-name": "Path 4194",
    className: "cls-3",
    d: "M36.08,43.93a.41.41,0,0,1,0,.11c0,.07,0,0,0,0s0,.16,0,0v0a1.26,1.26,0,0,1,0-.27.3.3,0,0,0,0,.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4195",
    "data-name": "Path 4195",
    className: "cls-3",
    d: "M36.23,43.3l.09,0h0a.09.09,0,0,0-.09,0v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4196",
    "data-name": "Path 4196",
    className: "cls-3",
    d: "M37.17,43.78l0,0,.08.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4197",
    "data-name": "Path 4197",
    className: "cls-3",
    d: "M37.3,44.09h0l0,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4198",
    "data-name": "Path 4198",
    className: "cls-3",
    d: "M39,36.65h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4199",
    "data-name": "Path 4199",
    className: "cls-3",
    d: "M39.51,36.84h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4200",
    "data-name": "Path 4200",
    className: "cls-3",
    d: "M40.38,45.54c0-.11-.05-.24-.07-.22v0a1.34,1.34,0,0,1,.07.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4201",
    "data-name": "Path 4201",
    className: "cls-3",
    d: "M40.8,40.79v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4202",
    "data-name": "Path 4202",
    className: "cls-3",
    d: "M40.72,40.7a.35.35,0,0,0,0-.14l0,.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4203",
    "data-name": "Path 4203",
    className: "cls-3",
    d: "M36.06,36.53l-.09,0c.14,0,.08,0,.09,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4204",
    "data-name": "Path 4204",
    className: "cls-3",
    d: "M38.6,47.28a1.49,1.49,0,0,0,.08.23.9.9,0,0,0-.08-.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4205",
    "data-name": "Path 4205",
    className: "cls-3",
    d: "M39.3,36.49h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4206",
    "data-name": "Path 4206",
    className: "cls-3",
    d: "M38.89,47.8l-.06,0a.29.29,0,0,1-.1-.12l0,0v0l0-.06a.88.88,0,0,0,0,.15.36.36,0,0,0,.16.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4209",
    "data-name": "Path 4209",
    className: "cls-3",
    d: "M37.8,45.35c0-.06,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4210",
    "data-name": "Path 4210",
    className: "cls-3",
    d: "M37.75,45s0,0,0,0l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4212",
    "data-name": "Path 4212",
    className: "cls-3",
    d: "M37.77,45.25a.92.92,0,0,0,0,.09l0-.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4213",
    "data-name": "Path 4213",
    className: "cls-3",
    d: "M37.76,45.27l0-.06,0,.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4214",
    "data-name": "Path 4214",
    className: "cls-3",
    d: "M37.84,45.44a.42.42,0,0,1,0-.1h0l0,.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4215",
    "data-name": "Path 4215",
    className: "cls-3",
    d: "M34,39.48h0c0,.07,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4217",
    "data-name": "Path 4217",
    className: "cls-3",
    d: "M39.29,43.71a.59.59,0,0,1,.12.22l0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4218",
    "data-name": "Path 4218",
    className: "cls-3",
    d: "M37.75,36.52l.17,0c-.21,0-.36,0-.2.05s.19,0,.36,0,.34,0,.36,0l.11,0h-.07c.22.06.17,0,.45,0,.1,0,.16.06.1,0l.21.05c.07,0,0,0,0,0l.31.13h0l.2.08c.07.06,0,0,0,0l.16.1c0,.06-.09,0-.19-.1a.29.29,0,0,0,.14.13,1,1,0,0,1,.24.23l-.13-.12c0,.1.15.2.25.37,0-.05-.2-.35-.06-.2l.15.19s0,.1.11.21h0l.13.18a.31.31,0,0,1,0,.23c.07.25,0-.18.09.11s.08.35.14.61,0,0,0,0a.93.93,0,0,1,0,.13s0,0,0,0,0,0,.06.19,0,.37,0,.6c0,.05,0,0,0,0,0,.31,0,.26,0,.52l0,.21c0-.15.06.05.05.23l0-.13,0,.29s0,0,0,0v0c0,.1,0,.05,0,0l0-.1c0-.07,0-.14,0-.13v.1a0,0,0,0,0,0,0v.09l0,.06v0c0,.12-.06.23-.1.35a1.89,1.89,0,0,1-.27.87c0-.1,0,0,0-.06a1.77,1.77,0,0,0,.23-.48c0,.1,0,.07,0,0a1.58,1.58,0,0,1-.14.36s-.05.06-.12.13,0,0,0,.13a2.09,2.09,0,0,1-.2.22s0,0,.13-.17a1.29,1.29,0,0,0-.16.17.37.37,0,0,1-.17.16l.06-.06c-.07.08-.31.2-.26.16l0,0-.25.13a.35.35,0,0,0-.22.32.61.61,0,0,0,.05.18l.06.11a.44.44,0,0,0,.08.11l-.08,0,.36.45s-.06.18-.18,0a1.36,1.36,0,0,0,.13.3s0-.14,0-.07.06.24.1.36c0-.07.07,0,.11.09s0,0-.07,0l.18.25c0-.06-.05,0,0,.08a2,2,0,0,1,.14.31l0-.13c.14.32.22.28.35.59,0,0-.11-.06,0,.1a2.6,2.6,0,0,1,.41.53v.06l.11.2a6.45,6.45,0,0,1-.47-.63.76.76,0,0,0,.08.21c0,.07-.07-.08-.09-.13l.17.41s.17.3.19.27l-.23-.43s.2.22.33.51c0,.08-.08,0-.09,0a1.68,1.68,0,0,1,.15.3L40.78,47a1,1,0,0,0,.11.21l.06.11,0,.06v.06a.09.09,0,0,1,0,.08s0,0,0,0,.2-.06.19,0a.32.32,0,0,1-.2.16h-.16l-.1,0c-.12,0,.18-.07.07-.1l-.1,0c-.07,0,0,0-.13,0s-.34,0-.08,0c-.16,0-.17,0-.36,0,.06,0-.18.08-.34.09,0,0,0,0,0,0h-.61a.23.23,0,0,1-.17-.1s0-.16,0-.11a.51.51,0,0,1-.09-.16c0-.18.09.2.07,0a3.72,3.72,0,0,1-.19-.34,1.57,1.57,0,0,0,.18.42s-.17-.19-.31-.49,0-.11,0-.15c-.18-.45-.22-.36-.35-.74,0-.16.05,0,.06-.07.08.19.1.31.16.44l-.06-.17a1.23,1.23,0,0,1,.12.26c0-.13-.3-.76-.43-1.12,0-.06-.08-.16-.07-.11l0,.11c0,.11-.11-.2-.06,0a4,4,0,0,1-.24-.51l0-.05a.48.48,0,0,0,.07.2c-.05-.08-.09-.34-.17-.42l0,.16a4.66,4.66,0,0,1-.25-.5c0,.1,0,0,0,.18,0-.13.19.48.16.28,0,.15.08.24.12.42,0,0,0-.07,0,.09l0,0h0a.19.19,0,0,1,0-.08c0,.07.15.31.2.39s0,0,0,0l.07.12s.06.26,0,0l.08.2a2.35,2.35,0,0,0,.14.37c0,.09.12.22.07.15l.14.3h0c.06.16.13.3.2.47s.06.16.1.24l0,.13a.44.44,0,0,0,.1.16.36.36,0,0,0,.24.09h.23l0,0c.14,0,.42,0,.48,0a5.78,5.78,0,0,0,.93,0v0h.08a.4.4,0,0,0,.35-.45.31.31,0,0,0,0-.08v0c0-.07,0-.1-.07-.16L41,47l-.16-.39a.35.35,0,0,1,.06.14c-.09-.34-.33-.65-.42-1a1.3,1.3,0,0,1-.08-.17h0v0l0-.1a.46.46,0,0,0,0,.09c0-.05-.06-.13-.11-.21v-.07c0-.08,0-.06,0,0l-.06-.1c0-.08-.1-.2-.1-.31s-.2-.4-.26-.43,0,0,0,0c0-.1-.08-.18-.12-.27v0L39.64,44c0-.13,0-.18,0-.07-.16-.28-.12-.23-.26-.46h0l-.08-.15,0-.07a.09.09,0,0,1,0-.05.22.22,0,0,1,.07-.17.1.1,0,0,1,0,0l.09,0,.2-.1a2.32,2.32,0,0,0,.72-.64c-.1.06.17-.21.14-.26s.07-.09,0,0a1.85,1.85,0,0,0,.2-.6s0,.07,0,0l0-.12s0,0,0,.09a.65.65,0,0,0,0-.28.09.09,0,0,0,0-.08.69.69,0,0,0,0-.32c0-.05,0-.13,0,0,0,0,0-.2,0-.35a1.31,1.31,0,0,0,0-.28V40c0-.23,0-.25,0-.47v.06a1.17,1.17,0,0,1,0-.36h0c0-.1,0-.2,0-.3a2.89,2.89,0,0,1,0-.29l0,0s0-.37-.14-.59c0,0,0,.06,0,.09s-.06-.37-.12-.49,0,0,0,.07c-.14-.33,0,0-.18-.25,0-.05.07,0,0-.12a3.87,3.87,0,0,0-.54-.53s.07.08,0,0a1.46,1.46,0,0,0-.59-.31l0,0a2,2,0,0,0-.53-.08,1,1,0,0,0-.48-.07c-.2,0-.38,0-.37,0h-.41a1.75,1.75,0,0,0-.46,0c-.06,0,0,0,0,0a3.21,3.21,0,0,0-.76,0l0,0c-.09,0-.57,0-1,0h0a5.48,5.48,0,0,1-.7,0h-.3a.4.4,0,0,0-.15,0,.3.3,0,0,0-.08.08.33.33,0,0,0-.12.31.25.25,0,0,1,0-.17s0,0,0,0,0,.12,0,0c0,.08,0,.17,0,.22s0,.07,0,0v0c0-.06,0,.46,0,.45,0,.73,0,1.44,0,2.12l0-.08v.24c0,.06,0,.08,0-.09a.93.93,0,0,0,0,.29c0,.33,0-.13,0,0v.11a1.82,1.82,0,0,1,0,.32c0,.13,0,.07,0,.12v.38l0-.12c0,.13,0,.28,0,.14,0,.2,0,1.12,0,1.24a4,4,0,0,1,0,.6c0-.05,0-.09,0,.11-.07-.07,0,.36-.08.52,0-.15,0,.55,0,.33,0,.16,0,0,0,.14,0,.38,0,.85,0,1.33,0,0,0-.07,0,0l-.05.26c0,.09.06.08,0,.26,0,0,0-.06,0,0,0,.47,0,1,0,1.43v.65a.36.36,0,0,0,.33.3h.1l.36,0c-.13,0,0,0,.06,0-.07,0,0,0,0,0l.4,0c.07,0,.42,0,.47,0h-.13c.17,0-.24-.08-.21-.13a7.21,7.21,0,0,0-.81,0c-.07,0,.06,0,0,0l-.14,0h-.09a.13.13,0,0,1-.08,0h0a.17.17,0,0,1-.13-.17,2.53,2.53,0,0,1,0-.28c0-.19,0-.38,0-.66l0,0a1.5,1.5,0,0,1,0-.2c0-.13,0,.34-.05.21s0-.84.06-.94,0,0,0-.13l0,0,0-.05c0-.12,0-.18,0-.18v.11a3.89,3.89,0,0,0,0-.49V45c0-.5,0-1.11,0-1.6v0c0-.37,0-.3,0-.7v0c0-.1,0-.2,0-.3,0,.1,0-.2,0-.06a1.89,1.89,0,0,0-.06-.47l0-.06a1.45,1.45,0,0,1,0-.3c0,.17,0-.13,0,.06,0-.42,0-.63,0-.83s0,.37,0,.26c0,.09,0-.16,0-.29a5.51,5.51,0,0,0,.06-.57v.07c0-.13,0-.25,0-.41s0-.2,0-.23V40a3.33,3.33,0,0,1,0-.63.88.88,0,0,1,0,.17c0-.09,0-.17,0-.26a3.64,3.64,0,0,1,0,.57c0-.09,0-.36,0-.26-.06-.14,0-.34,0-.57l0,0c0-.06,0-.12,0-.18l0,.12a4.82,4.82,0,0,1,0-.54c0,.37,0,.08,0,.24,0-.46.07-.27,0-.78,0,.07,0,.26,0,.15a2.83,2.83,0,0,1,0-.29c0-.34,0,0,0-.09s0-.17,0-.32h0c0-.4,0-.1,0-.46l0,.15V36.8l0,0a1.27,1.27,0,0,1,0-.2.16.16,0,0,1,.08-.1s0,0,0,0l0,0h.1c.12,0-.07,0,.18,0a.44.44,0,0,1-.23,0s0,0,0,0h.29l.35,0c.06,0,0,0,0,0l.23,0s0,0-.17,0l.34,0,.13,0c.19,0,.46,0,.71,0h.09a4.33,4.33,0,0,0,.72,0l.16,0c.22,0-.21,0,.15-.06s.1,0,.19,0a1.88,1.88,0,0,1,.58,0h-.21m2.36.8s-.11-.1-.13-.14.08.07.13.14m.58,3.85a.75.75,0,0,1,0-.16.94.94,0,0,1,0,.16m-2.58,4.9h0c0,.11,0,.07,0,0M38,45.85s0,0,0,0a.61.61,0,0,1,0,.12.36.36,0,0,0,0-.11m-4.16-5.6v0c0,.11,0,.08,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4219",
    "data-name": "Path 4219",
    className: "cls-3",
    d: "M40.73,40.71l0,0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4221",
    "data-name": "Path 4221",
    className: "cls-3",
    d: "M40.62,47.62h.1s0,0-.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4222",
    "data-name": "Path 4222",
    className: "cls-3",
    d: "M37.51,44.67l.07.14a.5.5,0,0,1,0-.13s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4223",
    "data-name": "Path 4223",
    className: "cls-3",
    d: "M37.15,43.37l0-.06h0c0,.08.08.15,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4224",
    "data-name": "Path 4224",
    className: "cls-3",
    d: "M37.53,44.51s0-.11-.07-.21v0s0,.09.06.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4225",
    "data-name": "Path 4225",
    className: "cls-3",
    d: "M37.45,44.28l0-.09a.79.79,0,0,0,0,.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4226",
    "data-name": "Path 4226",
    className: "cls-3",
    d: "M37.9,45.56c0-.05,0,0,0-.05s.16.31,0,.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4227",
    "data-name": "Path 4227",
    className: "cls-3",
    d: "M37.56,44.4v0l.05.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4228",
    "data-name": "Path 4228",
    className: "cls-3",
    d: "M37.87,45.2,37.81,45l0,0a1.76,1.76,0,0,0,.09.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4229",
    "data-name": "Path 4229",
    className: "cls-3",
    d: "M37.78,45a.5.5,0,0,0-.05-.13,1.12,1.12,0,0,0,.05.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4230",
    "data-name": "Path 4230",
    className: "cls-3",
    d: "M37.66,44.62v.05l0,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4231",
    "data-name": "Path 4231",
    className: "cls-3",
    d: "M38.56,46.93l.08.17s0,0,0-.1,0-.1,0-.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4232",
    "data-name": "Path 4232",
    className: "cls-3",
    d: "M38.41,46.37a.28.28,0,0,1,0,.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4233",
    "data-name": "Path 4233",
    className: "cls-3",
    d: "M38.62,46.88s.13.24,0,0c0,0-.09-.18,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4234",
    "data-name": "Path 4234",
    className: "cls-3",
    d: "M40.9,47.68h0l0,.05a.14.14,0,0,0,0-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4235",
    "data-name": "Path 4235",
    className: "cls-3",
    d: "M40.07,45.49c.08.2,0,0,.12.22s-.06-.15,0-.11c-.07-.12-.09-.18-.1-.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4236",
    "data-name": "Path 4236",
    className: "cls-3",
    d: "M40.17,45.6l0,.06,0-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4237",
    "data-name": "Path 4237",
    className: "cls-3",
    d: "M35.39,47.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4238",
    "data-name": "Path 4238",
    className: "cls-3",
    d: "M35.67,47.8l0,0,.09,0h-.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4239",
    "data-name": "Path 4239",
    className: "cls-3",
    d: "M40.27,37.66h0a.24.24,0,0,0-.05-.1l0,.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4240",
    "data-name": "Path 4240",
    className: "cls-3",
    d: "M38.85,36.64h0l-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4241",
    "data-name": "Path 4241",
    className: "cls-3",
    d: "M37.25,36.58h.21c-.14,0-.23,0-.21,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4242",
    "data-name": "Path 4242",
    className: "cls-3",
    d: "M43.07,36.39h5.58a.27.27,0,0,1,.27.27V38.1a.27.27,0,0,1-.27.27H45.13a.27.27,0,0,0-.27.28v2.08a.27.27,0,0,0,.27.28H48a.28.28,0,0,1,.28.27v1.44A.28.28,0,0,1,48,43H45.13a.27.27,0,0,0-.27.28v2.19a.28.28,0,0,0,.27.28H48.7A.28.28,0,0,1,49,46v1.43a.28.28,0,0,1-.28.28H43.07a.28.28,0,0,1-.28-.28V36.66a.28.28,0,0,1,.28-.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4243",
    "data-name": "Path 4243",
    className: "cls-3",
    d: "M43.07,36.39h5.58a.27.27,0,0,1,.27.27V38.1a.27.27,0,0,1-.27.27H45.13a.27.27,0,0,0-.27.28v2.08a.27.27,0,0,0,.27.28H48a.28.28,0,0,1,.28.27v1.44A.28.28,0,0,1,48,43H45.13a.27.27,0,0,0-.27.28v2.19a.28.28,0,0,0,.27.28H48.7A.28.28,0,0,1,49,46v1.43a.28.28,0,0,1-.28.28H43.07a.28.28,0,0,1-.28-.28V36.66a.28.28,0,0,1,.28-.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4244",
    "data-name": "Path 4244",
    className: "cls-3",
    d: "M43,36.27c.1,0,.06,0,.08,0s-.11,0-.11,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4245",
    "data-name": "Path 4245",
    className: "cls-3",
    d: "M42.72,37.47v0l0,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4246",
    "data-name": "Path 4246",
    className: "cls-3",
    d: "M42.72,38.58q0-.3,0-.6v0l0-.09c0,.24,0,.55,0,.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4247",
    "data-name": "Path 4247",
    className: "cls-3",
    d: "M42.64,39.17s0,.13,0-.14v.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4248",
    "data-name": "Path 4248",
    className: "cls-3",
    d: "M42.64,39.06c0-.12,0,.08,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4249",
    "data-name": "Path 4249",
    className: "cls-3",
    d: "M42.65,39.6l0-.15s0,.17,0,.11c0,.16,0,.13,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4250",
    "data-name": "Path 4250",
    className: "cls-3",
    d: "M42.67,39.74v-.08a.21.21,0,0,0,0,.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4251",
    "data-name": "Path 4251",
    className: "cls-3",
    d: "M42.66,39.5v.16s0,0,0-.07,0,0,0-.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4252",
    "data-name": "Path 4252",
    className: "cls-3",
    d: "M42.66,39.4c0-.09,0-.2,0,0,0-.3,0-.25,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4253",
    "data-name": "Path 4253",
    className: "cls-3",
    d: "M42.75,38.64l0-.12,0-.1s0,.22,0,.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4254",
    "data-name": "Path 4254",
    className: "cls-3",
    d: "M42.63,40.55s0,0,0-.06v-.11a1.11,1.11,0,0,1,0,.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4255",
    "data-name": "Path 4255",
    className: "cls-3",
    d: "M42.66,40.49v.17c0-.15,0-.18,0-.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4256",
    "data-name": "Path 4256",
    className: "cls-3",
    d: "M42.71,39.77l0-.28,0,.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4257",
    "data-name": "Path 4257",
    className: "cls-3",
    d: "M42.63,41.2l0-.1,0,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4258",
    "data-name": "Path 4258",
    className: "cls-3",
    d: "M42.63,41.63c0-.07,0,.1,0,0,0,.1,0,.2,0,.3,0-.11,0-.22,0-.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4259",
    "data-name": "Path 4259",
    className: "cls-3",
    d: "M42.64,42.11a.89.89,0,0,0,0-.15.77.77,0,0,0,0,.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4260",
    "data-name": "Path 4260",
    className: "cls-3",
    d: "M42.67,41a.32.32,0,0,0,0,.14l0-.07V41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4262",
    "data-name": "Path 4262",
    className: "cls-3",
    d: "M42.67,40.93v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4263",
    "data-name": "Path 4263",
    className: "cls-3",
    d: "M42.69,40.22c0,.1,0,.3.05.1s0,0-.05-.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4264",
    "data-name": "Path 4264",
    className: "cls-3",
    d: "M42.7,40.85v-.18s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4265",
    "data-name": "Path 4265",
    className: "cls-3",
    d: "M42.7,40.94v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4266",
    "data-name": "Path 4266",
    className: "cls-3",
    d: "M42.66,41.81a2.17,2.17,0,0,1,0,.26c0-.1,0-.21,0-.32s0,0,0,.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4269",
    "data-name": "Path 4269",
    className: "cls-3",
    d: "M42.68,41.74a.47.47,0,0,0,0-.17v.18s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4270",
    "data-name": "Path 4270",
    className: "cls-3",
    d: "M42.65,42.38c0-.05,0-.09,0-.14a.66.66,0,0,0,0,.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4272",
    "data-name": "Path 4272",
    className: "cls-3",
    d: "M42.66,41.47a.3.3,0,0,0,0,.1.49.49,0,0,0,0-.13v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4273",
    "data-name": "Path 4273",
    className: "cls-3",
    d: "M42.81,43.3a1,1,0,0,1,0-.39c0-.18-.08-.06-.11.09s0,0,0,.18c0-.06,0-.4,0-.24a1,1,0,0,1,0,.3c0-.1,0,.3.07.25v-.2s0,.07,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4274",
    "data-name": "Path 4274",
    className: "cls-3",
    d: "M42.68,42.66v-.08l0,.26a.83.83,0,0,0,0,.15v-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4275",
    "data-name": "Path 4275",
    className: "cls-3",
    d: "M42.67,42.25c0,.06,0,.24.06.13a1.33,1.33,0,0,0,0-.28c0,.35,0-.1,0,.15a1.15,1.15,0,0,0,0-.19c0,.07,0,.13,0,.18h0v0c0,.1,0,0,0,0h0v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4276",
    "data-name": "Path 4276",
    className: "cls-3",
    d: "M42.78,40.51h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4277",
    "data-name": "Path 4277",
    className: "cls-3",
    d: "M42.77,40.65a.53.53,0,0,1,0-.13c0-.07,0,0,0,0s0-.17,0,0v0a1.53,1.53,0,0,1,0,.3.84.84,0,0,0,.05-.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4278",
    "data-name": "Path 4278",
    className: "cls-3",
    d: "M42.73,41.46v.29l0-.14h0c0-.16,0-.13,0-.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4279",
    "data-name": "Path 4279",
    className: "cls-3",
    d: "M42.66,43.05l0,0,0,.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4280",
    "data-name": "Path 4280",
    className: "cls-3",
    d: "M42.66,43.42h0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4281",
    "data-name": "Path 4281",
    className: "cls-3",
    d: "M47.38,42.87h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4282",
    "data-name": "Path 4282",
    className: "cls-3",
    d: "M46.76,42.87h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4283",
    "data-name": "Path 4283",
    className: "cls-3",
    d: "M47.87,47.84c.12,0,.26,0,.25,0l0,0h-.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4284",
    "data-name": "Path 4284",
    className: "cls-3",
    d: "M45.5,45.74h0l.08,0-.12,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4285",
    "data-name": "Path 4285",
    className: "cls-3",
    d: "M45.41,45.83h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4286",
    "data-name": "Path 4286",
    className: "cls-3",
    d: "M47.6,41.15l-.1,0c.15,0,.09,0,.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4287",
    "data-name": "Path 4287",
    className: "cls-3",
    d: "M42.67,47.28v.15a.55.55,0,0,0,0,.17.34.34,0,0,1,0-.14s0-.06,0-.08v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4288",
    "data-name": "Path 4288",
    className: "cls-3",
    d: "M47.14,43.1h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4289",
    "data-name": "Path 4289",
    className: "cls-3",
    d: "M43,47.85l-.08,0a.41.41,0,0,1-.27-.23.37.37,0,0,0,.35.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4293",
    "data-name": "Path 4293",
    className: "cls-3",
    d: "M42.74,44.55a0,0,0,0,0,0,0,0,0,0,0,1,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4295",
    "data-name": "Path 4295",
    className: "cls-3",
    d: "M42.66,44.82v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4296",
    "data-name": "Path 4296",
    className: "cls-3",
    d: "M42.65,44.83v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4298",
    "data-name": "Path 4298",
    className: "cls-3",
    d: "M45.39,38.3h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4300",
    "data-name": "Path 4300",
    className: "cls-3",
    d: "M48.86,46.34a1,1,0,0,1,0,.29l.06-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4301",
    "data-name": "Path 4301",
    className: "cls-3",
    d: "M48.17,42.31l0,.2c0-.24,0-.41,0-.23,0,0,0,.21,0,.41s-.09.14-.09.17h0c-.26,0-.19,0-.52,0-.12,0-.2,0-.12,0l-.26,0c-.07,0-.06,0,0,0h-.39l-.25,0c-.1,0,0,0,0,0l-.21,0c-.09,0,.09,0,.24,0-.2-.07-.18,0-.62,0h.2a4.57,4.57,0,0,0-.52-.05s.46.06.23.08a1.41,1.41,0,0,0-.29,0s-.12,0-.28,0v0l-.15,0a.34.34,0,0,0-.14,0,.42.42,0,0,0-.21.16.76.76,0,0,0-.08.11.41.41,0,0,0,0,.11v0a.43.43,0,0,0,0-.05l0,0v.15a5.93,5.93,0,0,0,0,.73c0,.17,0,0,0,0l0,.16s0,0,0,0,0,0,0,.21a6.47,6.47,0,0,0,0,.68c0,.06,0,0,0,0l0,.2a.57.57,0,0,0,0,.13.69.69,0,0,0,.05.13.51.51,0,0,0,.3.17h.13c-.18,0,0,0,.25-.07l-.16,0,.32,0s0,0,0,0h.06c.11,0,0,0,0,.05l-.12,0c-.08,0-.15,0-.13.06h.1s0,0,0,0h.1l.07,0h0l.42,0a8.93,8.93,0,0,1,1-.1c-.12,0,0,0,0,.08a4.28,4.28,0,0,0-.62,0c.13,0,.1,0,.07,0l.44,0s.09,0,.21,0c-.09,0,.33,0,.5,0s0,0-.25,0c.24,0,.32-.06.55,0h-.1a1,1,0,0,1,.36,0h.45a.19.19,0,0,1,.12,0,.22.22,0,0,1,.07.09.43.43,0,0,1,0,.11.39.39,0,0,0,0,.15.23.23,0,0,1-.06-.07l.15.64c0-.06-.13.16-.15-.14a2.29,2.29,0,0,0,0,.37c0-.06.05-.15.06-.07s0,.15-.06.42c0,0,0,0,0,0a.26.26,0,0,1,0,.15s-.06,0-.06,0a.21.21,0,0,1-.12.21c.07,0,0,0,0-.06s-.29,0-.38,0l.14,0c-.38,0-.38.08-.76.07,0,0,.12-.07-.08-.08a3,3,0,0,1-.73.17l-.06,0-.26,0a6.88,6.88,0,0,1,.86-.17.71.71,0,0,0-.25,0c-.08,0,.11,0,.18,0h-.5s-.39,0-.37.07l.55,0a1.42,1.42,0,0,1-.67.09c-.09,0,.06-.06.06-.07a2.32,2.32,0,0,1-.37,0h-.41c-.08,0-.25-.05-.26,0s.16.16.07.19-.43,0-.52,0,.2-.08.08-.1l-.11,0c-.08,0,0,0-.15,0,0,0-.38,0-.08,0-.19,0-.2,0-.41,0,.06,0-.2.08-.38.09,0,0,0,0,0,0h-.69a.42.42,0,0,1-.22,0l-.06-.07s0-.05,0,0a.22.22,0,0,1,0-.17c0-.1,0,0,0,0s0,.11,0,0,0-.06,0-.15a2.65,2.65,0,0,1,0-.27.5.5,0,0,0,0,.21.65.65,0,0,0,0,.28s-.06,0-.08-.16,0-.3,0-.45,0-.13,0-.18c0-.54-.08-.46,0-.92,0-.18,0,0,.07,0,0,.23,0,.36,0,.52l0-.2a1.71,1.71,0,0,1,0,.32c0-.15,0-.92,0-1.34,0-.08,0-.2,0-.15v.14c0,.12,0-.25,0-.09q0-.32,0-.63l0,0a.88.88,0,0,0,0,.23,4.17,4.17,0,0,0,0-.5l0,.18c0-.21,0-.42,0-.63,0,.1,0,0,0,.21,0-.13,0,.57,0,.35,0,.16,0,.28-.06.5,0,0,0-.08,0,.11,0,0,0,0,0,0h0s0-.07,0-.1a3.89,3.89,0,0,1,0,.49c0,.11,0-.05,0,0v.15s0,.3,0,0v.23a3.38,3.38,0,0,0,0,.45c0,.11,0,.28,0,.18l0,.37h0c0,.18,0,.37,0,.56v.15a1,1,0,0,0,0,.17.36.36,0,0,0,.34.33h.42l0,0c.16,0,.47,0,.54,0a9,9,0,0,0,1,0v0h.61l0,0c.2,0,.53,0,.85,0h-.16c.38.05.81,0,1.16,0H48l0,0h0c.1,0,.08,0,0,0h.13c.08,0,.26,0,.37,0h.12a.41.41,0,0,0,.21-.1.42.42,0,0,0,.1-.2.25.25,0,0,0,0-.12s0,0,0,0a1.71,1.71,0,0,0,0-.32l0-.05,0-.24c0-.15,0-.21,0-.06,0-.35,0-.29,0-.59l0,0a1.48,1.48,0,0,0,0-.2.58.58,0,0,0-.08-.18.22.22,0,0,0-.11-.1.17.17,0,0,0-.1,0h-.57c-.34,0-.73,0-1,0,.12.06-.29,0-.32,0s-.12,0,0,0a5.3,5.3,0,0,0-.69,0s.07,0,0,0h0c-.32,0-.35,0-.37.08a1.15,1.15,0,0,0-.37,0s-.15,0,0,0h-.35a.22.22,0,0,1-.11-.1s0-.07,0-.07v-.63a1.42,1.42,0,0,1,0-.41h0c0-.46,0-.2,0-.65l0,0a.63.63,0,0,1,0-.25c0-.06,0-.13,0-.2v-.1s0-.06,0-.08a.15.15,0,0,0,0,.07.17.17,0,0,1,.13-.16.21.21,0,0,1,.11,0h0c.38,0,.05,0,.33,0,0,0-.07,0,.12,0s.55-.05.81,0c-.06,0-.11,0,0,0a4.33,4.33,0,0,0,.72,0h0c.16,0,.5,0,.59,0a.76.76,0,0,0,.21,0,.34.34,0,0,0,.33-.2.43.43,0,0,0,0-.19v-.13c0-.08,0-.13,0-.13V42h0a2.19,2.19,0,0,0,0-.51c0-.07,0,0,0,0V41.3a.37.37,0,0,0,0-.15.32.32,0,0,0-.16-.18l-.1,0H48l-.22,0,0,0c-.1,0-.64,0-1.07,0h.05a8.57,8.57,0,0,0-1.34,0h-.3c.07,0,.14,0,.15,0h0s-.12,0,0,0a.24.24,0,0,1-.21-.09c0-.05,0-.06,0,0l0,0s-.06-.06-.07-.17a.14.14,0,0,1,0-.09v-.09c0-.05,0-.09,0-.09,0-.4,0-.81,0-1.2,0-.2,0-.39,0-.58a.37.37,0,0,1,0-.11.16.16,0,0,1,.13-.11h.12l-.08,0h.26c.07,0,.1,0-.1,0a.93.93,0,0,0,.33,0c.37,0-.15,0,0,0h.12a1.1,1.1,0,0,1,.36,0c.14,0,.07,0,.13,0h.42l-.13,0c.15,0,.31,0,.16,0,.23.05,1.25,0,1.39,0h.49a.71.71,0,0,0,.2,0s-.07,0-.06,0l.16-.08s0,0,.05,0a.25.25,0,0,0,.1-.17.17.17,0,0,0,0-.07V38a1,1,0,0,1,0-.17c0,.16,0-.63-.05-.38,0-.18,0,0,0-.15s0-.22,0-.34v-.29a.56.56,0,0,0,0-.12.39.39,0,0,0-.32-.2h-.5s.08,0,0,0l-.28-.05c-.11,0-.1.05-.29,0,0,0,.07,0,0,0-1.06-.05-2.16,0-3.23-.05.15,0,.05,0-.06,0,.07,0,0,0,0,0l-.45,0c-.08,0-.48,0-.53,0h.15c-.19,0,.26.08.23.13a9.08,9.08,0,0,0,.91,0c.07,0-.07,0,0,0a1.7,1.7,0,0,1,.39,0h0c.56,0,.79,0,1.41,0l0,0,.22,0c.16,0-.37,0-.23,0s.94,0,1.06.05-.06,0,.14,0h.06l0,0c.14,0,.2,0,.21,0h.88a.16.16,0,0,1,.11.07.09.09,0,0,1,0,.07V37c0,.15,0,.29,0,.43v.33a1,1,0,0,1,0,.16,1.88,1.88,0,0,0,0,.24h0a.19.19,0,0,1-.13.19s0,0,0,0h0a2.16,2.16,0,0,0-.51.06l-.07,0a1.87,1.87,0,0,1-.34,0c.19,0-.14,0,.07-.05-.48,0-.71,0-.93,0s.41,0,.29,0c.1,0-.18,0-.33,0s-.42-.05-.64-.06h.08c-.14,0-.28,0-.46,0s-.22,0-.25,0h.35a4.26,4.26,0,0,1-.71,0l.19,0h-.3a4.73,4.73,0,0,1,.65,0c-.1,0-.4,0-.3,0a.67.67,0,0,1-.28,0h-.1l-.11,0a.3.3,0,0,0-.16.19v0a.27.27,0,0,0,0,.12v.13l0-.07v.09a.76.76,0,0,1,0,.15c0,.1,0,.2,0,.3,0-.42,0-.1,0-.28,0,.52-.06.3,0,.88,0-.08,0-.3,0-.17l0,.33c0,.38,0-.06,0,.1a1,1,0,0,0,0,.35h0a.74.74,0,0,0,0,.28.08.08,0,0,1,0,0,.35.35,0,0,0,.08.22.31.31,0,0,1-.11-.19.34.34,0,0,0,.13.24l-.06,0a.39.39,0,0,0,.32.13h.26s0,0,.22,0-.07,0,.2,0a.53.53,0,0,1-.25,0l-.07,0h.35l.4,0c.06,0,0,0,0,0h.26s0,0-.19.05l.38,0s.2,0,.14,0c.21,0,.52,0,.8,0h.46a.17.17,0,0,1,.1.13v.06l0,.17c0,.25,0-.24.06.17s0,.11,0,.21a2.44,2.44,0,0,1,0,.66,1.92,1.92,0,0,1,0-.24m-2.33.56h.22a.41.41,0,0,1-.22,0m.1,2.91a.61.61,0,0,1-.19,0h.19m-3.27,0h0c0,.13,0,.09,0,0m0-.27s0,0,0,0a.38.38,0,0,1,0,.15.57.57,0,0,0,0-.13m3.56-7.08h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4302",
    "data-name": "Path 4302",
    className: "cls-3",
    d: "M45.42,45.82h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4304",
    "data-name": "Path 4304",
    className: "cls-3",
    d: "M44.92,47.62H45s0,0-.11,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4305",
    "data-name": "Path 4305",
    className: "cls-3",
    d: "M42.64,44.11v.17a.76.76,0,0,1,0-.15s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4306",
    "data-name": "Path 4306",
    className: "cls-3",
    d: "M42.79,42.61v-.08h0c0,.11,0,.18,0,.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4307",
    "data-name": "Path 4307",
    className: "cls-3",
    d: "M42.72,44s0-.12,0-.24v0s0,.09,0,.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4308",
    "data-name": "Path 4308",
    className: "cls-3",
    d: "M42.73,43.68v-.11s0,0,0,.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4309",
    "data-name": "Path 4309",
    className: "cls-3",
    d: "M42.67,45.21c0-.06,0,0,0-.07s0,.38,0,.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4310",
    "data-name": "Path 4310",
    className: "cls-3",
    d: "M42.79,43.85l0,0,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4311",
    "data-name": "Path 4311",
    className: "cls-3",
    d: "M42.77,44.81v-.19a.12.12,0,0,1,0,0v.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4312",
    "data-name": "Path 4312",
    className: "cls-3",
    d: "M42.77,44.57v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4313",
    "data-name": "Path 4313",
    className: "cls-3",
    d: "M42.8,44.12v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4314",
    "data-name": "Path 4314",
    className: "cls-3",
    d: "M42.77,46.89v.22s0,0,0-.12,0-.13,0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4315",
    "data-name": "Path 4315",
    className: "cls-3",
    d: "M42.84,46.25s0,.07,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4316",
    "data-name": "Path 4316",
    className: "cls-3",
    d: "M42.85,46.87s0,.31,0,0c0,0,0-.23,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4317",
    "data-name": "Path 4317",
    className: "cls-3",
    d: "M45.25,47.7h0v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4318",
    "data-name": "Path 4318",
    className: "cls-3",
    d: "M48.06,47.58c-.25,0-.06,0-.29,0-.05,0,.19,0,.13,0,.15,0,.23,0,.16,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4319",
    "data-name": "Path 4319",
    className: "cls-3",
    d: "M47.9,47.62h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4320",
    "data-name": "Path 4320",
    className: "cls-3",
    d: "M43.51,36.26h-.16l.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4321",
    "data-name": "Path 4321",
    className: "cls-3",
    d: "M43.2,36.3l0,0-.1,0h.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4322",
    "data-name": "Path 4322",
    className: "cls-3",
    d: "M45.4,42.81h.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4323",
    "data-name": "Path 4323",
    className: "cls-3",
    d: "M47.58,42.84h0l.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4324",
    "data-name": "Path 4324",
    className: "cls-3",
    d: "M48.11,41.75V42c0-.16,0-.26,0-.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4325",
    "data-name": "Path 4325",
    className: "cls-3",
    d: "M7.44,28.52a.22.22,0,0,1,.19.23A3.59,3.59,0,0,1,6.9,31a3.58,3.58,0,0,1-3,1.18A3.23,3.23,0,0,1,.81,30.64a6.49,6.49,0,0,1-.68-3.57V24.32c0-1.94.22-3,.83-3.78a3.24,3.24,0,0,1,2.94-1.3c2.29,0,3.42,1.11,3.58,3.51a.25.25,0,0,1-.2.24l-1.63.13a.22.22,0,0,1-.24-.18c-.14-1.06-.61-1.53-1.48-1.53-1.19,0-1.57.76-1.57,3.12v2.32c0,2.38.38,3.12,1.58,3.12.93,0,1.43-.48,1.59-1.51a.22.22,0,0,1,.25-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4326",
    "data-name": "Path 4326",
    className: "cls-3",
    d: "M7.44,28.52a.22.22,0,0,1,.19.23A3.59,3.59,0,0,1,6.9,31a3.58,3.58,0,0,1-3,1.18A3.23,3.23,0,0,1,.81,30.64a6.49,6.49,0,0,1-.68-3.57V24.32c0-1.94.22-3,.83-3.78a3.24,3.24,0,0,1,2.94-1.3c2.29,0,3.42,1.11,3.58,3.51a.25.25,0,0,1-.2.24l-1.63.13a.22.22,0,0,1-.24-.18c-.14-1.06-.61-1.53-1.48-1.53-1.19,0-1.57.76-1.57,3.12v2.32c0,2.38.38,3.12,1.58,3.12.93,0,1.43-.48,1.59-1.51a.22.22,0,0,1,.25-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4327",
    "data-name": "Path 4327",
    className: "cls-3",
    d: "M7.41,28.39c.07,0,0,0,.06,0s-.06,0-.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4328",
    "data-name": "Path 4328",
    className: "cls-3",
    d: "M6.23,28.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4329",
    "data-name": "Path 4329",
    className: "cls-3",
    d: "M5.39,28.75a.72.72,0,0,0,.07-.25.33.33,0,0,1,.06-.19.21.21,0,0,1,.23-.1h.1a.39.39,0,0,0-.24,0,.31.31,0,0,0-.16.21,1.65,1.65,0,0,1-.06.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4330",
    "data-name": "Path 4330",
    className: "cls-3",
    d: "M5.12,29.24s0,.11.06-.11v0a.41.41,0,0,0,0,.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4331",
    "data-name": "Path 4331",
    className: "cls-3",
    d: "M5.16,29.15c0-.1,0,.06,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4332",
    "data-name": "Path 4332",
    className: "cls-3",
    d: "M4.88,29.53l.09-.1-.06.05s0,0,0,0-.08.09,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4333",
    "data-name": "Path 4333",
    className: "cls-3",
    d: "M4.79,29.63l.06,0-.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4334",
    "data-name": "Path 4334",
    className: "cls-3",
    d: "M5,29.48l-.1.11s0,0,.05-.05,0,0,.06-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4335",
    "data-name": "Path 4335",
    className: "cls-3",
    d: "M5,29.42c.05-.06.12-.14,0,0,.08-.1.1-.17.09-.16L5,29.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4336",
    "data-name": "Path 4336",
    className: "cls-3",
    d: "M5.42,28.82l0-.11s0-.07,0-.1-.06.21,0,.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4337",
    "data-name": "Path 4337",
    className: "cls-3",
    d: "M4.09,29.8s0,0,.06,0l.1,0H4.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4338",
    "data-name": "Path 4338",
    className: "cls-3",
    d: "M4.15,29.83l-.16,0c.14,0,.17,0,.16,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4339",
    "data-name": "Path 4339",
    className: "cls-3",
    d: "M4.8,29.68,5,29.5a1.15,1.15,0,0,1-.23.21l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4340",
    "data-name": "Path 4340",
    className: "cls-3",
    d: "M3.49,29.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4341",
    "data-name": "Path 4341",
    className: "cls-3",
    d: "M3.16,29.61s0,0,0,0,0,0,0,0l-.11-.08L3,29.41l.09.1.1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4342",
    "data-name": "Path 4342",
    className: "cls-3",
    d: "M2.88,29.31a.41.41,0,0,0,.09.1.81.81,0,0,1-.09-.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4343",
    "data-name": "Path 4343",
    className: "cls-3",
    d: "M3.71,29.83a.24.24,0,0,0-.12,0l.06,0h.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4344",
    "data-name": "Path 4344",
    className: "cls-3",
    d: "M3.65,29.83h0l-.13,0,.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4345",
    "data-name": "Path 4345",
    className: "cls-3",
    d: "M3.73,29.84h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4346",
    "data-name": "Path 4346",
    className: "cls-3",
    d: "M4.41,29.82c-.09,0-.29.08-.09.06s-.05,0,.09-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4347",
    "data-name": "Path 4347",
    className: "cls-3",
    d: "M3.81,29.87H4s0,0,0,0H3.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4348",
    "data-name": "Path 4348",
    className: "cls-3",
    d: "M3.72,29.87h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4349",
    "data-name": "Path 4349",
    className: "cls-3",
    d: "M3,29.54,3,29.46a.36.36,0,0,1-.07-.1.75.75,0,0,0,.07.12l0,.05,0,0s.05,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4350",
    "data-name": "Path 4350",
    className: "cls-3",
    d: "M3.3,29.73h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4352",
    "data-name": "Path 4352",
    className: "cls-3",
    d: "M3.06,29.59a.27.27,0,0,0,.12.09l-.07,0-.06-.06s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4353",
    "data-name": "Path 4353",
    className: "cls-3",
    d: "M2.76,29.09l0,.12a.28.28,0,0,0,0-.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4354",
    "data-name": "Path 4354",
    className: "cls-3",
    d: "M3.27,29.71h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4355",
    "data-name": "Path 4355",
    className: "cls-3",
    d: "M3.27,29.71l-.09,0,.1.05,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4356",
    "data-name": "Path 4356",
    className: "cls-3",
    d: "M2.41,28.25a1.36,1.36,0,0,1,.08.39c0,.17.08,0,.1-.11s0,0-.06-.17c0,.06,0,.39,0,.24a.75.75,0,0,1,0-.3c0,.1-.07-.29-.1-.23l0,.2s0-.07,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4357",
    "data-name": "Path 4357",
    className: "cls-3",
    d: "M2.65,28.85l0,.07a2,2,0,0,1,0-.24.51.51,0,0,0-.05-.15c0,.12.05.23.07.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4358",
    "data-name": "Path 4358",
    className: "cls-3",
    d: "M2.79,29.21s-.12-.19-.1-.09a.68.68,0,0,0,.14.23c-.16-.28,0,.08-.05-.14,0,.06.07.1.09.15a1,1,0,0,1-.07-.15h0a0,0,0,0,1,0,0c0-.08,0,0,0,0h0l-.07-.14-.06-.16a2.49,2.49,0,0,0,.11.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4359",
    "data-name": "Path 4359",
    className: "cls-3",
    d: "M4.14,30h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4360",
    "data-name": "Path 4360",
    className: "cls-3",
    d: "M4,30l.12,0c.07,0,0,0,0,0s.17,0,0,0h0a.92.92,0,0,1-.29,0A.44.44,0,0,0,4,30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4361",
    "data-name": "Path 4361",
    className: "cls-3",
    d: "M3.24,29.77A.91.91,0,0,1,3,29.62a.32.32,0,0,0,.1.1h0c.13.09.11.06.13.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4362",
    "data-name": "Path 4362",
    className: "cls-3",
    d: "M2.6,28.48l0,0-.06-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4363",
    "data-name": "Path 4363",
    className: "cls-3",
    d: "M2.54,28.12h0l0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4364",
    "data-name": "Path 4364",
    className: "cls-3",
    d: "M1.1,20.54l0,.07,0-.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4365",
    "data-name": "Path 4365",
    className: "cls-3",
    d: "M1.51,20.11v0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4366",
    "data-name": "Path 4366",
    className: "cls-3",
    d: "M5.12,22.29a1.45,1.45,0,0,0,0,.23v0a1.3,1.3,0,0,1-.06-.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4367",
    "data-name": "Path 4367",
    className: "cls-3",
    d: "M6.16,19.84l0,0,.08,0-.11-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4368",
    "data-name": "Path 4368",
    className: "cls-3",
    d: "M6,19.86l-.12-.1.12.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4369",
    "data-name": "Path 4369",
    className: "cls-3",
    d: "M.28,23.66l0,.1c0-.16,0-.09,0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4370",
    "data-name": "Path 4370",
    className: "cls-3",
    d: "M2.48,24.28c0-.1,0-.19,0-.26a.74.74,0,0,0,0,.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4371",
    "data-name": "Path 4371",
    className: "cls-3",
    d: "M1.08,20.21s-.05.06,0,.06l0-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4372",
    "data-name": "Path 4372",
    className: "cls-3",
    d: "M2.51,23.71V24a1.58,1.58,0,0,0,0-.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4373",
    "data-name": "Path 4373",
    className: "cls-3",
    d: "M5.32,31.85h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4374",
    "data-name": "Path 4374",
    className: "cls-3",
    d: "M7.65,29.46l0,.15s0-.07,0-.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4376",
    "data-name": "Path 4376",
    className: "cls-3",
    d: "M2.41,27s0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4377",
    "data-name": "Path 4377",
    className: "cls-3",
    d: "M2.46,22.92h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4378",
    "data-name": "Path 4378",
    className: "cls-3",
    d: "M2.49,26.74a.34.34,0,0,1,0-.1.58.58,0,0,1,0,.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4379",
    "data-name": "Path 4379",
    className: "cls-3",
    d: "M2.5,26.72v.07s0,0,0-.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4381",
    "data-name": "Path 4381",
    className: "cls-3",
    d: "M.36,29.29v0c0,.07,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4383",
    "data-name": "Path 4383",
    className: "cls-3",
    d: "M7,22.89a.68.68,0,0,1-.28,0l.1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4384",
    "data-name": "Path 4384",
    className: "cls-3",
    d: "M.49,21.82l.07-.19c0,.24-.08.4,0,.23,0,0,0-.21.08-.38a1.54,1.54,0,0,0,.12-.38L.82,21l0,.07a.54.54,0,0,0,.1-.2A.75.75,0,0,1,1,20.62c.08-.09.13-.14.09-.08l.15-.2c.05-.06.05,0,0,0a.86.86,0,0,1,.13-.14l.13-.13h0l.17-.18c.08-.05,0,0,0,0l.16-.13c.08,0-.06.07-.17.16a.4.4,0,0,0,.18-.1L2,19.79a.88.88,0,0,1,.22-.1,1,1,0,0,0-.17.1c.12,0,.25-.11.47-.16-.06,0-.43.11-.23,0l.25-.1s.12,0,.27-.05v0A1.09,1.09,0,0,0,3,19.42a.42.42,0,0,1,.27,0c.29,0-.21,0,.14-.06s.41,0,.71,0,0,0,0,0l.15,0s0,0,0,0,0,0,.22,0a3.94,3.94,0,0,1,.65.13s0,0,0,0l.3.07.25.07.2.13c-.14-.1.07,0,.25.07a1.13,1.13,0,0,1-.11-.11,2.11,2.11,0,0,1,.27.18s0,0,0,0l0,0c.07.09,0,.06-.06,0l-.07-.08c-.08,0-.15-.05-.15,0l.09.05s0,0,0,0l.09,0,0,.08h0l.15.14.13.15a3.14,3.14,0,0,1,.31.32,1.91,1.91,0,0,1,.15.21l.14.28c-.07-.1,0,0-.08,0a.67.67,0,0,0-.1-.23c-.06-.09-.11-.19-.18-.29.07.1,0,.09,0,.06A3.35,3.35,0,0,1,7,21s0,.09.06.2c0-.05,0,0,.08.13s.08.24.11.33,0,0,0,0a1.38,1.38,0,0,1-.07-.2,1,1,0,0,0,.08.25.61.61,0,0,1,.08.26.19.19,0,0,0,0-.1,1.07,1.07,0,0,1,0,.35v-.05c0,.09,0,.2,0,.31l0,.18v.15a.15.15,0,0,1-.06.09l-.1,0a.4.4,0,0,0-.15,0,.33.33,0,0,1,.06-.06l-.61.2s-.17-.11.12-.16a2.19,2.19,0,0,0-.36,0s.14.05.06.06a4.1,4.1,0,0,0-.41,0c.08,0,0,.07-.14.08,0,0,0-.05,0-.07l-.17.05H5.53c.06,0,0,0,0-.08s0,0,0-.07,0-.17,0-.25,0,.1,0,.15a1,1,0,0,0-.13-.37,3.47,3.47,0,0,1-.17-.34s0,0,.06,0,0-.05,0-.14l-.09-.07L5,21.81a1.87,1.87,0,0,0-.4-.2l-.05,0a1,1,0,0,0-.24-.05,1.09,1.09,0,0,1,.4,0,1.2,1.2,0,0,1,.42.25c-.1-.12,0,0-.19-.21s.12.06.17.12a1.31,1.31,0,0,0-.45-.33s-.1,0-.2,0-.2,0-.2,0a1.42,1.42,0,0,1,.56.15s-.09,0-.22,0a2.67,2.67,0,0,0-.48-.08c-.09,0,.07-.06.07-.07H3.77l.16,0a5.4,5.4,0,0,0-.58.09l-.16.05c-.06,0-.1,0-.1,0,.15,0,.21.08.15.14a.75.75,0,0,0-.2.1l-.13.1-.09.08c-.11.09.07-.21,0-.14a.37.37,0,0,1,0,.11c-.06.07,0-.05-.1.12s-.17.36,0,.1a1.78,1.78,0,0,1-.08.18,1.65,1.65,0,0,0-.07.21c0-.06,0,.21,0,.39,0,0,0,0,0,0-.05.31-.08.61-.1.92,0,0,0,.2,0,.13s0,.14,0,.2c0,.21,0-.24,0-.08a3.25,3.25,0,0,1,0,.44,2.17,2.17,0,0,0,0-.51,1.35,1.35,0,0,1,.1.63c0,.29,0,.12,0,.17,0,.55.08.47.05.92,0,.18-.06,0-.08.05,0-.24,0-.36,0-.52v.2a1.16,1.16,0,0,1,0-.32c0,.15,0,.92,0,1.34,0,.07,0,.2,0,.14v-.13c0-.13,0,.25,0,.08a3.33,3.33,0,0,1,0,.63l0,0a.87.87,0,0,0,0-.23,2.09,2.09,0,0,0,0,.5v-.18a5.32,5.32,0,0,1,.07.62c0-.1,0-.05,0-.21,0,.14,0-.56-.06-.34,0-.16,0-.28,0-.49,0,0,0,.07,0-.11,0,0,0,0,0,0h0s0,.06,0,.1a4,4,0,0,1,0-.49c0-.12,0,0,0,0V26.2s0-.29,0,0v-.24c0-.14,0-.29,0-.44s0-.28,0-.19l0-.36h0a9,9,0,0,1,0-1.16,3.4,3.4,0,0,1,0-.45l0,0c0-.16.08-.46.07-.52a1.34,1.34,0,0,0,.07-.18c0-.08,0-.16.08-.26A1.31,1.31,0,0,1,3,21.91l0,0a1.07,1.07,0,0,1,.45-.28l0,0a1.8,1.8,0,0,1,.8,0,.36.36,0,0,1-.15,0,3.34,3.34,0,0,1,.52.14A.81.81,0,0,1,5,22a.59.59,0,0,1,.1.17v0s0,0,0,0l0,.11,0-.09c0,.06.07.15.1.23v.07c0,.09,0,.07,0,0l0,.12a.35.35,0,0,0,0,.17s0,.06,0,.1V23a.29.29,0,0,0,.1.12.32.32,0,0,0,.23.08,1.18,1.18,0,0,0,.27-.06s0,0,0,0l.32,0,0,0,.24-.06c.15,0,.21,0,.07,0l.58-.1v0h.13l.06,0a.38.38,0,0,0,.16-.12.25.25,0,0,0,0-.15c0-.06,0-.11,0-.18s0-.31,0-.47a7.36,7.36,0,0,0-.25-1c0,.14-.09-.28-.15-.28s0-.12,0,0a3.08,3.08,0,0,0-.2-.34.79.79,0,0,0-.21-.24s.07,0,0,0l-.1-.1s0,0,.08.06A1.82,1.82,0,0,0,6.58,20l-.1-.07a.12.12,0,0,0-.1,0,.73.73,0,0,0-.3-.22s-.11-.11.06,0L6,19.63l-.21-.11a1.18,1.18,0,0,0-.3-.1l-.09,0-.09,0-.26-.07-.26-.05.07,0a.32.32,0,0,1-.17,0l-.24,0h0a1.84,1.84,0,0,0-.33,0l-.33,0,0,0c0,.05-.4,0-.67,0h.1c-.14,0-.41,0-.56,0l.09,0c-.39.06,0,0-.32.12,0,0,0-.07-.13,0a1.26,1.26,0,0,0-.33.16c-.14.07-.3.18-.41.24.06,0,.11,0,0,0a1.88,1.88,0,0,0-.55.5l0,0a2.4,2.4,0,0,0-.31.51,1,1,0,0,0-.26.47c-.08.21-.12.41-.16.4,0,.15-.08.31-.11.46h0a1.51,1.51,0,0,0,0,.52c0,.07,0,0,0,0a3,3,0,0,0,0,.85l0,0c0,.1,0,.64,0,1.07a.11.11,0,0,1,0-.05,8.44,8.44,0,0,0,0,1.33l0,.32c0-.41,0,.06.06-.1,0,.16,0,.42,0,.22v0c0-.07,0,.52,0,.5a14.54,14.54,0,0,0,.11,2.38l0-.09c0,.09,0,.18,0,.26s0,.1,0-.09a.92.92,0,0,0,.1.32c.09.37-.08-.13-.05,0s0,.1.05.15v0A3.45,3.45,0,0,1,.4,30c0,.14,0,.08,0,.13a.31.31,0,0,0,0,.09,2.2,2.2,0,0,0,.15.31l0-.14c.08.13.15.28.1.13a2.32,2.32,0,0,0,.4.63,4.24,4.24,0,0,0,.49.46,5.83,5.83,0,0,0,.6.32c-.05,0-.08-.07.13,0,0,0,0,.06.17.11a2.39,2.39,0,0,1,.38.13c-.08,0,.08,0,.22,0s.28,0,.16,0c.18,0,0,0,.15.06a8.62,8.62,0,0,0,1.52-.05s-.09,0,0,0a1.51,1.51,0,0,0,.3,0c.1,0,.08-.07.28-.1,0,0-.07,0,0,0a2.74,2.74,0,0,0,1.37-.87,3.8,3.8,0,0,0,.77-1.46c0,.14,0,.05,0-.07,0,.08,0,0,0,0,0-.15.07-.29.1-.44a1.31,1.31,0,0,1,0-.28c0-.06,0-.11,0-.17a.15.15,0,0,0,0-.11l0,.08v.09c0-.2-.1.26-.15.22a8.52,8.52,0,0,1-.16.88c0,.07,0-.07,0,0a.89.89,0,0,1-.11.36v0a2.27,2.27,0,0,1-.32.57,2.63,2.63,0,0,1-.49.51h0a1.09,1.09,0,0,1-.17.13c-.05.06,0,0,.1-.06s.14-.12.1-.06-.25.19-.45.3a1.25,1.25,0,0,1-.45.18c-.19.07.06,0-.13.08h0l0,0c-.13,0-.2,0-.2,0l.11,0c-.16,0-.46.12-.52.12a1.08,1.08,0,0,0,.19,0A6.34,6.34,0,0,1,3.24,32l0,0a2.2,2.2,0,0,1-.37,0l-.14,0-.25-.06h0a1.58,1.58,0,0,1-.31-.09c.1,0-.19-.11,0-.07-.4-.17-.2-.07-.47-.19l0-.05a1,1,0,0,1-.27-.19c.15.11-.08-.12.08,0-.15-.17-.27-.29-.36-.4a1,1,0,0,1-.2-.3c-.08-.08,0,0,0,.11l.1.14c0,.05,0,0-.06,0a1.91,1.91,0,0,1-.15-.21C.77,30.48.76,30.37.62,30a.49.49,0,0,0,0,.07,1.88,1.88,0,0,1-.14-.42c-.06-.08-.06-.21-.1-.23s.06.22.1.33a2,2,0,0,1-.2-.67,1.82,1.82,0,0,1,.06.18,2.74,2.74,0,0,1,0-.28s.08.41.17.6c0-.1-.12-.37-.06-.28a3.15,3.15,0,0,1-.13-.61h0a1.2,1.2,0,0,1,0-.2l0,.13a5.66,5.66,0,0,1,0-.6c0,.42,0,.1,0,.28a8.79,8.79,0,0,1,0-.88c0,.08,0,.3,0,.18s0-.22,0-.33c0-.38,0,.06,0-.1a1,1,0,0,0,0-.35h0c0-.44-.06-.12,0-.52l0,.17v-.2l0,0a2.9,2.9,0,0,1,0-.51c0,.05,0,0,0-.23s0,.08,0-.2a.53.53,0,0,1,0,.25.31.31,0,0,0,0,.08,3.53,3.53,0,0,0,0-.46.37.37,0,0,1,0,.11l0-.4c0-.07,0,0,0,0s0-.13,0-.25,0,0,.05.19l0-.38s0-.2,0-.15c0-.21,0-.51,0-.79v-.1c0-.26,0-.49,0-.8l.06-.17c0-.24-.08.23,0-.17s0-.1.08-.19a1.51,1.51,0,0,1,.13-.63,1.55,1.55,0,0,1-.07.23m1.75-2.19a.76.76,0,0,1-.18.09.31.31,0,0,1,.18-.09m4.24.52L6.33,20a.81.81,0,0,1,.14.12m-4,5.6h0c0-.13,0-.08,0,0m0,.27s0,0,0,0v-.15a.33.33,0,0,0,0,.14m-2,4.15v0c0,.11,0,.08,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4385",
    "data-name": "Path 4385",
    className: "cls-3",
    d: "M6.06,19.86s0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4386",
    "data-name": "Path 4386",
    className: "cls-3",
    d: "M.28,23.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4387",
    "data-name": "Path 4387",
    className: "cls-3",
    d: "M2.73,21.85a.3.3,0,0,1,.08-.08s0,0-.08.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4388",
    "data-name": "Path 4388",
    className: "cls-3",
    d: "M2.53,27.44l0-.17a.38.38,0,0,1,0,.15s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4389",
    "data-name": "Path 4389",
    className: "cls-3",
    d: "M2.56,28.93s0,.05,0,.07h0c0-.1-.06-.17,0-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4390",
    "data-name": "Path 4390",
    className: "cls-3",
    d: "M2.45,27.6a.58.58,0,0,0,0,.24h0s0-.1,0-.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4391",
    "data-name": "Path 4391",
    className: "cls-3",
    d: "M2.45,27.87s0,.08,0,.11,0,0,0-.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4392",
    "data-name": "Path 4392",
    className: "cls-3",
    d: "M2.48,26.36c0,.05,0,0,0,.07s0-.39,0-.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4393",
    "data-name": "Path 4393",
    className: "cls-3",
    d: "M2.38,27.7l0,0,0-.07v.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4394",
    "data-name": "Path 4394",
    className: "cls-3",
    d: "M2.38,26.75v.19a.12.12,0,0,1,0,0,1,1,0,0,0,0-.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4395",
    "data-name": "Path 4395",
    className: "cls-3",
    d: "M2.38,27a.86.86,0,0,0,0,.16.92.92,0,0,0,0-.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4397",
    "data-name": "Path 4397",
    className: "cls-3",
    d: "M2.38,24.67v-.21s0,0,0,.11,0,.13,0,.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4398",
    "data-name": "Path 4398",
    className: "cls-3",
    d: "M2.32,25.31a.31.31,0,0,1,0-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4399",
    "data-name": "Path 4399",
    className: "cls-3",
    d: "M2.31,24.69s0-.31,0,0c0,0,0,.23,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4400",
    "data-name": "Path 4400",
    className: "cls-3",
    d: "M3,21.66l0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4401",
    "data-name": "Path 4401",
    className: "cls-3",
    d: "M5.44,22.38c0-.12-.05-.14-.06-.15s0,0-.07-.12.07.18,0,.13c.07.14.09.22.1.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4402",
    "data-name": "Path 4402",
    className: "cls-3",
    d: "M5.34,22.24l0-.07,0,.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4403",
    "data-name": "Path 4403",
    className: "cls-3",
    d: "M7.75,28.87v-.19a.22.22,0,0,1,0,.08v.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4404",
    "data-name": "Path 4404",
    className: "cls-3",
    d: "M7.62,28.51a.14.14,0,0,0,0-.06.23.23,0,0,0-.14,0,.21.21,0,0,1,.16.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4405",
    "data-name": "Path 4405",
    className: "cls-3",
    d: "M2.66,19.55h0l-.13,0,.12,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4406",
    "data-name": "Path 4406",
    className: "cls-3",
    d: "M1,20.72l0,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4407",
    "data-name": "Path 4407",
    className: "cls-3",
    d: "M.44,22.36a1.85,1.85,0,0,1,0-.23c0,.16-.08.24,0,.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4408",
    "data-name": "Path 4408",
    className: "cls-3",
    d: "M11.39,32H9.59a.22.22,0,0,1-.22-.22V19.61a.22.22,0,0,1,.22-.22H13.3c1.4,0,2.14.25,2.69.92a4.1,4.1,0,0,1,.75,2.78c0,2.05-.48,3.09-1.66,3.58A.22.22,0,0,0,15,27h0l2,4.69a.23.23,0,0,1-.12.29l-.08,0h-2a.24.24,0,0,1-.21-.14L12.75,27.1a.23.23,0,0,0-.21-.14h-.71a.22.22,0,0,0-.22.22v4.56a.22.22,0,0,1-.23.22m1.73-7.08c1,0,1.43-.45,1.43-1.67s-.4-1.67-1.45-1.67h-1.3a.22.22,0,0,0-.23.22v2.9a.22.22,0,0,0,.23.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4409",
    "data-name": "Path 4409",
    className: "cls-3",
    d: "M11.39,32H9.59a.22.22,0,0,1-.22-.22V19.61a.22.22,0,0,1,.22-.22H13.3c1.4,0,2.14.25,2.69.92a4.1,4.1,0,0,1,.75,2.78c0,2.05-.48,3.09-1.66,3.58A.22.22,0,0,0,15,27h0l2,4.69a.23.23,0,0,1-.12.29l-.08,0h-2a.24.24,0,0,1-.21-.14L12.75,27.1a.23.23,0,0,0-.21-.14h-.71a.22.22,0,0,0-.22.22v4.56a.22.22,0,0,1-.23.22m1.73-7.08c1,0,1.43-.45,1.43-1.67s-.4-1.67-1.45-1.67h-1.3a.22.22,0,0,0-.23.22v2.9a.22.22,0,0,0,.23.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4410",
    "data-name": "Path 4410",
    className: "cls-3",
    d: "M13.1,24.76s0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4411",
    "data-name": "Path 4411",
    className: "cls-3",
    d: "M12.82,24.81h0l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4412",
    "data-name": "Path 4412",
    className: "cls-3",
    d: "M12.57,24.81s.09,0,.14,0h0l0,0-.16,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4413",
    "data-name": "Path 4413",
    className: "cls-3",
    d: "M12.43,24.73h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4414",
    "data-name": "Path 4414",
    className: "cls-3",
    d: "M12.45,24.73s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4415",
    "data-name": "Path 4415",
    className: "cls-3",
    d: "M12.33,24.74h0s0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4416",
    "data-name": "Path 4416",
    className: "cls-3",
    d: "M12.29,24.76h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4417",
    "data-name": "Path 4417",
    className: "cls-3",
    d: "M12.35,24.74l0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4418",
    "data-name": "Path 4418",
    className: "cls-3",
    d: "M12.38,24.75s0,0,0,0,.06,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4419",
    "data-name": "Path 4419",
    className: "cls-3",
    d: "M12.55,24.85h0l0,0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4420",
    "data-name": "Path 4420",
    className: "cls-3",
    d: "M12.1,24.72s0,0,0,0h0l-.05,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4421",
    "data-name": "Path 4421",
    className: "cls-3",
    d: "M12.12,24.75h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4422",
    "data-name": "Path 4422",
    className: "cls-3",
    d: "M12.29,24.8l.06,0-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4423",
    "data-name": "Path 4423",
    className: "cls-3",
    d: "M12,24.72l0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4424",
    "data-name": "Path 4424",
    className: "cls-3",
    d: "M11.85,24.72s0,0,0,0l-.07,0h.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4425",
    "data-name": "Path 4425",
    className: "cls-3",
    d: "M11.77,24.73h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4426",
    "data-name": "Path 4426",
    className: "cls-3",
    d: "M12,24.76l0,0,0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4429",
    "data-name": "Path 4429",
    className: "cls-3",
    d: "M12.18,24.78s-.07,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4430",
    "data-name": "Path 4430",
    className: "cls-3",
    d: "M12,24.79h.05s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4431",
    "data-name": "Path 4431",
    className: "cls-3",
    d: "M12,24.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4432",
    "data-name": "Path 4432",
    className: "cls-3",
    d: "M11.81,24.75h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4435",
    "data-name": "Path 4435",
    className: "cls-3",
    d: "M11.83,24.77s0,0,0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4436",
    "data-name": "Path 4436",
    className: "cls-3",
    d: "M11.75,24.73v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4438",
    "data-name": "Path 4438",
    className: "cls-3",
    d: "M11.89,24.75l0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4439",
    "data-name": "Path 4439",
    className: "cls-3",
    d: "M11.54,24.69s0,0,.05.08.07,0,.1-.06l0,0s0,.07,0,.06,0,0,0-.06,0,0,0,0,0,0,0,0l0,.05s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4440",
    "data-name": "Path 4440",
    className: "cls-3",
    d: "M11.71,24.74h0a0,0,0,0,1,0,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4441",
    "data-name": "Path 4441",
    className: "cls-3",
    d: "M11.75,24.76s0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4442",
    "data-name": "Path 4442",
    className: "cls-3",
    d: "M12.11,24.88h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4443",
    "data-name": "Path 4443",
    className: "cls-3",
    d: "M12.08,24.86h0s0,0,0,0,0,0,0,0h0s-.08,0-.07,0a.1.1,0,0,0,0,.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4444",
    "data-name": "Path 4444",
    className: "cls-3",
    d: "M11.89,24.82h-.07l0,0h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4445",
    "data-name": "Path 4445",
    className: "cls-3",
    d: "M11.7,24.7h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4446",
    "data-name": "Path 4446",
    className: "cls-3",
    d: "M11.69,24.66h0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4448",
    "data-name": "Path 4448",
    className: "cls-3",
    d: "M13.38,21.43h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4449",
    "data-name": "Path 4449",
    className: "cls-3",
    d: "M11.69,22.49s.05-.06,0,0h0a0,0,0,0,1,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4450",
    "data-name": "Path 4450",
    className: "cls-3",
    d: "M12.19,21.53h0l0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4451",
    "data-name": "Path 4451",
    className: "cls-3",
    d: "M12.2,21.44l0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4452",
    "data-name": "Path 4452",
    className: "cls-3",
    d: "M14.31,21.81h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4453",
    "data-name": "Path 4453",
    className: "cls-3",
    d: "M11.68,23.76s0-.05,0-.07,0,.06,0,.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4454",
    "data-name": "Path 4454",
    className: "cls-3",
    d: "M13.44,21.67s0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4455",
    "data-name": "Path 4455",
    className: "cls-3",
    d: "M11.7,23.62h0s0,0,0,.06a.09.09,0,0,0,0-.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4457",
    "data-name": "Path 4457",
    className: "cls-3",
    d: "M13.35,24.78h0a0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4459",
    "data-name": "Path 4459",
    className: "cls-3",
    d: "M11.61,24.4h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4461",
    "data-name": "Path 4461",
    className: "cls-3",
    d: "M11.69,24.33v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4462",
    "data-name": "Path 4462",
    className: "cls-3",
    d: "M11.7,24.33h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4463",
    "data-name": "Path 4463",
    className: "cls-3",
    d: "M11.7,24.28v0h0v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4464",
    "data-name": "Path 4464",
    className: "cls-3",
    d: "M14.6,23.16h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4466",
    "data-name": "Path 4466",
    className: "cls-3",
    d: "M11.44,21.94a.06.06,0,0,1,0,.07l.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4467",
    "data-name": "Path 4467",
    className: "cls-3",
    d: "M13.89,21.54l0,0c.07,0,.11,0,.07,0s-.07,0-.11,0-.1,0-.12,0l0,0h0c-.06,0-.06,0-.14,0s0,0,0,0h-.07s0,0,0,0h-.1a.09.09,0,0,1-.07,0s0,0,0,0,0,0-.05,0,0,0,.06,0-.05,0-.15,0h.05s-.07,0-.13-.06.12.07.06.08h-.07s0,0-.07,0v0s0,0-.06.05a.1.1,0,0,1-.06-.05c-.07,0,0,0,0,0a.32.32,0,0,0-.17,0s0,0,0,0l0,0s0,0,0,0,0,0-.05,0-.1-.06-.16,0,0,0,0,0a.31.31,0,0,0-.13.06l-.06,0s0,.05-.06.07l0,0-.08,0s0,0,0,0h0s0,0,0,0l0,0s0,0,0-.06h0s0,0,0,0h0l0,0h0l-.1,0a.64.64,0,0,1-.24.1s0,0,0-.08.08,0,.14,0,0,0,0,0l-.1,0s0,0-.05,0,0,0,0,0a.31.31,0,0,0-.1.05s0,0,.06-.06a.09.09,0,0,0-.08.05s0,.05,0,.06,0,0,0,0-.08.1-.08.08v0l0,.1v.1c0,.06,0,.1,0,.11l-.06,0,.15.15s-.13,0-.15,0a.14.14,0,0,0,0,.09s0,0,.06,0,0,0-.06.1.07,0,.06,0h-.06l.06.07s0,0-.07,0,0,.07,0,.09l0,0c0,.09.08.09.07.18s-.07,0-.08,0a.45.45,0,0,1,.17.17l0,0,0,.06a1.06,1.06,0,0,1-.17-.2s0,0,0,.06,0,0,0,0v.11s0,.09.07.09l0-.13s.1.07.09.16-.06,0-.07,0a.14.14,0,0,1,0,.09v0c0,.05,0,.08,0,.13s0,.06,0,.07a.19.19,0,0,1,.18,0,.61.61,0,0,1,0,.12s-.07-.05-.1,0,0,0,0,0,0,0,0,0,0,.09,0,0,0,.05,0,.1.08.05.09.09h0c0,.09,0,.14,0,.22s0,.05,0,0a.08.08,0,0,1,0,0c0,.05,0-.06,0,0s0,.06,0,.1,0-.09,0-.12.09.06.11.15,0,0,0,0,.07.11,0,.21-.05,0-.07,0,0-.08,0-.12V24a.11.11,0,0,1,0-.08s0,.22,0,.32,0,0,0,0v0s0,.06,0,0a.22.22,0,0,1,0,.14l0,0s0,0,0-.06,0,.09,0,.12l0,0a.23.23,0,0,1,0,.14s0,0,0-.05,0-.13,0-.08,0-.06.05-.11,0,0,0,0h0l0,0s0-.09,0-.11,0,0,0,0l0,0s0-.07,0,0v-.05a.17.17,0,0,0,0-.1s0-.07,0,0v-.09h0a.61.61,0,0,1,0-.27.21.21,0,0,1,0-.11h0s0-.11,0-.12,0-.18,0-.25h0a.71.71,0,0,0,0-.14h0c0-.05,0-.12,0-.2s0,0,0,0,0-.19,0-.27a0,0,0,0,1,0-.05h0v0a0,0,0,0,0,0,0,.13.13,0,0,0,0-.06h0s0,0,0,0a0,0,0,0,0,0,0s0-.07,0-.09,0-.12-.06-.13h0a.11.11,0,0,0,0-.08h0l0-.05s0,0,.05,0,0-.07-.05-.14h0s0-.06,0-.08a.14.14,0,0,0,0-.06.14.14,0,0,1,0-.07.11.11,0,0,1,.14-.05c0-.06.06,0,.07,0s0,0,0,0,.11,0,.17,0,0,0,0,0,0,0,0,0,0,0,0,0,.08-.05.08-.09a.06.06,0,0,0,.09,0s0,0,0,0,.16,0,.16,0,0,0,.05,0a.24.24,0,0,0,.12,0h0s.05,0,.1,0h0c.11,0,.05,0,.15,0v0c0-.05.09,0,.15,0h0s.09.07.13.07h0c.08,0,0,0,.07,0s0,0,0,0,.13-.05.18,0,0,0,0,0,.11.06.16,0,0,0,0,0,.11,0,.13,0,.22,0,.19.1l.1,0h0a.2.2,0,0,0,.11,0s0,0,0,0a.27.27,0,0,0,.16.1v0s0,0,.05.07a.41.41,0,0,0,.07.11h0c.08.08,0,.25.13.26l0,.07c0-.09,0,0,0,0s0,.1,0,.06h0s0,.12,0,.12a2.45,2.45,0,0,1,0,.54l0,0v.06s0,0,0,0,0,.07,0,.07,0,0,0,0v0h0s0,0,0,.09,0,0,0,0v0a.17.17,0,0,1,0,.07l0,0s0,.07,0,0a.33.33,0,0,0,0,.17.59.59,0,0,1,0,.14.29.29,0,0,1,0,.16s0,0,0,0,0,.08-.11.1,0,0,0,.05,0,.06,0,.05,0,0-.05,0-.11.18-.17.27,0,0,0,0h-.07s0,.05,0,.06,0,0,0,0a1.82,1.82,0,0,1-.31.16.6.6,0,0,1-.35,0s0,0,0,0,0,0,0,0l-.1,0s-.11,0-.12,0h0s.07.08.06.13.14.05.22,0,0,0,0,0a.1.1,0,0,1,.09,0h0l.17,0,.18,0,0,0H14c0-.05-.09,0-.07,0s.21-.11.26-.09,0,0,0,0h0v0a.06.06,0,0,1,.07,0l0,0s.09-.1.1-.11a.08.08,0,0,1,0,0,.93.93,0,0,0,.22-.4h0c0-.1,0-.07.07-.18h0a.11.11,0,0,1,0-.08s0-.05,0,0,0-.06,0-.13l0,0a.08.08,0,0,1,0-.08s0,0,0,0c.06-.11,0-.17,0-.22s0,.1,0,.07,0-.05,0-.08.07-.06.07-.15v0s0-.07,0-.11,0-.06,0-.06v.08c0-.05,0-.09,0-.17a.08.08,0,0,1,0,0s0,0,0-.06,0,.1,0,.15,0-.1,0-.07,0-.09,0-.15h0a.09.09,0,0,1,0-.05l0,0c0-.05,0-.1,0-.15,0,.1,0,0,0,.07,0-.12.06-.07,0-.21,0,0,0,.07,0,0a.11.11,0,0,1,0-.08c0-.09,0,0-.05,0s0-.05,0-.08h0c0-.11-.05,0-.05-.12l0,0,0,0h0a.16.16,0,0,1,0-.12s-.05,0-.06,0,0,0,0-.05a0,0,0,0,1,0,.06h0a.21.21,0,0,0,0-.11,0,0,0,0,1,0,0l-.07-.08s0,0,0,0l0-.05a.07.07,0,0,1,.07,0L14.43,22s0-.05,0,0-.11-.1-.15-.16l0,0a.27.27,0,0,1-.07-.08.21.21,0,0,0-.1-.06.14.14,0,0,0,0-.06c-.06,0,0,.07-.07,0s0,0,0-.06-.11,0-.16,0h.06m-.74-.11s0,0,0,0,0,0,0,0m-1.07.06h0m-.4,2.61h0s0,0,0,0m0,.06s0,0,0,0,0,0,0,0,0,0,0,0m2.77-.8h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4468",
    "data-name": "Path 4468",
    className: "cls-3",
    d: "M12.2,21.45v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4470",
    "data-name": "Path 4470",
    className: "cls-3",
    d: "M11.46,23.18l0,0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4471",
    "data-name": "Path 4471",
    className: "cls-3",
    d: "M11.71,24.5v0h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4472",
    "data-name": "Path 4472",
    className: "cls-3",
    d: "M11.64,24.83h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4473",
    "data-name": "Path 4473",
    className: "cls-3",
    d: "M11.63,24.54s0,0,0,.05h0s0,0,0-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4474",
    "data-name": "Path 4474",
    className: "cls-3",
    d: "M11.62,24.6v0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4475",
    "data-name": "Path 4475",
    className: "cls-3",
    d: "M11.68,24.24s0,0,0,0,0-.09,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4476",
    "data-name": "Path 4476",
    className: "cls-3",
    d: "M11.56,24.56h0l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4477",
    "data-name": "Path 4477",
    className: "cls-3",
    d: "M11.58,24.33v.05h0s0-.06,0-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4478",
    "data-name": "Path 4478",
    className: "cls-3",
    d: "M11.58,24.39v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4479",
    "data-name": "Path 4479",
    className: "cls-3",
    d: "M11.55,24.5v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4480",
    "data-name": "Path 4480",
    className: "cls-3",
    d: "M11.59,23.85V23.8s0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4481",
    "data-name": "Path 4481",
    className: "cls-3",
    d: "M11.52,24s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4482",
    "data-name": "Path 4482",
    className: "cls-3",
    d: "M11.51,23.85s0-.07,0,0,0,.06,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4483",
    "data-name": "Path 4483",
    className: "cls-3",
    d: "M11.55,23.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4484",
    "data-name": "Path 4484",
    className: "cls-3",
    d: "M11.43,22.45c0,.06,0,0,0,.07s0-.05,0,0,0-.06,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4485",
    "data-name": "Path 4485",
    className: "cls-3",
    d: "M11.46,22.49v0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4486",
    "data-name": "Path 4486",
    className: "cls-3",
    d: "M13.21,24.75h0l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4487",
    "data-name": "Path 4487",
    className: "cls-3",
    d: "M13.15,24.8v0l0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4488",
    "data-name": "Path 4488",
    className: "cls-3",
    d: "M13,21.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4489",
    "data-name": "Path 4489",
    className: "cls-3",
    d: "M13.58,21.43h0l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4490",
    "data-name": "Path 4490",
    className: "cls-3",
    d: "M14.05,21.55l-.06,0s0,.07.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4491",
    "data-name": "Path 4491",
    className: "cls-3",
    d: "M11.47,32.07c-.11,0-.07,0-.09,0s.12,0,.12,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4492",
    "data-name": "Path 4492",
    className: "cls-3",
    d: "M11.68,30.86v0l0-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4493",
    "data-name": "Path 4493",
    className: "cls-3",
    d: "M11.68,29.77a5.86,5.86,0,0,0,0,.59v0l0,.08c0-.23,0-.54,0-.71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4494",
    "data-name": "Path 4494",
    className: "cls-3",
    d: "M11.76,29.19s0-.13,0,.14v-.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4495",
    "data-name": "Path 4495",
    className: "cls-3",
    d: "M11.76,29.3c0,.12,0-.07,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4496",
    "data-name": "Path 4496",
    className: "cls-3",
    d: "M11.75,28.77v.15s0-.16,0-.11c0-.16,0-.13,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4497",
    "data-name": "Path 4497",
    className: "cls-3",
    d: "M11.72,28.63v.08a.19.19,0,0,0,0-.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4498",
    "data-name": "Path 4498",
    className: "cls-3",
    d: "M11.74,28.87v-.16s0,0,0,.07,0,0,0,.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4499",
    "data-name": "Path 4499",
    className: "cls-3",
    d: "M11.73,29c0,.08,0,.19,0,0,0,.29,0,.25,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4500",
    "data-name": "Path 4500",
    className: "cls-3",
    d: "M11.64,29.72v.11l0,.1c0-.05,0-.22,0-.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4501",
    "data-name": "Path 4501",
    className: "cls-3",
    d: "M11.77,27.83l0,.06V28a1,1,0,0,1,0-.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4502",
    "data-name": "Path 4502",
    className: "cls-3",
    d: "M11.74,27.89v-.17c0,.15,0,.18,0,.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4503",
    "data-name": "Path 4503",
    className: "cls-3",
    d: "M11.68,28.6l0,.28,0-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4504",
    "data-name": "Path 4504",
    className: "cls-3",
    d: "M11.77,27.19l0,.09,0-.08v0h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4505",
    "data-name": "Path 4505",
    className: "cls-3",
    d: "M11.89,27.12c-.07,0,.1,0,0,0l.3,0h-.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4506",
    "data-name": "Path 4506",
    className: "cls-3",
    d: "M12.37,27.11l-.15,0,.15,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4507",
    "data-name": "Path 4507",
    className: "cls-3",
    d: "M11.72,27.44a.31.31,0,0,0,0-.13l0,.06v.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4509",
    "data-name": "Path 4509",
    className: "cls-3",
    d: "M11.73,27.46v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4510",
    "data-name": "Path 4510",
    className: "cls-3",
    d: "M11.71,28.16c0-.1,0-.3-.05-.1s0,0,.05.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4511",
    "data-name": "Path 4511",
    className: "cls-3",
    d: "M11.7,27.54v.17s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4512",
    "data-name": "Path 4512",
    className: "cls-3",
    d: "M11.7,27.45v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4513",
    "data-name": "Path 4513",
    className: "cls-3",
    d: "M12.06,27.09H12s-.06,0,.05,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4514",
    "data-name": "Path 4514",
    className: "cls-3",
    d: "M11.77,27.1h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4516",
    "data-name": "Path 4516",
    className: "cls-3",
    d: "M12,27.07h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4517",
    "data-name": "Path 4517",
    className: "cls-3",
    d: "M12.57,27.11s0,0-.07,0l.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4519",
    "data-name": "Path 4519",
    className: "cls-3",
    d: "M11.79,27.1a.05.05,0,0,1,0,0l-.06,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4520",
    "data-name": "Path 4520",
    className: "cls-3",
    d: "M13,27.77a1,1,0,0,1-.16-.35c-.07-.16-.1,0-.07.12s0,0,.09.16c0-.06-.12-.37-.05-.24a.75.75,0,0,1,.09.29c0-.1.14.26.16.2L13,27.76s0,.06,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4521",
    "data-name": "Path 4521",
    className: "cls-3",
    d: "M12.68,27.23l0-.07a1.83,1.83,0,0,1,.06.25c.06.1.07.13.08.13l-.12-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4522",
    "data-name": "Path 4522",
    className: "cls-3",
    d: "M12.51,27.08l.08,0s0,0,0,0a.14.14,0,0,0-.09,0h0l-.11,0c.35,0-.1,0,.15,0h0c.09,0,0,0,0,0h.1a.08.08,0,0,1,0,0h0v0s0,0,0,0l-.06-.05H12.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4523",
    "data-name": "Path 4523",
    className: "cls-3",
    d: "M11.61,27.87s0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4524",
    "data-name": "Path 4524",
    className: "cls-3",
    d: "M11.63,27.74s0,.08,0,.12,0,0,0,0,0,.17,0,0v0a2.54,2.54,0,0,1,0-.29,1,1,0,0,0,0,.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4525",
    "data-name": "Path 4525",
    className: "cls-3",
    d: "M11.76,27a.2.2,0,0,1,.11,0H12l-.14,0v0h-.1s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4526",
    "data-name": "Path 4526",
    className: "cls-3",
    d: "M12.8,27.59l0,0,.09.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4527",
    "data-name": "Path 4527",
    className: "cls-3",
    d: "M12.94,27.94h0L13,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4528",
    "data-name": "Path 4528",
    className: "cls-3",
    d: "M14.79,19.67h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4529",
    "data-name": "Path 4529",
    className: "cls-3",
    d: "M15.32,19.89h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4530",
    "data-name": "Path 4530",
    className: "cls-3",
    d: "M16.22,29.57c0-.12-.06-.26-.07-.23v0a1.54,1.54,0,0,1,.08.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4531",
    "data-name": "Path 4531",
    className: "cls-3",
    d: "M16.66,24.31v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4532",
    "data-name": "Path 4532",
    className: "cls-3",
    d: "M16.58,24.22a.76.76,0,0,0,0-.16l0,.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4533",
    "data-name": "Path 4533",
    className: "cls-3",
    d: "M11.52,19.53l-.1,0c.16,0,.09,0,.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4534",
    "data-name": "Path 4534",
    className: "cls-3",
    d: "M14.32,31.47l.08.25a.81.81,0,0,0-.08-.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4535",
    "data-name": "Path 4535",
    className: "cls-3",
    d: "M15.09,19.53l-.07,0,.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4536",
    "data-name": "Path 4536",
    className: "cls-3",
    d: "M14.61,32.05,14.55,32a.19.19,0,0,1-.06-.07.25.25,0,0,1,0-.07l0-.13c0,.05,0,.1,0,.15a.35.35,0,0,0,.16.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4539",
    "data-name": "Path 4539",
    className: "cls-3",
    d: "M13.47,29.33c0-.07,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4540",
    "data-name": "Path 4540",
    className: "cls-3",
    d: "M13.41,28.94l0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4542",
    "data-name": "Path 4542",
    className: "cls-3",
    d: "M13.44,29.22l0,.1,0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4543",
    "data-name": "Path 4543",
    className: "cls-3",
    d: "M13.43,29.24l0-.07s0,0,0,.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4544",
    "data-name": "Path 4544",
    className: "cls-3",
    d: "M13.51,29.43l0-.12s0,0,0,0l0,.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4545",
    "data-name": "Path 4545",
    className: "cls-3",
    d: "M9.44,22.92h0c0,.08,0,.05,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4547",
    "data-name": "Path 4547",
    className: "cls-3",
    d: "M15.08,27.53a1,1,0,0,1,.12.25l0-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4548",
    "data-name": "Path 4548",
    className: "cls-3",
    d: "M13.38,19.52l.2,0c-.23,0-.4,0-.22,0a1,1,0,0,1,.39,0,1.19,1.19,0,0,0,.4,0l.12,0h-.08c.24.07.19,0,.5.05.11,0,.18.06.1.05l.24.06c.08,0,0,0,0,0a2.11,2.11,0,0,1,.34.16h0a1,1,0,0,1,.21.1c.07.06-.05,0,0,0l.17.11c.05.07-.09,0-.2-.12a.54.54,0,0,0,.15.15.81.81,0,0,1,.25.27l-.13-.14c.05.12.16.22.26.41,0-.05-.21-.38-.06-.22a1.06,1.06,0,0,0,.16.22s0,.11.11.24h0a2.43,2.43,0,0,0,.14.2.46.46,0,0,1,0,.26c.07.27,0-.2.08.12s.09.4.14.68,0,0,0,0l0,.14s0,0,0,0,0,0,.05.21,0,.42,0,.66c0,.07,0,0,0,0,0,.35,0,.3,0,.58l0,.23c0-.17.05.06.05.26,0-.06,0-.11,0-.15s0,.21,0,.32,0,0,0,0v0c0,.11,0,.05,0,0a.49.49,0,0,0,0-.11c0-.08,0-.15,0-.14s0,.07,0,.1,0,0,0,0v.1l-.05.06,0,0c0,.13-.07.26-.11.39l0,.21a1.42,1.42,0,0,1-.05.22,1.83,1.83,0,0,1-.08.25l-.06.14-.08.14c0-.11,0,0-.05-.07a1.81,1.81,0,0,0,.26-.52c-.05.11-.05.08-.05.05a3.12,3.12,0,0,1-.15.39s-.07.06-.14.15,0,0-.06.13a.76.76,0,0,1-.11.14,1.14,1.14,0,0,1-.11.11s0,0,.15-.19a1.07,1.07,0,0,0-.18.19l-.08.09-.12.08a.13.13,0,0,0,.07-.06c-.08.09-.34.22-.3.17l.05,0-.28.13-.1.06a.36.36,0,0,0-.07.1.31.31,0,0,0,0,.23,1.71,1.71,0,0,0,.22.4.16.16,0,0,1-.09,0l.38.51c-.05,0-.05.19-.18-.06a2.33,2.33,0,0,0,.14.33c0-.06,0-.15,0-.08a3.63,3.63,0,0,0,.11.4c0-.08.06,0,.11.1s0,0-.07,0l.18.29c0-.07-.05,0,0,.08s.11.27.15.35l0-.14c.14.35.22.31.36.66,0,0-.11-.08,0,.1a2.53,2.53,0,0,1,.43.6v.06l.12.23c-.1-.13-.36-.5-.49-.71a1.13,1.13,0,0,0,.08.24c0,.07-.07-.1-.09-.16l.18.46s.18.33.2.3l-.24-.48a1.47,1.47,0,0,1,.34.57c0,.09-.08,0-.09,0a2.49,2.49,0,0,1,.16.33l-.07-.13a5.44,5.44,0,0,1,.22.5c0,.08,0,.13,0,.14l.11,0a.06.06,0,0,1,.08,0v0a.22.22,0,0,1-.05.08.28.28,0,0,1-.17.09.47.47,0,0,1-.17,0h-.12c-.13,0,.2-.08.09-.1l-.11,0c-.09,0,0,0-.15,0s-.37,0-.09,0c-.18,0-.19,0-.4,0,.07,0-.19.07-.37.08,0,0,0,0,0,0H15c-.14,0-.3,0-.38-.12s-.06-.19,0-.13l-.09-.18c0-.2.09.22.07.06a2.69,2.69,0,0,1-.19-.38,1.54,1.54,0,0,0,.19.46s-.18-.21-.33-.54,0-.12,0-.17c-.19-.5-.24-.4-.37-.82,0-.18.05,0,.05-.07.1.21.11.34.17.48L14,30.36l.12.29c0-.15-.33-.85-.46-1.24,0-.07-.09-.18-.07-.12l.05.12c0,.12-.12-.22-.07-.06a4.7,4.7,0,0,1-.25-.57v-.06a.83.83,0,0,0,.08.22,3.66,3.66,0,0,0-.18-.46l0,.17a4.79,4.79,0,0,1-.26-.56c0,.1,0,.05.05.2,0-.14.2.53.17.3a4.19,4.19,0,0,0,.12.48s0-.08.05.1l0,0h0a.29.29,0,0,1,0-.09c.05.08.16.35.21.44s0,0,0,0l.07.13s.07.28,0,.05l.09.21a3.52,3.52,0,0,0,.15.42c0,.1.12.24.07.16l.15.34h0c.06.17.14.34.21.51l.11.27.05.14v0s0,0,0,.05a.61.61,0,0,0,.07.1.34.34,0,0,0,.2.09h.32l0,0c.16,0,.47,0,.53,0a8.81,8.81,0,0,0,1,0v0h.11a.34.34,0,0,0,.33-.34.25.25,0,0,0,0-.12v0l0,0,0,0v0c-.1-.18-.19-.48-.32-.78a1,1,0,0,1,.07.15c-.1-.37-.35-.72-.45-1.05a.82.82,0,0,1-.09-.19v0l0-.12,0,.1c0-.06-.07-.15-.11-.24v-.07c0-.09-.05-.06,0,0L16,29.24c0-.09-.11-.24-.11-.35a3.72,3.72,0,0,0-.27-.48s0,0,0,0a1.48,1.48,0,0,0-.12-.29v-.06l-.14-.2c0-.14-.05-.2,0-.08-.17-.3-.13-.25-.28-.51h0A2.2,2.2,0,0,1,15,27v0a.09.09,0,0,1,0-.05.14.14,0,0,1,0-.1l0,0,.1-.05.22-.11a2.83,2.83,0,0,0,.45-.32l.19-.19a1.4,1.4,0,0,0,.16-.2c-.11.08.18-.23.15-.28s.07-.1,0,0a2.25,2.25,0,0,0,.23-.66s0,.07,0,0a.28.28,0,0,1,0-.13s0,.05,0,.1a1,1,0,0,0,0-.3.13.13,0,0,0,0-.09.87.87,0,0,0,0-.36c0-.05.05-.14,0,.06,0-.06,0-.23,0-.39a.81.81,0,0,0,0-.31.54.54,0,0,0,0-.18,4.51,4.51,0,0,0,0-.52v.07a2.69,2.69,0,0,1,0-.4h0c0-.45,0-.19-.05-.64l0,0c-.05,0,0-.4-.14-.65v.1c0-.13-.06-.4-.12-.55s0,.05,0,.09c-.07-.19-.08-.19-.1-.19s0,0-.09-.1.07,0,0-.13a1.44,1.44,0,0,0-.22-.27c-.11-.12-.25-.24-.35-.34s.07.1,0,0l-.31-.22a.81.81,0,0,0-.33-.14l0,0a2.43,2.43,0,0,0-.59-.1,1.16,1.16,0,0,0-.52-.08c-.22,0-.42,0-.42,0H13a2.1,2.1,0,0,0-.5,0c-.07,0,0,0,0,0a3.94,3.94,0,0,0-.84,0l0,0c-.1,0-.62,0-1.05,0l.05,0a6.62,6.62,0,0,1-.77,0H9.68a.55.55,0,0,0-.18,0,.24.24,0,0,0-.2.22.36.36,0,0,0,0,.1v.24c0-.41,0,.06,0-.11,0,.16,0,.42,0,.22v0c-.05-.07,0,.51-.05.5,0,.8,0,1.58,0,2.33l0-.08V23c0,.07,0,.09,0-.09a.81.81,0,0,0,0,.31c0,.37,0-.14,0,0v.12a2.19,2.19,0,0,1,0,.36c0,.14,0,.07,0,.13v.42l0-.14c0,.15,0,.31,0,.16-.06.23,0,1.23,0,1.37a4.85,4.85,0,0,1,0,.66c0-.07,0-.1,0,.11-.06-.08,0,.4-.07.57,0-.15,0,.62.05.37,0,.18,0,0,0,.15,0,.43,0,.95,0,1.48,0,0,0-.08,0,0l0,.28c0,.1,0,.1,0,.29,0,0,0-.07,0,0,0,.52,0,1.05,0,1.58v.71a.22.22,0,0,0,0,.13.28.28,0,0,0,.22.14h.21l.4,0c-.14,0-.05,0,.06,0-.07,0,0,0,0,0l.44,0c.08,0,.47,0,.52,0H11c.19,0-.26-.09-.23-.14-.21.05-.55-.06-.89,0-.08,0,.06,0,0,0l-.15,0h-.2a.17.17,0,0,1-.1-.06s0,0,0-.05v-.07c0-.1,0-.2,0-.31s0-.41,0-.72l0,0a1.64,1.64,0,0,1,0-.22c0-.15,0,.37,0,.23s0-.93.05-1,0,.05,0-.15v0l0-.05c0-.14,0-.2,0-.2v.12c0-.17,0-.48,0-.54V29c0-.55,0-1.22,0-1.76v0c0-.4,0-.32,0-.77v0a1.82,1.82,0,0,1,0-.33c0,.11,0-.22,0-.07a2.22,2.22,0,0,0-.06-.51l0-.06a1.27,1.27,0,0,1,0-.34c0,.19,0-.14,0,.07.05-.47,0-.7,0-.91s0,.4,0,.28c0,.1,0-.18,0-.32s.06-.42.07-.63v.07c0-.14,0-.27,0-.45s0-.22,0-.25v.35a3.33,3.33,0,0,1,0-.7l0,.18c0-.09,0-.18,0-.28,0,.21,0,.42,0,.63,0-.1,0-.4,0-.29-.06-.15,0-.37,0-.62h0a1.23,1.23,0,0,1,0-.2l0,.14c0-.21,0-.4,0-.6,0,.41,0,.09,0,.27,0-.52.06-.3.05-.87,0,.08,0,.29,0,.17a1.66,1.66,0,0,1,0-.32c0-.38,0,.06,0-.1a1.35,1.35,0,0,0,0-.35h0c0-.44,0-.12,0-.5l0,.16V20l0,0a2.45,2.45,0,0,1,0-.25v-.15a0,0,0,0,1,0,0s0,0,0,0a.1.1,0,0,1,.1-.07c.12,0-.08,0,.2,0l-.1,0a.24.24,0,0,1-.12,0s0,0,0,0h.26l.4,0c.06,0,0,0,0,0h.25s0,0-.18.05l.37,0s.19,0,.14,0c.21,0,.51,0,.79,0h.1a5.34,5.34,0,0,0,.8,0l.17,0c.24,0-.23-.05.17-.06s.1,0,.2,0a2.29,2.29,0,0,1,.64,0h-.23m2.58.94a1,1,0,0,1-.13-.16c.06,0,.08.08.13.16m.58,4.27a.85.85,0,0,1,0-.17.85.85,0,0,1,0,.17M13.8,30.12h0c0,.12,0,.08,0,0m-.09-.25h0l.06.14a.5.5,0,0,0,0-.13M9.27,23.75V23.7c0,.12,0,.08,0,.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4549",
    "data-name": "Path 4549",
    className: "cls-3",
    d: "M16.59,24.23a0,0,0,0,1,0,0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4551",
    "data-name": "Path 4551",
    className: "cls-3",
    d: "M16.52,31.86h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4552",
    "data-name": "Path 4552",
    className: "cls-3",
    d: "M13.16,28.58l.07.15a.58.58,0,0,1-.05-.14s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4553",
    "data-name": "Path 4553",
    className: "cls-3",
    d: "M12.77,27.14a.16.16,0,0,0,0-.07h0c0,.09.07.16,0,.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4554",
    "data-name": "Path 4554",
    className: "cls-3",
    d: "M13.18,28.4a.66.66,0,0,0-.08-.23v0s0,.1.07.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4555",
    "data-name": "Path 4555",
    className: "cls-3",
    d: "M13.09,28.15a.3.3,0,0,0,0-.1s0,0,0,.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4556",
    "data-name": "Path 4556",
    className: "cls-3",
    d: "M13.58,29.57c0-.06,0,0,0-.06s.16.34,0,.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4557",
    "data-name": "Path 4557",
    className: "cls-3",
    d: "M13.21,28.29v0l0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4558",
    "data-name": "Path 4558",
    className: "cls-3",
    d: "M13.53,29.17,13.47,29l0,0,.09.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4559",
    "data-name": "Path 4559",
    className: "cls-3",
    d: "M13.45,29l-.06-.15a.58.58,0,0,0,.06.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4560",
    "data-name": "Path 4560",
    className: "cls-3",
    d: "M13.31,28.53l0,0,.05.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4561",
    "data-name": "Path 4561",
    className: "cls-3",
    d: "M14.27,31.08l.08.19s0,0,0-.1-.05-.12-.05-.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4562",
    "data-name": "Path 4562",
    className: "cls-3",
    d: "M14.11,30.47a.28.28,0,0,1,0,.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4563",
    "data-name": "Path 4563",
    className: "cls-3",
    d: "M14.34,31s.13.28,0,0c0,0-.1-.21,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4564",
    "data-name": "Path 4564",
    className: "cls-3",
    d: "M16.84,31.94h-.05V32a.21.21,0,0,0,0-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4565",
    "data-name": "Path 4565",
    className: "cls-3",
    d: "M15.9,29.5c.09.23,0,0,.13.25,0,.05-.06-.17,0-.12-.07-.13-.09-.21-.1-.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4566",
    "data-name": "Path 4566",
    className: "cls-3",
    d: "M16,29.63l0,.07,0-.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4567",
    "data-name": "Path 4567",
    className: "cls-3",
    d: "M11,32.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4568",
    "data-name": "Path 4568",
    className: "cls-3",
    d: "M11.25,32.05l0,0,.1,0h-.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4569",
    "data-name": "Path 4569",
    className: "cls-3",
    d: "M16.13,20.84h0a.67.67,0,0,0-.06-.12.49.49,0,0,1,0,.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4570",
    "data-name": "Path 4570",
    className: "cls-3",
    d: "M14.6,19.66h0l-.06-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4571",
    "data-name": "Path 4571",
    className: "cls-3",
    d: "M12.83,19.58h.24c-.17,0-.26,0-.24,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4572",
    "data-name": "Path 4572",
    className: "cls-3",
    d: "M19,19.39h1.79a.22.22,0,0,1,.22.22h0V31.74a.22.22,0,0,1-.22.22H19a.22.22,0,0,1-.23-.22V19.61a.22.22,0,0,1,.23-.22h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4573",
    "data-name": "Path 4573",
    className: "cls-3",
    d: "M19,19.39h1.79a.22.22,0,0,1,.22.22h0V31.74a.22.22,0,0,1-.22.22H19a.22.22,0,0,1-.23-.22V19.61a.22.22,0,0,1,.23-.22h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4574",
    "data-name": "Path 4574",
    className: "cls-3",
    d: "M18.94,19.27c.07,0,0,0,.06,0s-.05,0-.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4575",
    "data-name": "Path 4575",
    className: "cls-3",
    d: "M18.7,20h0l0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4576",
    "data-name": "Path 4576",
    className: "cls-3",
    d: "M18.7,20.68c0-.07,0-.24,0-.36v0l0-.06c0,.15,0,.34,0,.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4577",
    "data-name": "Path 4577",
    className: "cls-3",
    d: "M18.62,21s0,.08,0-.08h0V21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4578",
    "data-name": "Path 4578",
    className: "cls-3",
    d: "M18.62,21c0-.07,0,.05,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4579",
    "data-name": "Path 4579",
    className: "cls-3",
    d: "M18.63,21.29V21.2s0,.1,0,.07,0,.07,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4580",
    "data-name": "Path 4580",
    className: "cls-3",
    d: "M18.66,21.38v-.05a.11.11,0,0,0,0,.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4581",
    "data-name": "Path 4581",
    className: "cls-3",
    d: "M18.64,21.23v.1s0,0,0,0,0,0,0-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4582",
    "data-name": "Path 4582",
    className: "cls-3",
    d: "M18.64,21.17c0-.05,0-.12,0,0,0-.17,0-.15,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4583",
    "data-name": "Path 4583",
    className: "cls-3",
    d: "M18.74,20.71v-.13s0,.14,0,.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4584",
    "data-name": "Path 4584",
    className: "cls-3",
    d: "M18.61,21.86s0,0,0,0v-.07s0,.1,0,.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4585",
    "data-name": "Path 4585",
    className: "cls-3",
    d: "M18.64,21.83v.1c0-.09,0-.11,0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4586",
    "data-name": "Path 4586",
    className: "cls-3",
    d: "M18.7,21.39l0-.17,0,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4587",
    "data-name": "Path 4587",
    className: "cls-3",
    d: "M18.61,22.25l0-.05,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4588",
    "data-name": "Path 4588",
    className: "cls-3",
    d: "M18.61,22.51s0,.06,0,0a.58.58,0,0,0,0,.19.67.67,0,0,1,0-.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4589",
    "data-name": "Path 4589",
    className: "cls-3",
    d: "M18.62,22.8s0-.06,0-.09a.28.28,0,0,0,0,.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4590",
    "data-name": "Path 4590",
    className: "cls-3",
    d: "M18.65,22.1a.24.24,0,0,0,0,.08l0,0v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4592",
    "data-name": "Path 4592",
    className: "cls-3",
    d: "M18.65,22.09h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4593",
    "data-name": "Path 4593",
    className: "cls-3",
    d: "M18.68,21.66c0,.06,0,.19,0,.06s0,0,0-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4594",
    "data-name": "Path 4594",
    className: "cls-3",
    d: "M18.68,22v-.11s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4595",
    "data-name": "Path 4595",
    className: "cls-3",
    d: "M18.68,22.1v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4596",
    "data-name": "Path 4596",
    className: "cls-3",
    d: "M18.64,22.62a.76.76,0,0,1,0,.15c0-.06,0-.12,0-.19s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4599",
    "data-name": "Path 4599",
    className: "cls-3",
    d: "M18.66,22.57a.34.34,0,0,0,0-.1v.11h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4600",
    "data-name": "Path 4600",
    className: "cls-3",
    d: "M18.63,23s0-.05,0-.08a.22.22,0,0,0,0,.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4602",
    "data-name": "Path 4602",
    className: "cls-3",
    d: "M18.64,22.41s0,0,0,.06a.17.17,0,0,0,0-.07h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4603",
    "data-name": "Path 4603",
    className: "cls-3",
    d: "M18.79,23.51a.3.3,0,0,1,0-.23c0-.1-.09,0-.12,0s0,0,0,.11c0,0,0-.24,0-.14a.37.37,0,0,1,0,.18c0-.06,0,.18.08.15l0-.12s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4604",
    "data-name": "Path 4604",
    className: "cls-3",
    d: "M18.66,23.13v-.05a.41.41,0,0,1,0,.16c0,.07,0,.09,0,.09v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4605",
    "data-name": "Path 4605",
    className: "cls-3",
    d: "M18.66,22.89s0,.14.05.07,0-.09,0-.17c0,.21,0-.06,0,.09a.41.41,0,0,0,0-.11.41.41,0,0,1,0,.11h0c0,.06,0,0,0,0h0l0,.21v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4606",
    "data-name": "Path 4606",
    className: "cls-3",
    d: "M18.77,21.84h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4607",
    "data-name": "Path 4607",
    className: "cls-3",
    d: "M18.75,21.92a.17.17,0,0,1,0-.07c0-.05,0,0,0,0s0-.1,0,0v0a1.16,1.16,0,0,1,0,.18l.05-.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4608",
    "data-name": "Path 4608",
    className: "cls-3",
    d: "M18.71,22.41v.17l0-.08h0c0-.1,0-.08,0-.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4609",
    "data-name": "Path 4609",
    className: "cls-3",
    d: "M18.64,23.36l0,0,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4610",
    "data-name": "Path 4610",
    className: "cls-3",
    d: "M18.64,23.59h0l0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4611",
    "data-name": "Path 4611",
    className: "cls-3",
    d: "M20.89,29.6v-.05a.43.43,0,0,1,0,.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4612",
    "data-name": "Path 4612",
    className: "cls-3",
    d: "M20.89,30h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4613",
    "data-name": "Path 4613",
    className: "cls-3",
    d: "M18.65,29.15c0,.07,0,.16,0,.15l0,0a.28.28,0,0,1,0-.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4614",
    "data-name": "Path 4614",
    className: "cls-3",
    d: "M19.87,32h0l-.05,0,.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4615",
    "data-name": "Path 4615",
    className: "cls-3",
    d: "M19.92,31.86l.1,0-.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4616",
    "data-name": "Path 4616",
    className: "cls-3",
    d: "M20.87,27.57l0-.06c0,.1,0,.06,0,.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4617",
    "data-name": "Path 4617",
    className: "cls-3",
    d: "M18.65,25.91c0,.05,0,.1,0,.16s0-.14,0-.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4618",
    "data-name": "Path 4618",
    className: "cls-3",
    d: "M21.12,29.74a.06.06,0,0,0,0,0s0,.05,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4619",
    "data-name": "Path 4619",
    className: "cls-3",
    d: "M18.64,26.25v0a.76.76,0,0,1,0-.15.54.54,0,0,0,0,.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4621",
    "data-name": "Path 4621",
    className: "cls-3",
    d: "M19.62,19.29h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4623",
    "data-name": "Path 4623",
    className: "cls-3",
    d: "M18.72,24.27a0,0,0,0,0,0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4625",
    "data-name": "Path 4625",
    className: "cls-3",
    d: "M18.65,24.43a.13.13,0,0,1,0,.06.18.18,0,0,1,0-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4626",
    "data-name": "Path 4626",
    className: "cls-3",
    d: "M18.64,24.44v-.05s0,0,0,.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4628",
    "data-name": "Path 4628",
    className: "cls-3",
    d: "M20.94,24.17h0c0-.05,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4630",
    "data-name": "Path 4630",
    className: "cls-3",
    d: "M18.89,30.57a.32.32,0,0,1,0-.17l-.07.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4631",
    "data-name": "Path 4631",
    className: "cls-3",
    d: "M20.88,28.71l0,.12c0-.14,0-.25-.05-.14s0,.48.08.49l0,.08v-.05c0,.16.05.12,0,.32s0,.12,0,.07l0,.15c0,.05,0,0,0,0V30h0l0,.15c0,.06,0,0,0,0l0,.13c0,.06,0,0,0-.14-.06.12,0,.11,0,.37v-.12a1.67,1.67,0,0,0-.05.31s.06-.28.08-.13a.5.5,0,0,0,0,.17s0,.07,0,.17h0a.42.42,0,0,0,0,.15.22.22,0,0,1,0,.17c0,.18,0-.13,0,.09a2.07,2.07,0,0,0,0,.43c0,.1,0,0,0,0a0,0,0,0,0,0,0s0,0,0,0h0a0,0,0,0,0,0,0,0,0,0,0,1,0,.05s0,0,0,0h-.08a.53.53,0,0,0-.25,0s0,0,0,0l-.35,0-.15,0c.11,0,0,.05-.15.08l.1,0h-.2s0,0,0,0h0c-.07,0,0,0,0-.05l.07,0s.09,0,.08-.06h0s0,0-.06,0l0,0v0l-.25,0-.27.06-.16,0a.31.31,0,0,1-.19,0c.07,0,0,0,.05-.06s0,0,0,0h.3c-.08,0-.06,0-.05,0l-.25,0s0,0-.06-.05,0,0-.06,0a.19.19,0,0,1,0-.07.28.28,0,0,0,0-.1s0,0,0,0a.09.09,0,0,1,0,.05v.06s0,0,0,0v0a.64.64,0,0,1,0-.07.23.23,0,0,1,0-.16s0,.05,0,.06,0-.26,0-.22v0a2.57,2.57,0,0,0,0-.68s0,0,.06,0l-.15-.38s.13-.1.15.08a.81.81,0,0,0,0-.22s-.05.08-.06,0a1.29,1.29,0,0,0,.06-.25c0,.05-.07,0-.07-.09s.06,0,.07,0l-.06-.2c0,.05.05,0,.06,0a1.61,1.61,0,0,1,0-.23v.09c0-.23-.08-.23-.08-.46,0,0,.08.07.08,0a1.31,1.31,0,0,1-.16-.43l0,0,0-.16a3.16,3.16,0,0,1,.17.52.39.39,0,0,0,0-.15c0-.05,0,.07,0,.1v-.3s0-.23-.07-.22l0,.33s-.1-.19-.09-.4c0-.05.06,0,.07,0a.86.86,0,0,1,0-.22l0,.09c0-.12,0-.2,0-.34s0-.15,0-.16-.16.1-.19,0a2.85,2.85,0,0,1,.06-.32c0-.08.07.12.1.06s0-.05,0-.07,0,0,0-.09,0-.23,0-.05a2.26,2.26,0,0,1,0-.25s-.08-.12-.09-.23,0,0,0,0c0-.22,0-.34,0-.55,0,0,0-.12,0-.08a.5.5,0,0,1,0-.12c0-.13,0,.14,0,.05a1.27,1.27,0,0,1,0-.26s0,.21,0,.3-.09-.16-.11-.38,0-.08,0-.11c0-.32-.07-.27,0-.55,0-.1.05,0,.07,0s0,.21,0,.32v-.12a.61.61,0,0,1,0,.19c0-.09,0-.55,0-.8,0-.05,0-.13,0-.09v.08c0,.07,0-.15,0-.05a1.2,1.2,0,0,1,0-.38l0,0a.38.38,0,0,0,0,.15c0-.07,0-.24,0-.3l0,.1a1.55,1.55,0,0,1,0-.37c0,.06,0,0,0,.12,0-.08,0,.35,0,.21,0,.1,0,.2-.05.3s0,0,0,.07v0h0s0,0,0-.05a1.36,1.36,0,0,1,0,.29c0,.07,0,0,0,0l0,.09s0,.18-.05,0v.14a.82.82,0,0,0,0,.27.49.49,0,0,0,0,.11v.22h0a4.09,4.09,0,0,1,0,.7,2.53,2.53,0,0,1,0,.28l0,0a1.71,1.71,0,0,0,0,.32,2.66,2.66,0,0,0,0,.63h0c0,.11,0,.22,0,.36h0a4.61,4.61,0,0,1,0,.51.17.17,0,0,1,0-.1c-.05.23,0,.49,0,.7a.29.29,0,0,1,0,.13h0v.09s0,0,0-.06a1,1,0,0,0,0,.16l0,0h0c0,.06,0,.05,0,0a.25.25,0,0,0,0,.08s0,.15,0,.22,0,.3.06.33,0,0,0,0a.61.61,0,0,0,0,.19l0,0,0,.15c0,.09,0,.12-.05,0,0,.22,0,.18.05.36h0a1.48,1.48,0,0,1,0,.21,2.33,2.33,0,0,0,0,.46v.4a.36.36,0,0,0,0,.11.29.29,0,0,0,.13.16c0-.05,0,0,.09,0s.13,0,.14,0,.08,0,0,0a2.88,2.88,0,0,0,.41,0s0,0,0,0h.08s0,0-.06,0c.2,0,.22,0,.23-.09A.33.33,0,0,0,20,32s.09,0,0,0a1.48,1.48,0,0,0,.42,0h.38l.11,0a.21.21,0,0,0,.15-.07h0a.21.21,0,0,0,.09-.15v-.06a1.34,1.34,0,0,1,0-.2l0,0c-.05,0,0-.24,0-.4v.06c0-.09.07-.25.07-.33s0,0,0,.05c0-.22,0,0,0-.2s0,0,0-.07a2.57,2.57,0,0,1,0-.48s0,.06,0,0a1.62,1.62,0,0,0,0-.44,0,0,0,0,1,0,0,2,2,0,0,0,0-.35c.08-.09,0-.57,0-.57V28.5h0a1.1,1.1,0,0,0,0-.31s0,0,0,0a1.51,1.51,0,0,0,0-.52l0,0c0-.06,0-.38,0-.64a0,0,0,0,1,0,0c0-.29.07-.7,0-.8l0-.19c0,.25,0,0-.06.06,0-.1,0-.25,0-.13v0c.05,0,0-.31.05-.3,0-.49,0-1,0-1.43l0,.06v-.16c0-.05,0-.06,0,.05a.32.32,0,0,0,0-.19c0-.22,0,.09,0,0V24a.44.44,0,0,1,0-.22c0-.09,0-.05,0-.08v-.25l0,.08c0-.09,0-.19,0-.1a5.9,5.9,0,0,0,0-.84,2.64,2.64,0,0,1,0-.4s0,.06,0-.07c.07.05,0-.24.08-.35,0,.1,0-.37-.05-.22,0-.11,0,0,0-.09,0-.26,0-.58,0-.9,0,0,0,.05,0,0l0-.17c0-.07-.05-.06,0-.18s0,0,0,0,0-.32,0-.48v-.06a.19.19,0,0,0,0-.08.28.28,0,0,0-.22-.22h-.14a6.38,6.38,0,0,1-1,0c.09,0,0,0,0,0s0,0,0,0l-.27,0c-.05,0-.29,0-.32,0h.09c-.11,0,.16.08.14.13s.34.07.55,0c0,0,0,0,0,0a.65.65,0,0,1,.24,0h.69a.09.09,0,0,1,.06,0v0a.09.09,0,0,1,0,.07s0,0,0,0-.06-.05,0-.05l0,.08s0,0,0,.06v.1a.8.8,0,0,1,0,.31c0,.12,0,0,0,.09v0l0,0c0,.08,0,.12,0,.12v-.07a1.82,1.82,0,0,0,0,.33v-.12c0,.34,0,.75,0,1.07l0,0c0,.25,0,.2,0,.47h0a1.34,1.34,0,0,1,0,.2c0-.07,0,.13,0,0a.81.81,0,0,0,.06.31l0,0a.69.69,0,0,1,0,.2c0-.11,0,.09-.05,0,0,.29,0,.43,0,.56s0-.25,0-.17,0,.1,0,.2a1.59,1.59,0,0,0-.07.38v-.05a2.61,2.61,0,0,1,0,.28c0,.06,0,.14,0,.15v-.21a2.09,2.09,0,0,1,0,.43.45.45,0,0,1,0-.11c0,.05,0,.11,0,.17s0-.26,0-.39c0,.07,0,.25,0,.18.05.09,0,.23,0,.38h0a.49.49,0,0,1,0,.12l0-.08a2.26,2.26,0,0,1,0,.37c0-.26,0-.06.05-.17,0,.31-.06.18-.05.53,0-.05,0-.18,0-.1l0,.2c0,.23,0,0,0,.06s0,.12,0,.22h0c0,.26.05.07,0,.31l0-.1V26l0,0a1,1,0,0,1,0,.3s.05,0,.05.14,0-.05,0,.12a.16.16,0,0,1,0-.15l0-.05a1.31,1.31,0,0,0,0,.28.13.13,0,0,1,0-.06l0,.24s0,0,0,0,0,.09,0,.16,0,0-.05-.12l0,.23s0,.12,0,.09c0,.13,0,.31,0,.48,0,0,0,0,0,.06a2,2,0,0,0,0,.49l0,.1c0,.15.05-.14.06.1s0,.07,0,.13a1.29,1.29,0,0,1,0,.39.66.66,0,0,1,0-.14m0,1.81s0-.1,0-.13,0,.07,0,.13m-1.3,1.39h0M18.71,25h0c0,.08,0,.05,0,0m0-.16h0V25a.11.11,0,0,0,0-.08m2.44-1.21v0c0-.07,0-.05,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4632",
    "data-name": "Path 4632",
    className: "cls-3",
    d: "M19.91,31.87s0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4633",
    "data-name": "Path 4633",
    className: "cls-3",
    d: "M20.87,27.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4634",
    "data-name": "Path 4634",
    className: "cls-3",
    d: "M18.87,27.38a.13.13,0,0,1,0,.06s0,0,0-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4635",
    "data-name": "Path 4635",
    className: "cls-3",
    d: "M18.63,24v.1a.28.28,0,0,1,0-.09s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4636",
    "data-name": "Path 4636",
    className: "cls-3",
    d: "M18.78,23.1v-.05h0c0,.07,0,.11,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4637",
    "data-name": "Path 4637",
    className: "cls-3",
    d: "M18.71,23.91s0-.08,0-.15h0s0,.06,0,.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4639",
    "data-name": "Path 4639",
    className: "cls-3",
    d: "M18.65,24.66s0,0,0,0,0,.23,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4640",
    "data-name": "Path 4640",
    className: "cls-3",
    d: "M18.77,23.85l0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4641",
    "data-name": "Path 4641",
    className: "cls-3",
    d: "M18.76,24.42v-.11a0,0,0,0,0,0,0v.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4642",
    "data-name": "Path 4642",
    className: "cls-3",
    d: "M18.76,24.28v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4643",
    "data-name": "Path 4643",
    className: "cls-3",
    d: "M18.78,24v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4644",
    "data-name": "Path 4644",
    className: "cls-3",
    d: "M18.75,25.67v.13s0,0,0-.07,0-.08,0-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4645",
    "data-name": "Path 4645",
    className: "cls-3",
    d: "M18.82,25.29a.14.14,0,0,1,0,.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4646",
    "data-name": "Path 4646",
    className: "cls-3",
    d: "M18.83,25.66s0,.19,0,0c0,0,0-.14,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4647",
    "data-name": "Path 4647",
    className: "cls-3",
    d: "M18.79,27.58v0h-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4648",
    "data-name": "Path 4648",
    className: "cls-3",
    d: "M18.91,29.26c0-.15,0,0,0-.17s0,.11,0,.08,0,.14,0,.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4649",
    "data-name": "Path 4649",
    className: "cls-3",
    d: "M18.87,29.17v-.05a.09.09,0,0,1,0,.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4650",
    "data-name": "Path 4650",
    className: "cls-3",
    d: "M19.26,19.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4651",
    "data-name": "Path 4651",
    className: "cls-3",
    d: "M19.08,19.3l0,0-.05,0h.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4652",
    "data-name": "Path 4652",
    className: "cls-3",
    d: "M20.83,30.79h0a.28.28,0,0,0,0-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4653",
    "data-name": "Path 4653",
    className: "cls-3",
    d: "M20.86,29.48v0l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4654",
    "data-name": "Path 4654",
    className: "cls-3",
    d: "M20.82,28.37v.15c0-.1,0-.16,0-.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4655",
    "data-name": "Path 4655",
    className: "cls-3",
    d: "M30.42,28.52a.24.24,0,0,1,.19.23,3.3,3.3,0,0,1-3.74,3.41,3.24,3.24,0,0,1-3.09-1.52,6.49,6.49,0,0,1-.68-3.57V24.32c0-1.94.22-3,.83-3.78a3.24,3.24,0,0,1,2.94-1.3c2.29,0,3.42,1.11,3.58,3.51a.24.24,0,0,1-.2.24l-1.62.13a.21.21,0,0,1-.24-.18c-.15-1.05-.61-1.52-1.48-1.52-1.19,0-1.57.75-1.57,3.11v2.33c0,2.37.38,3.11,1.58,3.11.93,0,1.43-.48,1.58-1.51a.22.22,0,0,1,.25-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4656",
    "data-name": "Path 4656",
    className: "cls-3",
    d: "M30.42,28.52a.24.24,0,0,1,.19.23,3.3,3.3,0,0,1-3.74,3.41,3.24,3.24,0,0,1-3.09-1.52,6.49,6.49,0,0,1-.68-3.57V24.32c0-1.94.22-3,.83-3.78a3.24,3.24,0,0,1,2.94-1.3c2.29,0,3.42,1.11,3.58,3.51a.24.24,0,0,1-.2.24l-1.62.13a.21.21,0,0,1-.24-.18c-.15-1.05-.61-1.52-1.48-1.52-1.19,0-1.57.75-1.57,3.11v2.33c0,2.37.38,3.11,1.58,3.11.93,0,1.43-.48,1.58-1.51a.22.22,0,0,1,.25-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4657",
    "data-name": "Path 4657",
    className: "cls-3",
    d: "M30.38,28.39c.07,0,.05,0,.06,0s-.06,0-.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4658",
    "data-name": "Path 4658",
    className: "cls-3",
    d: "M29.2,28.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4659",
    "data-name": "Path 4659",
    className: "cls-3",
    d: "M28.36,28.75a.72.72,0,0,0,.07-.25.31.31,0,0,1,.06-.19.21.21,0,0,1,.23-.1h.1a.4.4,0,0,0-.24,0,.27.27,0,0,0-.15.21,3,3,0,0,1-.07.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4660",
    "data-name": "Path 4660",
    className: "cls-3",
    d: "M28.09,29.24s-.05.11.06-.11v0l-.05.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4661",
    "data-name": "Path 4661",
    className: "cls-3",
    d: "M28.14,29.15c0-.1,0,.06,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4662",
    "data-name": "Path 4662",
    className: "cls-3",
    d: "M27.85,29.53a.28.28,0,0,0,.09-.1l-.06.05s0,0,0,0-.07.09,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4663",
    "data-name": "Path 4663",
    className: "cls-3",
    d: "M27.77,29.63l.05,0a.1.1,0,0,0-.05,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4664",
    "data-name": "Path 4664",
    className: "cls-3",
    d: "M27.93,29.48l-.1.11s0,0,.05-.05,0,0,.05-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4665",
    "data-name": "Path 4665",
    className: "cls-3",
    d: "M28,29.42c.05-.06.12-.14,0,0,.09-.1.1-.17.09-.16l-.13.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4666",
    "data-name": "Path 4666",
    className: "cls-3",
    d: "M28.39,28.82l0-.11s0-.07,0-.1-.06.21,0,.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4667",
    "data-name": "Path 4667",
    className: "cls-3",
    d: "M27.06,29.8s.05,0,.06,0l.1,0h-.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4668",
    "data-name": "Path 4668",
    className: "cls-3",
    d: "M27.12,29.83l-.16,0c.14,0,.17,0,.16,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4669",
    "data-name": "Path 4669",
    className: "cls-3",
    d: "M27.77,29.68A1.53,1.53,0,0,0,28,29.5a1.1,1.1,0,0,1-.22.21l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4670",
    "data-name": "Path 4670",
    className: "cls-3",
    d: "M26.47,29.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4671",
    "data-name": "Path 4671",
    className: "cls-3",
    d: "M26.13,29.61s0,0,0,0,0,0,0,0L26,29.49l-.09-.08.09.1a.55.55,0,0,0,.11.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4672",
    "data-name": "Path 4672",
    className: "cls-3",
    d: "M25.85,29.31a.81.81,0,0,0,.09.1l-.09-.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4673",
    "data-name": "Path 4673",
    className: "cls-3",
    d: "M26.69,29.83a.27.27,0,0,0-.12,0l.05,0h.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4674",
    "data-name": "Path 4674",
    className: "cls-3",
    d: "M26.63,29.83h0l-.14,0,.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4675",
    "data-name": "Path 4675",
    className: "cls-3",
    d: "M26.7,29.84h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4676",
    "data-name": "Path 4676",
    className: "cls-3",
    d: "M27.38,29.82c-.09,0-.29.08-.09.06s-.05,0,.09-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4677",
    "data-name": "Path 4677",
    className: "cls-3",
    d: "M26.78,29.87H27s0,0,0,0h-.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4678",
    "data-name": "Path 4678",
    className: "cls-3",
    d: "M26.69,29.87h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4679",
    "data-name": "Path 4679",
    className: "cls-3",
    d: "M26,29.54l-.08-.08a.36.36,0,0,1-.07-.1l.08.12,0,.05.05,0s.05,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4680",
    "data-name": "Path 4680",
    className: "cls-3",
    d: "M26.27,29.73h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4682",
    "data-name": "Path 4682",
    className: "cls-3",
    d: "M26,29.59a.34.34,0,0,0,.12.09l-.07,0L26,29.58h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4683",
    "data-name": "Path 4683",
    className: "cls-3",
    d: "M25.74,29.09l0,.12,0-.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4684",
    "data-name": "Path 4684",
    className: "cls-3",
    d: "M26.24,29.71h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4685",
    "data-name": "Path 4685",
    className: "cls-3",
    d: "M26.24,29.71l-.09,0,.1.05,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4686",
    "data-name": "Path 4686",
    className: "cls-3",
    d: "M25.38,28.25a1.09,1.09,0,0,1,.08.39c.06.17.09,0,.1-.11s0,0-.06-.17c0,.06,0,.39,0,.24a1.45,1.45,0,0,1,0-.3c0,.1-.07-.29-.1-.23l0,.2s0-.07,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4687",
    "data-name": "Path 4687",
    className: "cls-3",
    d: "M25.63,28.85l0,.07a1,1,0,0,1,0-.24.72.72,0,0,0-.06-.15,3.38,3.38,0,0,0,.08.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4688",
    "data-name": "Path 4688",
    className: "cls-3",
    d: "M25.76,29.21s-.12-.19-.1-.09a.68.68,0,0,0,.14.23c-.16-.28.05.08,0-.14,0,.06.06.1.08.15l-.07-.15h0a0,0,0,0,1,0,0c0-.08,0,0,0,0h0l-.07-.14c0-.05,0-.1-.05-.16a1,1,0,0,0,.11.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4689",
    "data-name": "Path 4689",
    className: "cls-3",
    d: "M27.11,30h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4690",
    "data-name": "Path 4690",
    className: "cls-3",
    d: "M27,30l.13,0c.07,0,0,0,0,0s.16,0,0,0h0a.92.92,0,0,1-.29,0A.49.49,0,0,0,27,30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4691",
    "data-name": "Path 4691",
    className: "cls-3",
    d: "M26.21,29.77a1.14,1.14,0,0,1-.23-.15.32.32,0,0,0,.1.1h0c.13.09.11.06.13.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4692",
    "data-name": "Path 4692",
    className: "cls-3",
    d: "M25.57,28.48l0,0-.06-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4693",
    "data-name": "Path 4693",
    className: "cls-3",
    d: "M25.52,28.12h0l0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4694",
    "data-name": "Path 4694",
    className: "cls-3",
    d: "M24.07,20.54l0,.07s0-.05,0-.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4695",
    "data-name": "Path 4695",
    className: "cls-3",
    d: "M24.48,20.11v0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4696",
    "data-name": "Path 4696",
    className: "cls-3",
    d: "M28.09,22.29a1.45,1.45,0,0,0,.05.23v0a1.45,1.45,0,0,0-.06-.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4697",
    "data-name": "Path 4697",
    className: "cls-3",
    d: "M29.14,19.84l0,0,.08,0-.11-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4698",
    "data-name": "Path 4698",
    className: "cls-3",
    d: "M29,19.86l-.13-.1.13.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4699",
    "data-name": "Path 4699",
    className: "cls-3",
    d: "M23.25,23.66l0,.1c0-.16,0-.09,0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4700",
    "data-name": "Path 4700",
    className: "cls-3",
    d: "M25.46,24.28a2.54,2.54,0,0,0,0-.26.75.75,0,0,0,0,.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4701",
    "data-name": "Path 4701",
    className: "cls-3",
    d: "M24.05,20.21l0,.06,0-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4702",
    "data-name": "Path 4702",
    className: "cls-3",
    d: "M25.49,23.71a.13.13,0,0,1,0,.06V24a1.58,1.58,0,0,0,0-.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4703",
    "data-name": "Path 4703",
    className: "cls-3",
    d: "M28.29,31.85h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4704",
    "data-name": "Path 4704",
    className: "cls-3",
    d: "M30.63,29.46l0,.15a.75.75,0,0,0,0-.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4706",
    "data-name": "Path 4706",
    className: "cls-3",
    d: "M25.39,27a0,0,0,0,0,0,0,.1.1,0,0,1,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4707",
    "data-name": "Path 4707",
    className: "cls-3",
    d: "M25.43,22.92h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4708",
    "data-name": "Path 4708",
    className: "cls-3",
    d: "M25.46,26.74v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4709",
    "data-name": "Path 4709",
    className: "cls-3",
    d: "M25.47,26.72v.07s0,0,0-.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4711",
    "data-name": "Path 4711",
    className: "cls-3",
    d: "M23.34,29.29v0c0,.07,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4713",
    "data-name": "Path 4713",
    className: "cls-3",
    d: "M29.92,22.89a.66.66,0,0,1-.28,0l.1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4714",
    "data-name": "Path 4714",
    className: "cls-3",
    d: "M23.46,21.82l.07-.19c0,.24-.08.4,0,.23,0,0,0-.21.08-.38a1.54,1.54,0,0,0,.12-.38l.07-.1a.21.21,0,0,0,0,.07.75.75,0,0,0,.1-.2.5.5,0,0,1,.13-.25c.07-.09.13-.14.08-.08l.15-.2c.05-.06.05,0,0,0l.13-.14.14-.13h0a1.29,1.29,0,0,1,.16-.18c.08-.05,0,0,0,0l.16-.13c.08,0-.06.07-.17.16a.5.5,0,0,0,.19-.1l.11-.08a.88.88,0,0,1,.22-.1,1,1,0,0,0-.17.1c.13,0,.26-.11.47-.16-.05,0-.43.11-.23,0l.25-.1s.12,0,.27-.05v0a.92.92,0,0,0,.23-.09.42.42,0,0,1,.27,0c.29,0-.21,0,.14-.06s.41,0,.71,0,0,0,0,0l.15,0s0,0,0,0,0,0,.22,0a3.74,3.74,0,0,1,.65.13c.05,0,0,0,0,0l.3.07.25.07.2.13c-.14-.1.08,0,.25.07L29,19.73a1.59,1.59,0,0,1,.27.18s0,0-.05,0l.05,0c.08.09,0,.06-.05,0l-.08-.08c-.08,0-.15-.05-.15,0l.09.05s0,0,0,0a.2.2,0,0,0,.08,0l0,.08h0l.15.14a.93.93,0,0,1,.13.15,2.34,2.34,0,0,1,.31.32,2.24,2.24,0,0,1,.3.49c-.07-.1-.05,0-.08,0a.94.94,0,0,0-.1-.23l-.19-.29c.07.1,0,.09,0,.06.08.12.15.24.22.37s0,.09.05.2c0,0,0,0,.09.13s.08.24.1.33,0,0,0,0l-.06-.2a.87.87,0,0,0,.08.26.73.73,0,0,1,.08.25l0-.1a1.07,1.07,0,0,1,0,.35v-.05c0,.09,0,.2,0,.31v.27a.06.06,0,0,1,0,.06.13.13,0,0,1-.05.09.21.21,0,0,1-.1,0,.26.26,0,0,0-.15,0,.19.19,0,0,1,.06-.07l-.62.2c.06,0-.16-.11.13-.16a2.21,2.21,0,0,0-.37,0c.06,0,.15,0,.07.05a2.62,2.62,0,0,0-.42,0c.09,0,0,.06-.14.07,0,0,0,0,0-.06l-.17,0a.33.33,0,0,1-.14,0c.07,0,0,0,0-.08s0,0,0-.07a2,2,0,0,0,0-.24.66.66,0,0,1,0,.14.85.85,0,0,0-.12-.37,3.06,3.06,0,0,1-.18-.34s.05,0,.06,0,0-.05,0-.14a3.51,3.51,0,0,0-.23-.17,2.14,2.14,0,0,0-.4-.2l-.05,0-.24,0a1.29,1.29,0,0,1,.39,0,1.12,1.12,0,0,1,.42.25c-.09-.12,0-.05-.18-.21s.12.06.16.12a1.35,1.35,0,0,0-.45-.33s-.1,0-.2,0-.2,0-.2,0a1.21,1.21,0,0,1,.56.16s-.08,0-.21,0a2.67,2.67,0,0,0-.48-.08c-.09,0,.07-.06.07-.07h-.39l.16,0a2.8,2.8,0,0,0-.58.09.59.59,0,0,0-.17,0c-.05,0-.1,0-.1.05.15,0,.22.07.15.13a.93.93,0,0,0-.2.1l-.13.1-.08.08c-.11.09.07-.21,0-.13a.53.53,0,0,1-.06.1c0,.07,0-.05-.1.13s-.16.35,0,.09l-.08.18a1.65,1.65,0,0,0-.07.21c0-.06,0,.21,0,.39l0,0a7.19,7.19,0,0,0-.1.92s0,.2,0,.13a1.49,1.49,0,0,1,0,.21c0,.2,0-.25,0-.09a3.25,3.25,0,0,1,0,.44,2.17,2.17,0,0,0,0-.51,1.49,1.49,0,0,1,.1.63c0,.29,0,.13,0,.18,0,.54.07.46,0,.91,0,.18-.05,0-.07.05,0-.24,0-.36,0-.52l0,.2c0-.11,0-.21,0-.32,0,.15,0,.92,0,1.34,0,.07,0,.2,0,.14V26.5c0-.12,0,.25,0,.08q0,.32,0,.63l0,0a1.69,1.69,0,0,0,0-.23,1.68,1.68,0,0,0,0,.5v-.18c0,.18.06.4.07.62,0-.1,0-.05,0-.21,0,.14,0-.56-.06-.34,0-.16,0-.28,0-.49,0,0,0,.07,0-.11a.08.08,0,0,1,0,0h0a.44.44,0,0,1,0,.1c0-.1,0-.39,0-.49s0,0,0,0l0-.15s0-.29,0,0v-.24a2.14,2.14,0,0,0,0-.44c0-.11,0-.28,0-.18l0-.37h0a7.49,7.49,0,0,1,0-1.16,3.39,3.39,0,0,1,0-.45l0,0c0-.16.08-.46.07-.52a1.34,1.34,0,0,0,.07-.18c0-.08.05-.16.08-.25a1.26,1.26,0,0,1,.24-.44v0a1,1,0,0,1,.44-.28l0,0a1.8,1.8,0,0,1,.8,0,.39.39,0,0,1-.15,0,3.07,3.07,0,0,1,.52.14A.84.84,0,0,1,28,22a.44.44,0,0,1,.1.16h0l0,0,0,.1,0-.09c0,.06.07.15.1.23v.07c0,.09,0,.07,0,0l.05.12a.52.52,0,0,0,0,.17.3.3,0,0,1,0,.1V23a.41.41,0,0,0,.1.13.32.32,0,0,0,.23.07,1.07,1.07,0,0,0,.27-.06s0,0,0,0l.32,0,0,0,.24-.06c.15,0,.21,0,.07.05l.58-.1v0h.13l.07,0a.35.35,0,0,0,.15-.12.25.25,0,0,0,.05-.15,1.21,1.21,0,0,0,0-.18c0-.15,0-.31-.05-.46a6.06,6.06,0,0,0-.25-1c0,.14-.09-.28-.15-.28s0-.12,0,0a3.08,3.08,0,0,0-.2-.34.79.79,0,0,0-.21-.24s.07,0,0,0a.47.47,0,0,1-.1-.1s0,0,.08.06a.92.92,0,0,0-.14-.14.21.21,0,0,0-.1-.06.09.09,0,0,0-.1,0,.73.73,0,0,0-.3-.22s-.11-.11.06,0L29,19.65l-.21-.11a1.18,1.18,0,0,0-.3-.1l-.09,0-.09,0L28,19.31l-.26,0,.07,0a.33.33,0,0,1-.17,0l-.24,0h0a1.84,1.84,0,0,0-.33,0h-.33l0,0c0,.05-.4,0-.67,0h.1c-.14,0-.41,0-.56,0s0,0,.09,0c-.38.06,0,0-.32.12-.05,0,.06-.06-.13,0a1.2,1.2,0,0,0-.32.16l-.42.24c.06,0,.11,0,0,0a1.88,1.88,0,0,0-.55.5l0,0a2.29,2.29,0,0,0-.32.51,1,1,0,0,0-.26.47c-.08.21-.12.41-.16.4,0,.15-.08.31-.11.47v0a1.8,1.8,0,0,0-.05.52c0,.07,0,0,0,0a3,3,0,0,0,0,.85l0,0c0,.1-.05.64,0,1.07a.09.09,0,0,1,0-.05,8.58,8.58,0,0,0,0,1.34l0,.31c0-.41,0,.07.06-.1,0,.16,0,.42,0,.22v0c-.05-.08,0,.51-.05.5a14.42,14.42,0,0,0,.11,2.37l0-.09c0,.09,0,.18.05.26s0,.1-.05-.09a1.09,1.09,0,0,0,.1.32c.09.37-.08-.13-.05,0l.05.15v0a3.45,3.45,0,0,1,.14.34c.05.14,0,.08,0,.14a.23.23,0,0,0,0,.08c0,.1.09.21.15.31l0-.14c.08.13.15.29.1.13a2.32,2.32,0,0,0,.4.63,3.64,3.64,0,0,0,.5.46,4.3,4.3,0,0,0,.6.32c-.06,0-.08-.07.12,0-.05,0,0,.07.17.11a2.39,2.39,0,0,1,.38.13c-.08,0,.08,0,.22,0s.28,0,.16,0c.19,0,0,0,.15.06a8.59,8.59,0,0,0,1.52,0s-.09,0,0,0a1.51,1.51,0,0,0,.3,0c.1,0,.08-.07.28-.1,0,0-.07,0,0,0a2.77,2.77,0,0,0,1.38-.87,3.92,3.92,0,0,0,.76-1.46c-.05.14,0,.05,0-.06,0,.07,0,0,0,0,0-.14.07-.29.1-.44a.87.87,0,0,1,0-.28v-.17a.15.15,0,0,0,0-.11.11.11,0,0,1,0,.08v.09c0-.2-.1.26-.15.22a6.49,6.49,0,0,1-.16.88c0,.07,0-.07,0,0a.76.76,0,0,1-.11.36v0a2.52,2.52,0,0,1-.32.58,2.84,2.84,0,0,1-.48.5h0a1.09,1.09,0,0,1-.17.13c-.05.06,0,0,.1-.05s.14-.13.1-.07-.25.19-.45.3a1.18,1.18,0,0,1-.45.18c-.19.07.06,0-.12.08h-.06l0,0c-.13,0-.2,0-.2,0l.12,0c-.17,0-.47.11-.53.11A1.08,1.08,0,0,0,28,32a6.34,6.34,0,0,1-1.74.09l0,0a2.2,2.2,0,0,1-.37,0l-.14,0-.24-.06h0a1.58,1.58,0,0,1-.31-.09c.1,0-.18-.11-.05-.07-.4-.17-.2-.07-.46-.19l-.05-.05a1,1,0,0,1-.27-.18c.15.1-.09-.12.08,0-.16-.17-.28-.29-.37-.4a.8.8,0,0,1-.19-.3c-.08-.08,0,0,0,.1s.14.19.1.15,0,0-.07,0l-.15-.21c-.07-.13-.08-.25-.22-.59l0,.07a2.59,2.59,0,0,1-.14-.42c-.06-.08-.06-.21-.1-.23s.06.22.1.33a2.23,2.23,0,0,1-.2-.68l.06.18c0-.09,0-.17-.05-.27s.08.41.17.6c0-.1-.12-.37-.05-.28a3.18,3.18,0,0,1-.14-.61h0a1.18,1.18,0,0,1,0-.2l0,.13c0-.2,0-.4,0-.6,0,.42,0,.1,0,.28-.07-.52,0-.3,0-.88,0,.08,0,.3,0,.17a1.77,1.77,0,0,1,0-.32c0-.38,0,.06,0-.1a1.1,1.1,0,0,0,0-.36h0c0-.43-.05-.11,0-.51l0,.17v-.21l0,.05a3,3,0,0,1,0-.52c0,.06,0,0,0-.22s0,.08,0-.2a.53.53,0,0,1,0,.25s0,.06,0,.08a3.53,3.53,0,0,0,0-.46v.11l0-.4c0-.07,0,0,0,0s0-.14,0-.25,0,0,.05.19l0-.38s0-.2,0-.15c0-.21,0-.51,0-.79a.34.34,0,0,1,0-.1c0-.26.05-.49.06-.8l.05-.17c0-.24-.07.23,0-.17s0-.1.07-.19a1.91,1.91,0,0,1,.13-.63c0,.09,0,.15-.06.22m1.75-2.18a.66.66,0,0,1-.19.09.34.34,0,0,1,.19-.09m4.23.52L29.31,20a.49.49,0,0,1,.13.12m-4,5.59h0c0-.13,0-.09,0,0m0,.27s0,0,0,0a.38.38,0,0,1,0-.15.61.61,0,0,0,0,.14m-2,4.13,0-.05c.05.11,0,.08,0,.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4715",
    "data-name": "Path 4715",
    className: "cls-3",
    d: "M29,19.86s0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4716",
    "data-name": "Path 4716",
    className: "cls-3",
    d: "M23.25,23.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4717",
    "data-name": "Path 4717",
    className: "cls-3",
    d: "M25.7,21.85a.3.3,0,0,1,.08-.08l-.08.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4718",
    "data-name": "Path 4718",
    className: "cls-3",
    d: "M25.49,27.44v0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4719",
    "data-name": "Path 4719",
    className: "cls-3",
    d: "M25.53,28.93l0,.07h0c0-.1-.06-.17,0-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4720",
    "data-name": "Path 4720",
    className: "cls-3",
    d: "M25.42,27.6a.58.58,0,0,0,0,.24h0s0-.1,0-.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4721",
    "data-name": "Path 4721",
    className: "cls-3",
    d: "M25.43,27.87V28s0,0,0-.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4722",
    "data-name": "Path 4722",
    className: "cls-3",
    d: "M25.46,26.36c0,.05,0,0,0,.07s0-.39,0-.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4723",
    "data-name": "Path 4723",
    className: "cls-3",
    d: "M25.35,27.7l0,0,0-.07v.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4724",
    "data-name": "Path 4724",
    className: "cls-3",
    d: "M25.35,26.75v.19a.18.18,0,0,0,0,0v-.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4725",
    "data-name": "Path 4725",
    className: "cls-3",
    d: "M25.36,27a.86.86,0,0,0,0,.16V27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4727",
    "data-name": "Path 4727",
    className: "cls-3",
    d: "M25.36,24.67v-.21s0,0,0,.11,0,.13,0,.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4728",
    "data-name": "Path 4728",
    className: "cls-3",
    d: "M25.29,25.31a.3.3,0,0,1,0-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4729",
    "data-name": "Path 4729",
    className: "cls-3",
    d: "M25.28,24.69s0-.31,0,0c0,0,0,.23,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4730",
    "data-name": "Path 4730",
    className: "cls-3",
    d: "M26,21.66l0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4731",
    "data-name": "Path 4731",
    className: "cls-3",
    d: "M28.41,22.38c0-.12-.06-.14-.07-.15s0,0-.06-.12.07.18,0,.13c.07.14.08.22.1.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4732",
    "data-name": "Path 4732",
    className: "cls-3",
    d: "M28.31,22.24a.16.16,0,0,0,0-.07l0,.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4733",
    "data-name": "Path 4733",
    className: "cls-3",
    d: "M30.72,28.87v-.19a.22.22,0,0,1,0,.08v.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4734",
    "data-name": "Path 4734",
    className: "cls-3",
    d: "M30.59,28.51a.14.14,0,0,0,0-.06.22.22,0,0,0-.14,0,.21.21,0,0,1,.16.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4735",
    "data-name": "Path 4735",
    className: "cls-3",
    d: "M25.64,19.55h0a.28.28,0,0,0-.13,0l.12,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4736",
    "data-name": "Path 4736",
    className: "cls-3",
    d: "M24,20.72l0,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4737",
    "data-name": "Path 4737",
    className: "cls-3",
    d: "M23.41,22.36c0-.07,0-.16,0-.23,0,.16-.08.24,0,.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4738",
    "data-name": "Path 4738",
    className: "cls-3",
    d: "M32.61,19.39h1.76a.22.22,0,0,1,.22.22v4.06a.22.22,0,0,0,.22.22.21.21,0,0,0,.19-.11l2.58-4.28a.21.21,0,0,1,.18-.11h2.08a.22.22,0,0,1,.22.22.21.21,0,0,1,0,.12L36.9,24.46a.22.22,0,0,0,0,.22l3.38,7a.23.23,0,0,1-.11.3l-.09,0H38a.21.21,0,0,1-.2-.13l-2.22-5a.22.22,0,0,0-.29-.11.14.14,0,0,0-.09.08l-.53.84a.19.19,0,0,0,0,.12v4a.22.22,0,0,1-.22.22H32.61a.22.22,0,0,1-.22-.22V19.61a.22.22,0,0,1,.22-.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4739",
    "data-name": "Path 4739",
    className: "cls-3",
    d: "M32.61,19.39h1.76a.22.22,0,0,1,.22.22v4.06a.22.22,0,0,0,.22.22.21.21,0,0,0,.19-.11l2.58-4.28a.21.21,0,0,1,.18-.11h2.08a.22.22,0,0,1,.22.22.21.21,0,0,1,0,.12L36.9,24.46a.22.22,0,0,0,0,.22l3.38,7a.23.23,0,0,1-.11.3l-.09,0H38a.21.21,0,0,1-.2-.13l-2.22-5a.22.22,0,0,0-.29-.11.14.14,0,0,0-.09.08l-.53.84a.19.19,0,0,0,0,.12v4a.22.22,0,0,1-.22.22H32.61a.22.22,0,0,1-.22-.22V19.61a.22.22,0,0,1,.22-.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4740",
    "data-name": "Path 4740",
    className: "cls-3",
    d: "M32.51,19.28l.09,0s0,0,0,0-.14.05-.13.05h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4741",
    "data-name": "Path 4741",
    className: "cls-3",
    d: "M32.31,20.72v0l0,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4742",
    "data-name": "Path 4742",
    className: "cls-3",
    d: "M32.31,22a5.48,5.48,0,0,0,0-.7v0l0-.1c0,.28,0,.65,0,.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4743",
    "data-name": "Path 4743",
    className: "cls-3",
    d: "M32.23,22.71s0,.15,0-.16v.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4744",
    "data-name": "Path 4744",
    className: "cls-3",
    d: "M32.23,22.58c0-.14,0,.09,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4745",
    "data-name": "Path 4745",
    className: "cls-3",
    d: "M32.24,23.21V23s0,.2,0,.14c0,.19,0,.15,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4746",
    "data-name": "Path 4746",
    className: "cls-3",
    d: "M32.27,23.38v-.09a.28.28,0,0,0,0,.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4747",
    "data-name": "Path 4747",
    className: "cls-3",
    d: "M32.25,23.09v.2a.07.07,0,0,0,0-.09s0,0,0-.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4748",
    "data-name": "Path 4748",
    className: "cls-3",
    d: "M32.26,23c0-.1,0-.23,0-.05,0-.35,0-.29,0,.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4749",
    "data-name": "Path 4749",
    className: "cls-3",
    d: "M32.35,22.09v-.26a2.16,2.16,0,0,0,0,.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4750",
    "data-name": "Path 4750",
    className: "cls-3",
    d: "M32.22,24.34s0-.06,0-.08v-.13a1.49,1.49,0,0,1,0,.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4751",
    "data-name": "Path 4751",
    className: "cls-3",
    d: "M32.25,24.26l0,.2c0-.18,0-.21,0-.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4752",
    "data-name": "Path 4752",
    className: "cls-3",
    d: "M32.31,23.42l0-.33,0,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4753",
    "data-name": "Path 4753",
    className: "cls-3",
    d: "M32.22,25.1l0-.12,0,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4754",
    "data-name": "Path 4754",
    className: "cls-3",
    d: "M32.23,25.6c0-.08,0,.12,0,0,0,.14,0,.25,0,.36,0-.13,0-.26,0-.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4755",
    "data-name": "Path 4755",
    className: "cls-3",
    d: "M32.23,26.16c0-.05,0-.11,0-.17s0,.12,0,.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4756",
    "data-name": "Path 4756",
    className: "cls-3",
    d: "M32.26,24.8a.88.88,0,0,0,0,.16l0-.08V24.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4758",
    "data-name": "Path 4758",
    className: "cls-3",
    d: "M32.26,24.78v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4759",
    "data-name": "Path 4759",
    className: "cls-3",
    d: "M32.29,23.94c0,.12,0,.36,0,.12,0-.08,0,.05,0-.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4760",
    "data-name": "Path 4760",
    className: "cls-3",
    d: "M32.29,24.68v-.21s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4761",
    "data-name": "Path 4761",
    className: "cls-3",
    d: "M32.29,24.79v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4762",
    "data-name": "Path 4762",
    className: "cls-3",
    d: "M32.25,25.81c0,.09,0,.19,0,.3v-.37s0-.07,0,.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4765",
    "data-name": "Path 4765",
    className: "cls-3",
    d: "M32.28,25.72a1.34,1.34,0,0,0,0-.2v.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4766",
    "data-name": "Path 4766",
    className: "cls-3",
    d: "M32.24,26.47l0-.15a.77.77,0,0,0,0,.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4768",
    "data-name": "Path 4768",
    className: "cls-3",
    d: "M32.26,25.4a.41.41,0,0,0,0,.12V25.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4769",
    "data-name": "Path 4769",
    className: "cls-3",
    d: "M32.41,27.56a1.24,1.24,0,0,1,0-.47c0-.2-.08-.07-.12.11,0,0,0,0,0,.22,0-.08,0-.47,0-.29a1.45,1.45,0,0,1,0,.36c0-.11,0,.35.07.29v-.24s0,.08,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4770",
    "data-name": "Path 4770",
    className: "cls-3",
    d: "M32.27,26.8v-.08c0,.1,0,.16,0,.3a.37.37,0,0,0,0,.18v-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4771",
    "data-name": "Path 4771",
    className: "cls-3",
    d: "M32.27,26.33c0,.07,0,.27,0,.15s0-.22,0-.33c0,.41,0-.12,0,.18v-.22c0,.07,0,.14,0,.21h0v0h0v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4772",
    "data-name": "Path 4772",
    className: "cls-3",
    d: "M32.38,24.28h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4773",
    "data-name": "Path 4773",
    className: "cls-3",
    d: "M32.37,24.45a.38.38,0,0,1,0-.15c0-.09,0,0,0,0s0-.2,0,0v0a2,2,0,0,1,0,.35.65.65,0,0,0,0-.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4774",
    "data-name": "Path 4774",
    className: "cls-3",
    d: "M32.32,25.4v.34l0-.17h0c0-.2,0-.15,0-.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4775",
    "data-name": "Path 4775",
    className: "cls-3",
    d: "M32.26,27.26l0-.05,0,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4776",
    "data-name": "Path 4776",
    className: "cls-3",
    d: "M32.26,27.7l0,0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4777",
    "data-name": "Path 4777",
    className: "cls-3",
    d: "M38.19,27.65l0-.08,0,.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4778",
    "data-name": "Path 4778",
    className: "cls-3",
    d: "M38.5,28.31h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4779",
    "data-name": "Path 4779",
    className: "cls-3",
    d: "M34.84,27.49a1.86,1.86,0,0,0,.18-.23l-.05,0a2.39,2.39,0,0,1-.13.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4780",
    "data-name": "Path 4780",
    className: "cls-3",
    d: "M38.35,32h0l-.1,0,.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4781",
    "data-name": "Path 4781",
    className: "cls-3",
    d: "M38.45,31.86l.19,0-.19,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4782",
    "data-name": "Path 4782",
    className: "cls-3",
    d: "M37,24l0-.11C37,24,37,24,37,24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4783",
    "data-name": "Path 4783",
    className: "cls-3",
    d: "M32.75,32.08h.31a1.09,1.09,0,0,0-.31,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4784",
    "data-name": "Path 4784",
    className: "cls-3",
    d: "M38.52,27.81l0-.07,0,.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4785",
    "data-name": "Path 4785",
    className: "cls-3",
    d: "M33.42,32.09h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4789",
    "data-name": "Path 4789",
    className: "cls-3",
    d: "M32.33,29a.1.1,0,0,0,0,0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4791",
    "data-name": "Path 4791",
    className: "cls-3",
    d: "M32.26,29.34v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4792",
    "data-name": "Path 4792",
    className: "cls-3",
    d: "M32.25,29.36v-.09s0,0,0,.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4794",
    "data-name": "Path 4794",
    className: "cls-3",
    d: "M38.86,19.46h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4795",
    "data-name": "Path 4795",
    className: "cls-3",
    d: "M36.11,27.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4796",
    "data-name": "Path 4796",
    className: "cls-3",
    d: "M36.26,28.11a1.05,1.05,0,0,1-.15-.3l0,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4797",
    "data-name": "Path 4797",
    className: "cls-3",
    d: "M37.43,26.1l.08.22c-.15-.24-.23-.43-.16-.22.08,0,.41.82.49.82l0,.15,0-.09c.1.29.14.18.3.54.05.12.08.21,0,.13l.14.27c0,.08,0,.07,0,0l.21.41h0l.16.24c0,.11,0,0,0,0l.13.23c0,.1-.08-.08-.16-.24.05.24.11.18.3.66L38.81,29a4,4,0,0,0,.23.57c0-.06-.19-.52,0-.27a2.1,2.1,0,0,0,.15.3s0,.14.13.3h0a2.2,2.2,0,0,0,.17.25.69.69,0,0,1,.09.31c.15.32-.07-.24.12.14s.25.51.39.76,0,0,0,0l.1.16s0,0,0,0,0,.07.06.08l0,0a.11.11,0,0,1,0,.08s0,0,0,.07a.11.11,0,0,1-.11.06h-.47c-.08,0,0,0,0,0l-.69,0-.29,0c.21,0-.06.05-.29.08l.18,0-.38,0s0,0,.06,0h-.07c-.14,0-.07,0,0-.05l.14,0c.09,0,.18,0,.16-.06h-.21l-.09,0,0,0h-.22a.09.09,0,0,1,0,0,.3.3,0,0,1,0-.08c-.18-.31-.35-.57-.59-1.07.08.11.06,0,.09,0,.09.22.19.44.3.65-.06-.14,0-.11,0-.08l-.24-.46s0-.11-.07-.23c0,.11-.18-.34-.28-.53,0,0,0,0,.14.26-.08-.28-.2-.31-.28-.58a.3.3,0,0,0,.06.11c-.08-.13-.21-.47-.16-.39l0,.05a9.38,9.38,0,0,0-.57-1.2l.09,0-.43-.62c.06,0,0-.22.2.09a2.87,2.87,0,0,0-.18-.4c0,.07,0,.18,0,.09s0-.17-.14-.47c0,.1-.07,0-.13-.13,0,0,0,0,.08,0l-.11-.17a.28.28,0,0,0-.21-.13c.06,0,.07,0,.05,0a.24.24,0,0,0-.14-.05.45.45,0,0,0-.22.13l-.05.07,0,.07-.06.1.1-.13c-.25.37-.17.41-.41.8a.11.11,0,0,0,0-.08s0,0,0,0l0,0a.13.13,0,0,0,0,.09v.07l0,.07a.83.83,0,0,1,.05.2,3.2,3.2,0,0,1,.08.54v.37c0-.19-.13-.72-.17-1a1.51,1.51,0,0,0,0,.3c0,.09,0-.13,0-.21v.59s0,.45.06.43l0-.64a2.06,2.06,0,0,1,.09.78c0,.11-.06-.08-.07-.07s0,.29,0,.43l0-.18c0,.24.05.38,0,.66a1.53,1.53,0,0,0,0,.3c0-.16.16-.19.19-.08s0,.5-.06.61-.07-.24-.1-.1a.31.31,0,0,1,0,.13c0,.1,0,0,0,.18,0,0,0,.44,0,.1,0,.21,0,.23,0,.48,0,0,0,0,0,.11a.3.3,0,0,1,0,.16.21.21,0,0,1-.14.1s0,0-.07,0l-1.08,0s-.24,0-.15,0l-.24,0c-.25,0,.28,0,.1,0l-.19,0h-.17a.27.27,0,0,1-.12,0,.12.12,0,0,0,.07.05h.15l.35,0s-.08,0-.21.06l-.24,0a.28.28,0,0,1-.3-.24v-.14a.06.06,0,0,1,0,0s0,0,0,0c0-.64-.07-.54,0-1.07,0-.21.05,0,.07-.06,0,.28,0,.43,0,.62v-.23c0,.12,0,.24,0,.37,0-.18,0-1.08,0-1.57,0-.09,0-.24,0-.17v.16c0,.14,0-.3,0-.1a6.15,6.15,0,0,1,0-.74l0-.06a.88.88,0,0,0,0,.28,5.81,5.81,0,0,0,0-.59l0,.21a6.06,6.06,0,0,1,0-.73c0,.12,0,.06,0,.24,0-.16,0,.67,0,.41,0,.19,0,.33-.05.58,0,0,0-.09,0,.13a.09.09,0,0,1,0,0h0a.43.43,0,0,1,0-.11c0,.11,0,.46,0,.57s0-.05,0,0l0,.18s0,.34,0,0v.27a3.13,3.13,0,0,0,0,.53c0,.13,0,.32,0,.21v.43h0v.16a1.36,1.36,0,0,0,0,.2.32.32,0,0,0,.26.24h.11a5.61,5.61,0,0,1,.71,0,4.2,4.2,0,0,1,.53,0l0,0h.45a.28.28,0,0,0,.13,0,.3.3,0,0,0,.14-.11.29.29,0,0,0,.08-.14.3.3,0,0,0,0-.1v-.4c0-.24,0-.5,0-.66h0c0-.22,0-.44,0-.72l0,0c0-.24,0-.61,0-1a.6.6,0,0,1,0,.19c.05-.46,0-1,0-1.37,0-.13,0-.1,0-.17v0l0,0,.09-.12-.08.1.16-.28.05,0v0c.07-.09,0-.08,0,0a1,1,0,0,1,.19-.3.26.26,0,0,1,.07-.1.07.07,0,0,1,.05,0,.06.06,0,0,1,.06,0,.14.14,0,0,1,.1.05l0,0,0,0,.05.09a.33.33,0,0,0,.06.1s0,0,0,0a2.07,2.07,0,0,0,.15.34v.07l.16.24c.05.17.07.24,0,.09.2.36.15.3.32.61h0c.06.12.12.24.17.37s.55,1.28.81,2c0-.15.11.32.17.33s0,.14,0,0c.11.25.22.5.35.74,0,0-.06-.07,0,0l0,.07,0,.09,0,0-.05-.09,0,.06,0,.08a.41.41,0,0,0,.13.1.3.3,0,0,0,.16,0h0a.24.24,0,0,0,.09-.06,1.19,1.19,0,0,0,.42,0c.07,0,.18,0-.06,0a5.59,5.59,0,0,0,.82,0H40a.5.5,0,0,0,.2-.08.24.24,0,0,0,.09-.3h0c-.21-.5-.12-.2-.32-.7v0c-.07,0-.17-.44-.33-.7l0,.11c-.08-.2-.15-.41-.21-.61,0,0,0,0,.06.09-.17-.41-.06,0-.2-.33,0-.06.07.05,0-.15s-.33-.55-.44-.84c0,.07,0,.13,0,0a6,6,0,0,0-.36-.77.1.1,0,0,1,0,0c-.09-.16-.27-.51-.34-.6s-.52-1-.45-1l-.24-.5h0a3.29,3.29,0,0,0-.29-.52c0-.08,0,0,0,0L37,24.81l-.05-.1a.2.2,0,0,1,0-.08.17.17,0,0,1,0-.12l.13-.23.05,0c0-.1.44-.6.7-1a.14.14,0,0,1,0,.06A14.11,14.11,0,0,0,38.66,22l.18-.33c-.27.4,0-.08-.11.08.1-.16.3-.4.17-.2l0,0c0,.1.35-.5.37-.47.26-.4.53-.79.79-1.17a1,1,0,0,0,.1-.17.32.32,0,0,0-.21-.4l-.11,0H39l.1,0h-.31c-.08,0-.11,0,.12,0a1.2,1.2,0,0,0-.38,0c-.44,0,.17,0,0,0h-.14a3,3,0,0,1-.43,0c-.16,0-.08,0-.15,0h-.1a.3.3,0,0,0-.13,0,.24.24,0,0,0-.13.07.36.36,0,0,0-.07.1l-.05.08.11-.12c-.09.16-.2.32-.08.18-.18.2-.77,1.25-.87,1.38a6.35,6.35,0,0,1-.39.68c0-.06.1-.08,0,.14,0-.12-.27.39-.41.54.12-.14-.37.63-.18.4-.12.18,0,0-.13.13s-.27.46-.43.71a.91.91,0,0,1-.11.16.11.11,0,0,1-.11,0,.14.14,0,0,1-.08-.09v-.22s0,.1,0,0l0-.33a1,1,0,0,1,0-.35s0,.08,0,0c0-.62,0-1.25,0-1.88V19.62a.28.28,0,0,0,0-.09.39.39,0,0,0-.08-.14.37.37,0,0,0-.15-.08h-.14l-.24,0c.17,0,.06,0-.07,0,.09,0,0,0,0,0l-.53,0c-.1,0-.56,0-.62,0H33c-.22,0,.31.08.28.13.24,0,.65.07,1.06,0,0,0,0,0,0,0s-.06,0,0,0h.06l.06,0a.18.18,0,0,1,.05.07.43.43,0,0,1,0,.05v.05c0,.65,0,.93,0,1.66l0-.06a1.47,1.47,0,0,1,0,.27c0,.18,0-.44,0-.28s0,1.1,0,1.25,0-.08,0,.17v.06l0,.06a.64.64,0,0,1,0,.24v-.15c0,.2,0,.58,0,.65v.16a.36.36,0,0,0,.08.19.34.34,0,0,0,.36.1.4.4,0,0,0,.16-.13l.07-.12c.19-.31.37-.62.52-.9l0,0c.23-.43.21-.33.48-.79v0a3.9,3.9,0,0,1,.19-.35c-.06.12.15-.2.07,0a2.85,2.85,0,0,0,.26-.56l.06-.06a2.31,2.31,0,0,1,.18-.35c-.1.2.11-.13,0,.09.32-.46.39-.73.57-.92s-.27.4-.21.27c-.07.09.08-.2.17-.35l.17-.22.06-.07a.13.13,0,0,1,.13-.05h.06c.17,0,.33,0,.53,0s.27,0,.3,0h-.41a5.91,5.91,0,0,1,.84,0l-.23,0c.12,0,.22,0,.34,0,0,0-.5,0-.75,0,.12,0,.47,0,.34,0,.19-.05.45,0,.75,0l0,0,.24,0-.16,0h.18c.07,0,.09,0,.11,0a.11.11,0,0,1,0,.12.1.1,0,0,0,0-.09s0,0,0,0,0,0,0,0a.14.14,0,0,1,0,.1.08.08,0,0,1,0,.08l-.11.12a2.36,2.36,0,0,0-.32.44c0-.08.2-.28.13-.16a3.69,3.69,0,0,1-.23.3c-.25.38.06,0,0,.13a1.31,1.31,0,0,0-.21.36h0c-.3.42,0,.14-.3.51l.08-.18-.13.21v-.06a4.45,4.45,0,0,1-.33.51c.05,0,0,0-.1.24s0-.08-.15.19a.58.58,0,0,1,.15-.25s0-.07,0-.09-.23.35-.3.45l.08-.1-.23.41c-.05.06,0,0,0-.05s-.08.14-.16.26c0,0,0-.05.09-.22l-.23.39s-.15.18-.12.13c-.15.2-.3.52-.5.79l-.06.11-.13.18-.06.09a.34.34,0,0,0,0,.36l.05.11.12.23.06.2c.13.25-.08-.28.14.15s0,.12.07.24a4,4,0,0,1,.36.68c-.05-.09-.08-.17-.13-.25M39,29.27a1,1,0,0,1-.12-.23.57.57,0,0,1,.12.23m-1.12,2.61.07,0h0a.11.11,0,0,1-.08,0m-5.6-1.38h0c0,.15,0,.1,0,0m0-.31s0,0,0,0v.17a.38.38,0,0,0,0-.15m5.59-10.9h.06c-.14,0-.1,0-.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4798",
    "data-name": "Path 4798",
    className: "cls-3",
    d: "M38.44,31.87l0,0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4799",
    "data-name": "Path 4799",
    className: "cls-3",
    d: "M37,24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4800",
    "data-name": "Path 4800",
    className: "cls-3",
    d: "M34.49,30.84a.59.59,0,0,1,0-.13s0,0,0,.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4801",
    "data-name": "Path 4801",
    className: "cls-3",
    d: "M32.24,28.51v.2a1.21,1.21,0,0,1,0-.19s0,.05,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4802",
    "data-name": "Path 4802",
    className: "cls-3",
    d: "M32.39,26.74v-.09h0c0,.13,0,.22,0,.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4803",
    "data-name": "Path 4803",
    className: "cls-3",
    d: "M32.32,28.32a.93.93,0,0,0,0-.29v0s0,.11,0,.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4804",
    "data-name": "Path 4804",
    className: "cls-3",
    d: "M32.33,28v-.13s0,.05,0,.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4805",
    "data-name": "Path 4805",
    className: "cls-3",
    d: "M32.27,29.79c0-.07,0,0,0-.08s0,.45,0,.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4806",
    "data-name": "Path 4806",
    className: "cls-3",
    d: "M32.39,28.2l0,.05,0,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4807",
    "data-name": "Path 4807",
    className: "cls-3",
    d: "M32.37,29.33V29.1a.22.22,0,0,1,0-.06,1.4,1.4,0,0,0,0,.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4809",
    "data-name": "Path 4809",
    className: "cls-3",
    d: "M32.39,28.51v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4810",
    "data-name": "Path 4810",
    className: "cls-3",
    d: "M32.37,31.77a.22.22,0,0,0,.17.19s0,0-.11-.08-.06-.15-.06-.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4811",
    "data-name": "Path 4811",
    className: "cls-3",
    d: "M32.43,31a.43.43,0,0,1,0,.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4812",
    "data-name": "Path 4812",
    className: "cls-3",
    d: "M32.44,31.74a.31.31,0,0,0,.05.1h0s0-.05,0-.08a0,0,0,0,1,0,0v-.07s0,0,0,.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4813",
    "data-name": "Path 4813",
    className: "cls-3",
    d: "M34.58,30.45v.07h.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4814",
    "data-name": "Path 4814",
    className: "cls-3",
    d: "M34.73,27.16c-.17.24,0,.08-.16.29s.12-.17.1-.11c.08-.16.14-.23.06-.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4815",
    "data-name": "Path 4815",
    className: "cls-3",
    d: "M34.67,27.34l0,.08a.56.56,0,0,1,0-.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4816",
    "data-name": "Path 4816",
    className: "cls-3",
    d: "M33.13,19.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4817",
    "data-name": "Path 4817",
    className: "cls-3",
    d: "M32.77,19.3l-.05,0-.11,0h.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4818",
    "data-name": "Path 4818",
    className: "cls-3",
    d: "M39.15,29.77h0l-.06-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4819",
    "data-name": "Path 4819",
    className: "cls-3",
    d: "M38.06,27.45l0,0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4820",
    "data-name": "Path 4820",
    className: "cls-3",
    d: "M37.08,25.53l.13.25c-.09-.17-.1-.28-.13-.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4821",
    "data-name": "Path 4821",
    className: "cls-3",
    d: "M42,19.39h6.1a.22.22,0,0,1,.22.22h0v1.76a.22.22,0,0,1-.22.22h-3.9a.22.22,0,0,0-.22.22h0v2.48a.22.22,0,0,0,.22.23h3.23a.21.21,0,0,1,.22.22h0V26.5a.22.22,0,0,1-.22.22H44.15a.22.22,0,0,0-.22.22h0v2.6a.22.22,0,0,0,.22.22h4a.22.22,0,0,1,.22.22h0v1.76a.22.22,0,0,1-.22.22H42a.22.22,0,0,1-.22-.22h0V19.61a.22.22,0,0,1,.22-.22h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4822",
    "data-name": "Path 4822",
    className: "cls-3",
    d: "M42,19.39h6.1a.22.22,0,0,1,.22.22h0v1.76a.22.22,0,0,1-.22.22h-3.9a.22.22,0,0,0-.22.22h0v2.48a.22.22,0,0,0,.22.23h3.23a.21.21,0,0,1,.22.22h0V26.5a.22.22,0,0,1-.22.22H44.15a.22.22,0,0,0-.22.22h0v2.6a.22.22,0,0,0,.22.22h4a.22.22,0,0,1,.22.22h0v1.76a.22.22,0,0,1-.22.22H42a.22.22,0,0,1-.22-.22h0V19.61a.22.22,0,0,1,.22-.22h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4823",
    "data-name": "Path 4823",
    className: "cls-3",
    d: "M41.86,19.28c.12,0,.07,0,.1,0s-.13,0-.13,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4824",
    "data-name": "Path 4824",
    className: "cls-3",
    d: "M41.66,20.62v0l0,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4825",
    "data-name": "Path 4825",
    className: "cls-3",
    d: "M41.66,21.84q0-.33,0-.66v0l0-.1c0,.26,0,.6,0,.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4826",
    "data-name": "Path 4826",
    className: "cls-3",
    d: "M41.58,22.48s0,.14,0-.15v.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4827",
    "data-name": "Path 4827",
    className: "cls-3",
    d: "M41.58,22.36c0-.13,0,.08,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4828",
    "data-name": "Path 4828",
    className: "cls-3",
    d: "M41.59,23l0-.17s0,.19,0,.13c0,.17,0,.14,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4829",
    "data-name": "Path 4829",
    className: "cls-3",
    d: "M41.61,23.11V23a.27.27,0,0,0,0,.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4830",
    "data-name": "Path 4830",
    className: "cls-3",
    d: "M41.6,22.84V23s0,0,0-.08,0,0,0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4831",
    "data-name": "Path 4831",
    className: "cls-3",
    d: "M41.6,22.73c0-.09,0-.21,0,0,0-.33,0-.28,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4832",
    "data-name": "Path 4832",
    className: "cls-3",
    d: "M41.69,21.9l0-.13,0-.11c0,.06,0,.25,0,.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4833",
    "data-name": "Path 4833",
    className: "cls-3",
    d: "M41.57,24s0-.06,0-.07v-.12a1.37,1.37,0,0,1,0,.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4834",
    "data-name": "Path 4834",
    className: "cls-3",
    d: "M41.6,23.93v.19c0-.17,0-.2,0-.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4835",
    "data-name": "Path 4835",
    className: "cls-3",
    d: "M41.65,23.14l0-.3,0,.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4836",
    "data-name": "Path 4836",
    className: "cls-3",
    d: "M41.57,24.71l0-.11,0,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4837",
    "data-name": "Path 4837",
    className: "cls-3",
    d: "M41.57,25.18c0-.08,0,.11,0,0a3.28,3.28,0,0,0,0,.34c0-.12,0-.24,0-.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4838",
    "data-name": "Path 4838",
    className: "cls-3",
    d: "M41.58,25.71a1,1,0,0,0,0-.17,1,1,0,0,0,0,.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4839",
    "data-name": "Path 4839",
    className: "cls-3",
    d: "M41.61,24.43a.39.39,0,0,0,0,.15l0-.07v-.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4841",
    "data-name": "Path 4841",
    className: "cls-3",
    d: "M41.61,24.41v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4842",
    "data-name": "Path 4842",
    className: "cls-3",
    d: "M41.63,23.63c0,.11,0,.33,0,.11,0-.07,0,.05,0-.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4843",
    "data-name": "Path 4843",
    className: "cls-3",
    d: "M41.64,24.32v-.2s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4844",
    "data-name": "Path 4844",
    className: "cls-3",
    d: "M41.64,24.42v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4845",
    "data-name": "Path 4845",
    className: "cls-3",
    d: "M41.6,25.37a2.62,2.62,0,0,1,0,.29c0-.12,0-.23,0-.35s0-.06,0,.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4848",
    "data-name": "Path 4848",
    className: "cls-3",
    d: "M41.63,25.29a1.09,1.09,0,0,0,0-.18v.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4849",
    "data-name": "Path 4849",
    className: "cls-3",
    d: "M41.59,26v-.15a.76.76,0,0,0,0,.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4851",
    "data-name": "Path 4851",
    className: "cls-3",
    d: "M41.6,25s0,.07,0,.11a.61.61,0,0,0,0-.14v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4852",
    "data-name": "Path 4852",
    className: "cls-3",
    d: "M41.75,27a1.23,1.23,0,0,1,0-.43c0-.19-.08-.06-.11.1a.93.93,0,0,1,0,.2c0-.07,0-.43,0-.27a1.27,1.27,0,0,1,0,.34c0-.1,0,.33.07.28V27s0,.08,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4853",
    "data-name": "Path 4853",
    className: "cls-3",
    d: "M41.62,26.3v-.08l0,.28a.51.51,0,0,0,0,.17V26.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4854",
    "data-name": "Path 4854",
    className: "cls-3",
    d: "M41.62,25.86c0,.06,0,.26.05.14a1.55,1.55,0,0,0,0-.31c0,.38,0-.11,0,.17a1.41,1.41,0,0,0,0-.21c0,.07,0,.14,0,.2h0s0,0,0,0,0,0,0,0h0v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4855",
    "data-name": "Path 4855",
    className: "cls-3",
    d: "M41.72,24h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4856",
    "data-name": "Path 4856",
    className: "cls-3",
    d: "M41.71,24.1a.61.61,0,0,1,0-.14c0-.07,0,0,0,0s0-.19,0,0v0a1.66,1.66,0,0,1,0,.32,1.21,1.21,0,0,0,.05-.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4857",
    "data-name": "Path 4857",
    className: "cls-3",
    d: "M41.67,25v.32l0-.16h0c0-.18,0-.15,0-.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4858",
    "data-name": "Path 4858",
    className: "cls-3",
    d: "M41.6,26.73l0-.05,0,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4859",
    "data-name": "Path 4859",
    className: "cls-3",
    d: "M41.6,27.14l0,0,0,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4860",
    "data-name": "Path 4860",
    className: "cls-3",
    d: "M46.61,26.59h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4861",
    "data-name": "Path 4861",
    className: "cls-3",
    d: "M45.94,26.59h0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4862",
    "data-name": "Path 4862",
    className: "cls-3",
    d: "M47.13,32.09c.14,0,.29,0,.27,0l0,0h-.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4863",
    "data-name": "Path 4863",
    className: "cls-3",
    d: "M44.61,29.76h0l.1,0h-.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4864",
    "data-name": "Path 4864",
    className: "cls-3",
    d: "M44.52,29.85h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4865",
    "data-name": "Path 4865",
    className: "cls-3",
    d: "M46.93,24.66l-.11,0c.17,0,.1,0,.11,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4866",
    "data-name": "Path 4866",
    className: "cls-3",
    d: "M41.61,31.36c0,.12,0,.21,0,.29a.93.93,0,0,0,0-.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4867",
    "data-name": "Path 4867",
    className: "cls-3",
    d: "M46.35,26.83c.06,0,.08,0,.08,0s-.09,0-.08,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4868",
    "data-name": "Path 4868",
    className: "cls-3",
    d: "M41.81,32.06a.16.16,0,0,1-.08-.06.3.3,0,0,1-.12-.17.34.34,0,0,1,0-.1v0a.59.59,0,0,0,0,.14.34.34,0,0,0,.2.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4872",
    "data-name": "Path 4872",
    className: "cls-3",
    d: "M41.68,28.37s0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4874",
    "data-name": "Path 4874",
    className: "cls-3",
    d: "M41.6,28.67v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4875",
    "data-name": "Path 4875",
    className: "cls-3",
    d: "M41.59,28.68v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4877",
    "data-name": "Path 4877",
    className: "cls-3",
    d: "M44.42,21.52h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4879",
    "data-name": "Path 4879",
    className: "cls-3",
    d: "M48.22,30.48a1.06,1.06,0,0,1,0,.31l.07-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4880",
    "data-name": "Path 4880",
    className: "cls-3",
    d: "M47.48,26l0,.22c0-.27,0-.46-.05-.25a1.08,1.08,0,0,1,0,.44v.1a.05.05,0,0,1,0,0l0,0h-.06c-.28,0-.21.05-.58,0-.12,0-.21,0-.12,0h-.29c-.08,0-.06,0,0,0h-.43l-.27,0c-.11,0,.06,0,0,0h-.24c-.1,0,.1,0,.27,0-.23-.07-.2,0-.68,0h.22a3.66,3.66,0,0,0-.57,0c.06,0,.51.06.25.08h-.31a.76.76,0,0,0-.31,0v0l-.17,0a.44.44,0,0,0-.34.33s0,0,0,.06l0,0c0,.33,0-.23,0,.16a7.06,7.06,0,0,0,0,.8c0,.19,0,0,0,0l0,.17s0,0,0,0,0,0,0,.23-.06.47,0,.75c0,.07,0,0,0,0,0,.2,0,.28,0,.35a.29.29,0,0,0,.2.3.37.37,0,0,0,.15,0l.14,0c-.2,0,0-.06.27-.08l-.17,0,.35,0s0,0,0,0h.07c.12,0,.06,0,0,0l-.13,0c-.09,0-.17,0-.15.07h.11s0,0,0,0h.1l.08,0h0l.46,0c.38-.05.76-.08,1.14-.1-.13,0,0,0,0,.08h-.68c.14,0,.11,0,.07,0l.49,0s.1,0,.23,0c-.1-.05.36,0,.55-.05,0,0,0,0-.27,0,.26,0,.34-.06.6,0h-.12a1.26,1.26,0,0,1,.4,0h.49a.16.16,0,0,1,.11.05s0,0,0,.05a.2.2,0,0,1,0,.07c0,.06,0,.11,0,.16a.45.45,0,0,0,0,.16.19.19,0,0,1-.07-.08l.15.7c0-.06-.13.17-.15-.15a2.67,2.67,0,0,0,0,.4c0-.06.06-.16.06-.07s0,.16-.06.45c0-.1.07,0,.07.16,0,0-.06,0-.07,0a.17.17,0,0,1,0,.07.13.13,0,0,1,0,.06.15.15,0,0,1-.11.08s0,0,0,0h0l-.06,0h-.26c-.42,0-.42.08-.83.08,0,0,.12-.07-.09-.08a3.16,3.16,0,0,1-.8.16H46l-.28,0c.17,0,.67-.14.94-.18l-.28,0c-.08,0,.13,0,.2,0H46s-.42,0-.4.06l.6,0a1.86,1.86,0,0,1-.74.09c-.1,0,.08-.06.07-.07a2.67,2.67,0,0,1-.4,0l.17,0c-.21,0-.41,0-.62,0a1.33,1.33,0,0,0-.28,0c.15,0,.18.16.08.19L43.93,32c-.14,0,.23-.07.1-.1a.24.24,0,0,1-.12,0c-.09,0,0,0-.16,0,0,0-.42,0-.1,0-.2,0-.22,0-.45,0,.07,0-.21.07-.41.08,0,0,0,0-.06,0H42a.2.2,0,0,1-.2-.1.34.34,0,0,1,0-.1s0-.07,0,0a1.64,1.64,0,0,1,0-.22c0-.23,0,.26,0,.09a3.88,3.88,0,0,1,0-.48,2.09,2.09,0,0,0,0,.56,1.64,1.64,0,0,1-.11-.69c0-.32,0-.14,0-.19,0-.6-.07-.51,0-1,0-.2.05,0,.07-.06,0,.26,0,.4,0,.58v-.22c0,.12,0,.23,0,.35,0-.17,0-1,0-1.47,0-.08,0-.22,0-.16V29c0,.13,0-.27,0-.09a5.3,5.3,0,0,1,0-.69l0-.05a.7.7,0,0,0,0,.25,4.86,4.86,0,0,0,0-.54l0,.19a5.17,5.17,0,0,1,0-.68,1.88,1.88,0,0,0,0,.23c0-.15,0,.62,0,.38,0,.18,0,.31-.05.54,0,0,0-.08,0,.12a.09.09,0,0,1,0,.05h0a.3.3,0,0,1,0-.1c0,.1,0,.43,0,.54s0-.06,0,0l0,.16s0,.33,0,0v.26a2.68,2.68,0,0,0,0,.49c0,.12,0,.31,0,.2v.4h0c0,.2,0,.4,0,.62v.5a.3.3,0,0,0,.11.23.37.37,0,0,0,.14.07h.42l.05,0c.17,0,.51,0,.59,0a10.84,10.84,0,0,0,1.14,0v0h.66v0c.22,0,.57,0,.93,0h-.18c.42,0,.89,0,1.27,0a.89.89,0,0,1,.23,0h.33l0,0h0c.11,0,.09,0,0,0h.15c.09,0,.29,0,.4,0l.12,0h.12a.32.32,0,0,0,.12-.08.31.31,0,0,0,.07-.34s0,0,0,0v-.35l0,0,0-.27c0-.16,0-.23.06-.07,0-.38,0-.31,0-.64l0,0c0-.06,0-.14,0-.21V30s0-.06,0-.09a.24.24,0,0,0-.09-.15l-.11-.05h-.63c-.37,0-.8,0-1.14,0,.13.06-.31,0-.34,0s-.14,0,0,0c-.25,0-.5,0-.75,0,0,0,.07,0,0,0h-.15s0,0,.11,0c-.36,0-.39,0-.42.08a1.34,1.34,0,0,0-.4,0c-.06,0-.16,0,.05,0h-.35a.13.13,0,0,1-.14-.1s0-.09,0-.08a.67.67,0,0,0,0-.2v-.5a1.36,1.36,0,0,1,0-.45h0c0-.5,0-.22,0-.71l0,0A5.77,5.77,0,0,1,44,27v.1a.28.28,0,0,1,0-.13.18.18,0,0,1,.08-.09.17.17,0,0,1,.1,0l.14,0h-.1c.41,0,0,0,.36,0,.06,0-.07,0,.13.05s.6-.06.89,0c-.07,0-.13,0,0,0a7,7,0,0,0,.79,0s0,0,0,0c.17,0,.55,0,.65,0a.85.85,0,0,0,.23,0h.08a.27.27,0,0,0,.12,0,.3.3,0,0,0,.18-.29v-.23c0-.09,0-.14,0-.14v-.51h0a2.59,2.59,0,0,0,0-.56c0-.08,0,0,0,0s0-.21,0-.29a.31.31,0,0,0-.11-.25.24.24,0,0,0-.11-.06h-.12l-.25,0,0,0c-.11,0-.7,0-1.17,0H46a10.15,10.15,0,0,0-1.46,0l-.35,0c.45,0-.07,0,.12.06h-.15a.21.21,0,0,1-.1-.06l0,0,.06,0a0,0,0,0,0,0,0S44,24.43,44,24.3a1,1,0,0,1,0-.3c0-.44,0-.88,0-1.31,0-.22,0-.44,0-.65v-.16a.17.17,0,0,1,0-.1l.06-.05h.12l-.09,0h.29c.07,0,.1,0-.11,0a1.1,1.1,0,0,0,.36,0c.4,0-.16,0,0,0h.13l.4,0c.16,0,.08,0,.15,0h.46l-.14,0c.16,0,.34,0,.17,0,.25,0,1.37,0,1.52,0s.49,0,.74,0c0,0-.07,0-.06,0h0a.34.34,0,0,0,.14,0s0,0,.06,0a.28.28,0,0,0,.1-.21,3,3,0,0,1,0-.42c0,.17,0-.68,0-.41,0-.2,0,0,0-.16a6.93,6.93,0,0,1,0-.79.31.31,0,0,0-.3-.29h-.55s.09,0,0,0l-.31,0c-.12,0-.11.05-.32,0,0,0,.07,0,0,0-1.16,0-2.36,0-3.54-.05.16,0,.06,0-.06,0,.08,0,0,0,0,0l-.49,0c-.09,0-.53,0-.58,0h.16c-.21,0,.29.09.26.13.23,0,.61.07,1,0,.08,0-.07,0,0,0a1.55,1.55,0,0,1,.43,0h0c.61,0,.87,0,1.55,0l0,0h.25c.16,0-.41,0-.26,0s1,0,1.16.06-.07,0,.16,0h.06l.06,0a.39.39,0,0,1,.22,0H47c.19,0,.54,0,.6,0h.49a.12.12,0,0,1,.09.09v.47c0,.17,0,.32,0,.47l0,0c0,.45,0,.36,0,.86v.05s0,0,0,0a.15.15,0,0,1-.11.07h0c-.05,0-.1,0,0,0a2.76,2.76,0,0,0-.57.06l-.07,0a2.31,2.31,0,0,1-.37,0c.2,0-.16,0,.07-.05-.52,0-.77,0-1,0s.45,0,.32,0c.11,0-.2,0-.37,0a5.35,5.35,0,0,0-.7-.07h.09c-.16,0-.31,0-.5,0s-.25,0-.28,0H45a6.79,6.79,0,0,1-.78,0,.76.76,0,0,1,.21,0H44.1s.07,0,.1,0h.19a3,3,0,0,0,.42,0c-.11,0-.44,0-.32,0a.77.77,0,0,1-.3,0h-.12a.24.24,0,0,0-.12.07.23.23,0,0,0-.08.12.23.23,0,0,0,0,.14l0,0c0,.05,0,.14,0,.22l0-.15c0,.23,0,.45,0,.67,0-.47,0-.1,0-.3,0,.56-.06.32-.05,1,0-.09,0-.32,0-.19a1.86,1.86,0,0,1,0,.36c0,.42,0-.07,0,.11a1.7,1.7,0,0,0,0,.39h0c0,.24,0,.28,0,.3a.13.13,0,0,1,0,.06.39.39,0,0,0,0,.09.28.28,0,0,0,.06.15.36.36,0,0,1-.07-.1.27.27,0,0,1,0-.12v.08a.31.31,0,0,0,0,.08.29.29,0,0,0,.1.12l-.07,0a.36.36,0,0,0,.22.11h.42c-.06,0,0,0,.24,0s-.08,0,.22,0a.62.62,0,0,1-.27,0l-.08,0H45l.44,0c.07,0,0,0,0,0l.28,0s0,0-.21.05l.41,0s.22,0,.16,0c.24,0,.57,0,.88,0h.47s0,0,.05.06V25l0,.2c0,.26,0-.27.05.18s0,.12,0,.23a2.9,2.9,0,0,1,0,.72,2.25,2.25,0,0,1,0-.26m-2.55.6a.65.65,0,0,1,.24,0,.65.65,0,0,1-.24,0m.17,3.2h0m-3.49-.05h0c0,.14,0,.09,0,0m0-.3s0,0,0,0a.49.49,0,0,1,0,.17.76.76,0,0,0,0-.15m3.73-7.77h-.06c.13,0,.09,0,.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4881",
    "data-name": "Path 4881",
    className: "cls-3",
    d: "M44.53,29.85l0,0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4883",
    "data-name": "Path 4883",
    className: "cls-3",
    d: "M43.91,31.86h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4884",
    "data-name": "Path 4884",
    className: "cls-3",
    d: "M41.58,27.89v.19a1,1,0,0,1,0-.17s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4885",
    "data-name": "Path 4885",
    className: "cls-3",
    d: "M41.73,26.25v-.09h0c0,.12,0,.2,0,.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4886",
    "data-name": "Path 4886",
    className: "cls-3",
    d: "M41.66,27.72a.62.62,0,0,0,0-.27v0s0,.1,0,.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4887",
    "data-name": "Path 4887",
    className: "cls-3",
    d: "M41.67,27.42V27.3s0,.05,0,.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4888",
    "data-name": "Path 4888",
    className: "cls-3",
    d: "M41.61,29.08c0-.06,0,0,0-.07s0,.42,0,.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4889",
    "data-name": "Path 4889",
    className: "cls-3",
    d: "M41.73,27.61l0,.05,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4890",
    "data-name": "Path 4890",
    className: "cls-3",
    d: "M41.71,28.66v-.21a.22.22,0,0,1,0-.06v.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4892",
    "data-name": "Path 4892",
    className: "cls-3",
    d: "M41.74,27.9v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4893",
    "data-name": "Path 4893",
    className: "cls-3",
    d: "M41.71,30.94v.23s0,0,0-.13,0-.14,0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4894",
    "data-name": "Path 4894",
    className: "cls-3",
    d: "M41.78,30.24a.44.44,0,0,1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4895",
    "data-name": "Path 4895",
    className: "cls-3",
    d: "M41.78,30.91s0,.34,0,.05c0,0,0-.26,0-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4896",
    "data-name": "Path 4896",
    className: "cls-3",
    d: "M44.27,32h-.06V32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4897",
    "data-name": "Path 4897",
    className: "cls-3",
    d: "M47.34,31.82c-.27,0-.06,0-.31,0-.06,0,.2,0,.14,0,.16,0,.25,0,.17,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4898",
    "data-name": "Path 4898",
    className: "cls-3",
    d: "M47.17,31.86h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4899",
    "data-name": "Path 4899",
    className: "cls-3",
    d: "M42.44,19.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4900",
    "data-name": "Path 4900",
    className: "cls-3",
    d: "M42.1,19.3l0,0-.11,0h.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4901",
    "data-name": "Path 4901",
    className: "cls-3",
    d: "M44.44,26.54h0a.38.38,0,0,0,.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4902",
    "data-name": "Path 4902",
    className: "cls-3",
    d: "M46.84,26.56h-.05l.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4903",
    "data-name": "Path 4903",
    className: "cls-3",
    d: "M47.42,25.38v.27c0-.18,0-.29,0-.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4904",
    "data-name": "Path 4904",
    className: "cls-3",
    d: "M52.16,21.59H49.85a.22.22,0,0,1-.22-.22h0V19.61a.22.22,0,0,1,.22-.22h7.29a.22.22,0,0,1,.22.22h0v1.76a.22.22,0,0,1-.22.22h-2.3a.22.22,0,0,0-.22.22h0v9.93a.22.22,0,0,1-.22.22H52.6a.22.22,0,0,1-.22-.22h0V21.81a.22.22,0,0,0-.22-.22h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4905",
    "data-name": "Path 4905",
    className: "cls-3",
    d: "M52.16,21.59H49.85a.22.22,0,0,1-.22-.22h0V19.61a.22.22,0,0,1,.22-.22h7.29a.22.22,0,0,1,.22.22h0v1.76a.22.22,0,0,1-.22.22h-2.3a.22.22,0,0,0-.22.22h0v9.93a.22.22,0,0,1-.22.22H52.6a.22.22,0,0,1-.22-.22h0V21.81a.22.22,0,0,0-.22-.22h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4906",
    "data-name": "Path 4906",
    className: "cls-3",
    d: "M52.18,21.72s0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4907",
    "data-name": "Path 4907",
    className: "cls-3",
    d: "M52.31,22.48h0l0,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4908",
    "data-name": "Path 4908",
    className: "cls-3",
    d: "M52.31,23.39a4,4,0,0,0,0-.49v0l0-.07c0,.2,0,.45,0,.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4909",
    "data-name": "Path 4909",
    className: "cls-3",
    d: "M52.23,23.87s0,.1,0-.11v.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4910",
    "data-name": "Path 4910",
    className: "cls-3",
    d: "M52.23,23.78c0-.1,0,.07,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4911",
    "data-name": "Path 4911",
    className: "cls-3",
    d: "M52.24,24.22V24.1s0,.14,0,.1c0,.13,0,.1,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4912",
    "data-name": "Path 4912",
    className: "cls-3",
    d: "M52.27,24.34v-.06a.13.13,0,0,0,0,.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4913",
    "data-name": "Path 4913",
    className: "cls-3",
    d: "M52.25,24.14v.14s0,0,0-.07,0,0,0-.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4914",
    "data-name": "Path 4914",
    className: "cls-3",
    d: "M52.25,24.06c0-.07,0-.16,0,0,0-.25,0-.21,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4915",
    "data-name": "Path 4915",
    className: "cls-3",
    d: "M52.35,23.44v-.18a.54.54,0,0,0,0,.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4916",
    "data-name": "Path 4916",
    className: "cls-3",
    d: "M52.22,25l0-.05v-.1a.4.4,0,0,1,0,.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4917",
    "data-name": "Path 4917",
    className: "cls-3",
    d: "M52.25,25v.14c0-.13,0-.15,0-.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4918",
    "data-name": "Path 4918",
    className: "cls-3",
    d: "M52.31,24.37l0-.23,0,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4919",
    "data-name": "Path 4919",
    className: "cls-3",
    d: "M52.22,25.54l0-.08,0,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4920",
    "data-name": "Path 4920",
    className: "cls-3",
    d: "M52.22,25.89c0-.05,0,.08,0,0a1,1,0,0,0,0,.25,1.22,1.22,0,0,1,0-.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4921",
    "data-name": "Path 4921",
    className: "cls-3",
    d: "M52.23,26.29a.69.69,0,0,0,0-.13c0,.05,0,.09,0,.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4922",
    "data-name": "Path 4922",
    className: "cls-3",
    d: "M52.26,25.33a.23.23,0,0,0,0,.11l0-.05v-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4924",
    "data-name": "Path 4924",
    className: "cls-3",
    d: "M52.26,25.32h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4925",
    "data-name": "Path 4925",
    className: "cls-3",
    d: "M52.29,24.73c0,.09,0,.26,0,.09s0,0,0-.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4926",
    "data-name": "Path 4926",
    className: "cls-3",
    d: "M52.29,25.25V25.1s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4927",
    "data-name": "Path 4927",
    className: "cls-3",
    d: "M52.29,25.32v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4928",
    "data-name": "Path 4928",
    className: "cls-3",
    d: "M52.25,26a1.7,1.7,0,0,1,0,.22c0-.09,0-.17,0-.26s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4931",
    "data-name": "Path 4931",
    className: "cls-3",
    d: "M52.27,26a.33.33,0,0,0,0-.14V26h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4932",
    "data-name": "Path 4932",
    className: "cls-3",
    d: "M52.24,26.5v-.11a.45.45,0,0,0,0,.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4934",
    "data-name": "Path 4934",
    className: "cls-3",
    d: "M52.25,25.75a.24.24,0,0,0,0,.09.37.37,0,0,0,0-.11v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4935",
    "data-name": "Path 4935",
    className: "cls-3",
    d: "M52.4,27.26a.58.58,0,0,1,0-.32c0-.15-.09-.05-.12.07s0,0,0,.15c0-.05,0-.32,0-.2a.76.76,0,0,1,0,.26c0-.08,0,.24.08.2l0-.17s0,.05,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4936",
    "data-name": "Path 4936",
    className: "cls-3",
    d: "M52.27,26.73v-.06a1.52,1.52,0,0,1,0,.21c0,.1,0,.12,0,.13v-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4937",
    "data-name": "Path 4937",
    className: "cls-3",
    d: "M52.27,26.4c0,.05,0,.19,0,.1a1,1,0,0,0,0-.23c0,.29,0-.08,0,.13a.81.81,0,0,0,0-.16.76.76,0,0,1,0,.15h0v0c0,.08,0,0,0,0h0v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4938",
    "data-name": "Path 4938",
    className: "cls-3",
    d: "M52.38,25h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4939",
    "data-name": "Path 4939",
    className: "cls-3",
    d: "M52.36,25.09a.41.41,0,0,1,0-.11c0-.06,0,0,0,0s0-.14,0,0v0a2,2,0,0,1,0,.24.58.58,0,0,0,0-.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4940",
    "data-name": "Path 4940",
    className: "cls-3",
    d: "M52.32,25.75V26l0-.12h0c0-.14,0-.11,0-.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4941",
    "data-name": "Path 4941",
    className: "cls-3",
    d: "M52.25,27.05l0,0,0,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4942",
    "data-name": "Path 4942",
    className: "cls-3",
    d: "M52.25,27.36h0l0,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4943",
    "data-name": "Path 4943",
    className: "cls-3",
    d: "M55.12,21.47h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4944",
    "data-name": "Path 4944",
    className: "cls-3",
    d: "M54.55,21.63v0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4945",
    "data-name": "Path 4945",
    className: "cls-3",
    d: "M54.75,31c0-.1,0-.21,0-.2l0,0V31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4946",
    "data-name": "Path 4946",
    className: "cls-3",
    d: "M54.61,25.83v0l0,.07a.44.44,0,0,0,0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4947",
    "data-name": "Path 4947",
    className: "cls-3",
    d: "M54.52,25.76l0-.14a1.15,1.15,0,0,1,0,.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4948",
    "data-name": "Path 4948",
    className: "cls-3",
    d: "M57.21,21l0-.08c0,.12,0,.07,0,.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4949",
    "data-name": "Path 4949",
    className: "cls-3",
    d: "M52.26,30.52a1.86,1.86,0,0,0,0,.22.55.55,0,0,0,0-.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4950",
    "data-name": "Path 4950",
    className: "cls-3",
    d: "M54.92,21.7h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4951",
    "data-name": "Path 4951",
    className: "cls-3",
    d: "M52.25,31v-.25a1,1,0,0,0,0,.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4953",
    "data-name": "Path 4953",
    className: "cls-3",
    d: "M51.32,21.69h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4955",
    "data-name": "Path 4955",
    className: "cls-3",
    d: "M52.33,28.28a0,0,0,0,0,0,0v0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4957",
    "data-name": "Path 4957",
    className: "cls-3",
    d: "M52.26,28.5a.28.28,0,0,1,0,.09.39.39,0,0,1,0-.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4958",
    "data-name": "Path 4958",
    className: "cls-3",
    d: "M52.25,28.52v-.06s0,0,0,.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4960",
    "data-name": "Path 4960",
    className: "cls-3",
    d: "M54.21,19.46h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4962",
    "data-name": "Path 4962",
    className: "cls-3",
    d: "M54.5,29.08a.65.65,0,0,1,0,.24l.06-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4963",
    "data-name": "Path 4963",
    className: "cls-3",
    d: "M56.33,21.46l-.17,0c.2,0,.35,0,.19,0s-.64,0-.66.07h0c-.21,0-.15.05-.43,0-.1,0-.16,0-.1,0l-.21,0c-.06,0,0,0,0,0h-.08l-.12,0a.35.35,0,0,0-.18.16h0a.22.22,0,0,0,0,.14c0,.05,0,.08,0,.11s0,0,0,0v.18c0,.07,0-.08,0-.2-.07.16,0,.15,0,.51v-.17a2,2,0,0,0,0,.43c0-.05.06-.38.08-.19a.88.88,0,0,0,0,.23s0,.1,0,.23h0a1.18,1.18,0,0,0,0,.2.37.37,0,0,1,0,.23c0,.24,0-.17,0,.12a4,4,0,0,0,0,.6c0,.14,0,0,0,0l0,.13s0,0,0,0,0,0,0,.18-.06.34,0,.55c0,.05,0,0,0,0a4.46,4.46,0,0,0,.06.48l0,.2c0-.14,0,0,.07.21a1.3,1.3,0,0,1,0-.13l0,.26s0,0,0,0v0c0,.1,0,.05-.05,0l0-.09c0-.07-.05-.13-.06-.11v.08s0,0,0,0,0,.05,0,.08l0,.06v0l0,.34a6,6,0,0,1,.1.85c0-.1,0,0-.08,0a4.17,4.17,0,0,0,0-.5c0,.11,0,.08,0,.06l0,.36s0,.07,0,.17c0-.07,0,.27,0,.41s0,0,0-.2c0,.2.06.25,0,.45a.28.28,0,0,0,0-.09c0,.1,0,.36,0,.3v-.05a4.83,4.83,0,0,0,0,.93l-.06-.05.15.51s-.13.13-.15-.11a1.5,1.5,0,0,0,0,.3s.06-.11.06-.05a2,2,0,0,0-.06.34c0-.07.07,0,.07.12s-.06,0-.07,0l.06.28c0-.07-.05,0-.07.05s0,.24,0,.31l0-.11c0,.31.08.31.07.62,0,0-.07-.1-.07.06s0,.12.08.23,0,.11,0,.17a.44.44,0,0,0,0,.1.24.24,0,0,1,0,.12l0,.06a.3.3,0,0,1-.22.14.29.29,0,0,0,.15-.09.25.25,0,0,0,.05-.19c0-.13-.07-.28-.09-.38a.74.74,0,0,0,0,.21c0,.06,0-.1,0-.15v.31a0,0,0,0,0,0,0s0,0,0,.06l-.06,0s0,0,0,0h.08a.09.09,0,0,0,.05,0l0-.05v-.08a.11.11,0,0,1,0,0,.08.08,0,0,1,0,.08.13.13,0,0,1-.1.1.14.14,0,0,1-.09,0h-.11c-.07,0,.06-.06.05-.07a1.51,1.51,0,0,1-.3,0l.12,0a3.49,3.49,0,0,1-.46,0c-.06,0-.2,0-.21,0s.13.16.06.19L53.05,32c-.11,0,.17-.07.07-.1l-.09,0c-.07,0,0,0-.12,0s-.31,0-.07,0h-.23l-.08,0s0,0-.08,0a.15.15,0,0,1-.08-.08.43.43,0,0,1,0-.12s0,0,0,0c0-.3,0-.47,0-.76,0,0,0-.16,0-.1a1,1,0,0,1,0-.17c0-.17,0,.2,0,.07a1.47,1.47,0,0,1,0-.36,1.19,1.19,0,0,0,0,.42c-.05,0-.09-.22-.11-.52s0-.1,0-.14c0-.45-.07-.38,0-.75,0-.15.05,0,.07,0,0,.19,0,.3,0,.43v-.16a2.17,2.17,0,0,1,0,.26c0-.13,0-.76,0-1.1,0-.06,0-.17,0-.12v.11c0,.1,0-.21,0-.07a2.9,2.9,0,0,1,0-.51l0,0a.41.41,0,0,0,0,.19c0-.09,0-.32,0-.41l0,.14a2.85,2.85,0,0,1,0-.51c0,.09,0,.05,0,.18,0-.12,0,.46,0,.28a3.62,3.62,0,0,0-.05.4s0-.06,0,.09a.06.06,0,0,1,0,0h0a.19.19,0,0,1,0-.08c0,.08,0,.32,0,.4s0,0,0,0l0,.12s0,.25,0,0v.2a1.45,1.45,0,0,0,0,.36c0,.09,0,.23,0,.15V30h0a7.69,7.69,0,0,1,0,1c0,.12,0,.25,0,.37l0,0v.37a.13.13,0,0,0,0,.06.09.09,0,0,0,0,.05.31.31,0,0,0,.14.23.36.36,0,0,0,.18.07h.59v0h.5v0c.17,0,.43,0,.69,0a.29.29,0,0,1-.13,0h.19a.33.33,0,0,0,.32-.3v-.14a.49.49,0,0,0,0-.12,1.62,1.62,0,0,1,0-.22v-.17h0V31s0,0,0,.08a1.77,1.77,0,0,0,0-.22l0,0v0c0-.08,0-.06,0,0a.36.36,0,0,0,0-.11c0-.06,0-.21,0-.3a3.47,3.47,0,0,0-.06-.45s0,0,0,0a1.22,1.22,0,0,0,0-.27l0,0,0-.2c0-.12,0-.17,0-.05,0-.29,0-.23,0-.48h0a2.62,2.62,0,0,1,0-.28c0-.2,0-1,0-1.48,0,.1,0-.24,0-.26s0-.1,0,0a3.54,3.54,0,0,0,0-.56s0,.05,0,0v-.11s0,0,0,.08c0-.27,0-.29-.09-.31a.61.61,0,0,0,0-.3c0-.05,0-.13,0,0a2.82,2.82,0,0,0,0-.58.38.38,0,0,0,0-.15v-.37c0-.08,0-.17,0-.34h0c0-.37,0-.16,0-.53l0,0c-.05,0,0-.33,0-.54v.08a2.23,2.23,0,0,1,.08-.45s0,0,0,.08c0-.31,0,0,0-.27,0,0,0,.05,0-.1s0-.44,0-.66c0,0,0,.09,0,0a.65.65,0,0,1,0-.14s0-.06,0-.07l.08,0H55l.48,0c.12.08.78,0,.78,0h.37a1.49,1.49,0,0,0,.42,0c.06,0,0,0,0,0h.14a.31.31,0,0,0,.12-.05.28.28,0,0,0,.15-.26V21.3l0-.19,0,0c0-.08,0-.52,0-.87,0,0,0,0,0,0,0-.22,0-.43,0-.65a.33.33,0,0,0-.24-.32s-.06,0-.08,0H57.1l-.07,0-.26,0c.34,0-.05,0,.09.06-.13,0-.35,0-.18,0h0c.06,0-.42,0-.41,0-.67,0-1.32,0-1.94,0l.07,0H54.2c-.05,0-.07,0,.08,0a.74.74,0,0,0-.26,0c-.3,0,.12,0,0,0h-.1a1.53,1.53,0,0,1-.3,0c-.11,0-.06,0-.1,0h-.35l.11,0c-.12,0-.26,0-.13,0-.19-.05-1,0-1.14,0a3.37,3.37,0,0,1-.55,0c.05,0,.09,0-.1,0,.07-.07-.33,0-.47-.08.13,0-.51,0-.31,0-.15,0,0,0-.12,0a5.81,5.81,0,0,1-.59,0,.38.38,0,0,0-.2,0,.28.28,0,0,0-.15.17.36.36,0,0,0,0,.11v.25s0-.07,0,0l-.05.23c0,.09.06.08,0,.24,0,0,0-.06,0,0,0,.22,0,.44,0,.66v.33a.31.31,0,0,0,.07.2.31.31,0,0,0,.2.11h.67c.22,0,.45,0,.66,0-.11,0,0,0,.06,0-.06,0,0,0,0,0l.37,0c.07,0,.4,0,.44,0h-.12c.16,0-.22-.08-.19-.13-.18,0-.46-.06-.75,0-.06,0,.06,0,0,0a.85.85,0,0,1-.32,0h-.8a.13.13,0,0,1-.1-.13s0,0,0,0v-.17c0-.06,0,0,0,.1v.08s0,0,0,0a.5.5,0,0,0,0-.17V21a1.49,1.49,0,0,1,0-.42c0-.17,0,0,0-.12v0l0,0c0-.11,0-.17,0-.17v.1c0-.15,0-.4,0-.46V20c0-.11,0-.23,0-.36a.09.09,0,0,1,0-.08l0,0h.06c.25,0,.5,0,.72,0h0c.34,0,.27,0,.64,0h0l.28,0c-.1,0,.17,0,0,0a1.47,1.47,0,0,0,.42-.06l.06,0a1.27,1.27,0,0,1,.28,0c-.16,0,.12,0-.06.05a7.23,7.23,0,0,1,.76,0c.18-.05-.34,0-.23,0-.09,0,.14,0,.27,0a4.35,4.35,0,0,0,.52.06h-.06c.11,0,.23,0,.37,0s.19,0,.21,0h-.29a2.92,2.92,0,0,1,.59,0l-.16,0c.08,0,.15,0,.23,0a3,3,0,0,1-.52,0c.08,0,.33,0,.24,0,.13-.06.31,0,.52,0v0h.17l-.12,0a4.13,4.13,0,0,1,.5,0c-.34,0-.07,0-.22-.05.43,0,.25.07.72.05-.06,0-.24,0-.14,0l.27,0c.31,0,0,0,.08,0s.16,0,.3,0v0c.36,0,.1,0,.41,0l-.13,0h.17l0,0a2,2,0,0,1,.42,0s0,0,0,0h.13s0,0,0,0,0,0,0,.05a.24.24,0,0,1-.08-.06l0,0s.09.05.08.11v.08l0,.16c0,.06,0,0,0,0s0,.12,0,.21,0,0-.05-.15l0,.31s0,.16,0,.12c0,.17,0,.42,0,.65a.28.28,0,0,1,0,.09c0,.1,0,.2,0,.31l0,0a.11.11,0,0,1-.07,0l-.15,0c-.2,0,.2.05-.13.06s-.09,0-.17,0a2,2,0,0,1-.54,0,1.2,1.2,0,0,1,.19,0m-1.82,1a.47.47,0,0,1,0-.17.24.24,0,0,1,0,.17m.06,3.76a.43.43,0,0,1,0-.16.86.86,0,0,1,0,.16m-2.3,3.12h0c0,.1,0,.07,0,0m0-.22s0,0,0,0v.12a.2.2,0,0,0,0-.11m1.24-9.8h0c-.1,0-.07,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4964",
    "data-name": "Path 4964",
    className: "cls-3",
    d: "M54.53,25.77l0,0s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4965",
    "data-name": "Path 4965",
    className: "cls-3",
    d: "M57.22,21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4966",
    "data-name": "Path 4966",
    className: "cls-3",
    d: "M53.05,31.86h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4967",
    "data-name": "Path 4967",
    className: "cls-3",
    d: "M52.23,27.92v.15a.53.53,0,0,1,0-.13s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4968",
    "data-name": "Path 4968",
    className: "cls-3",
    d: "M52.38,26.69v-.07h0c0,.09,0,.15,0,.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4969",
    "data-name": "Path 4969",
    className: "cls-3",
    d: "M52.32,27.79s0-.1,0-.2v0s0,.08,0,.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4970",
    "data-name": "Path 4970",
    className: "cls-3",
    d: "M52.32,27.57v-.09s0,0,0,.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4971",
    "data-name": "Path 4971",
    className: "cls-3",
    d: "M52.26,28.82c0-.05,0,0,0-.06s0,.31,0,.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4972",
    "data-name": "Path 4972",
    className: "cls-3",
    d: "M52.38,27.71l0,0,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4973",
    "data-name": "Path 4973",
    className: "cls-3",
    d: "M52.37,28.5v-.16a.1.1,0,0,0,0,0v.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4974",
    "data-name": "Path 4974",
    className: "cls-3",
    d: "M52.36,28.3a.28.28,0,0,0,0-.13v.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4975",
    "data-name": "Path 4975",
    className: "cls-3",
    d: "M52.39,27.93v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4976",
    "data-name": "Path 4976",
    className: "cls-3",
    d: "M52.36,30.2v.18s0,0,0-.1,0-.1,0-.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4977",
    "data-name": "Path 4977",
    className: "cls-3",
    d: "M52.43,29.68a.24.24,0,0,1,0,.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4978",
    "data-name": "Path 4978",
    className: "cls-3",
    d: "M52.44,30.19s0,.25,0,0c0,0,0-.19,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4979",
    "data-name": "Path 4979",
    className: "cls-3",
    d: "M53.32,32h0V32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4980",
    "data-name": "Path 4980",
    className: "cls-3",
    d: "M54.48,30.87c0,.2,0,.05,0,.23s0-.15,0-.1c0-.12,0-.19,0-.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4981",
    "data-name": "Path 4981",
    className: "cls-3",
    d: "M54.52,31v.06s0,0,0-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4982",
    "data-name": "Path 4982",
    className: "cls-3",
    d: "M51.8,21.72h.13l-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4983",
    "data-name": "Path 4983",
    className: "cls-3",
    d: "M52.05,21.68l0,0,.08,0h-.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4984",
    "data-name": "Path 4984",
    className: "cls-3",
    d: "M54.44,22.81h0a.45.45,0,0,0,0-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4985",
    "data-name": "Path 4985",
    className: "cls-3",
    d: "M55.29,21.44h0l.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4986",
    "data-name": "Path 4986",
    className: "cls-3",
    d: "M56.79,21.4h-.2c.13,0,.21,0,.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4987",
    "data-name": "Path 4987",
    className: "cls-3",
    d: "M23.83,12.84c.16-.13.31-.25.46-.39l.3-.26.14-.13.27-.24.16-.14.68-.6.49-.43.49-.42.42-.35.48-.41.37-.31.55-.43c.27-.21.54-.42.82-.62l.68-.45c.13-.08.17-.07.26,0a.64.64,0,0,0,.25.15.25.25,0,0,1,.14.25.88.88,0,0,0,0,.17.24.24,0,0,1,0,.12,1.07,1.07,0,0,1-.2.38,8,8,0,0,1-.87.88l-.79.73c-.27.24-.54.47-.8.72s-.74.73-1.11,1.09a5.86,5.86,0,0,0-.57.66l-.35.45c-.13.19-.24.38-.36.57s-.25.4-.37.61-.3.51-.46.76-.21.29-.32.43a.61.61,0,0,1-.12.15,1.56,1.56,0,0,1-.2.16l0,0c-.08,0-.1.05-.14.1l0,.07H24v-.06c0-.05,0-.09.06-.12s0-.09,0-.14a1.23,1.23,0,0,1,0-.2,6.94,6.94,0,0,1,.25-.81c.07-.18.13-.35.2-.52s.25-.57.38-.85a.56.56,0,0,0,0-.12h0l-.37.33c-.42.35-.82.71-1.24,1.05s-.89.69-1.34,1l-.72.55a.5.5,0,0,1-.39.1.38.38,0,0,1-.13-.06,2,2,0,0,1-.22-.09.1.1,0,0,1-.05-.06.45.45,0,0,1,0-.28h0a1.27,1.27,0,0,0,.13-.32.9.9,0,0,1,.13-.28l.43-.65c.09-.12.19-.24.28-.37s.25-.34.38-.5l.33-.41.27-.33.32-.4v0l.3-.35.25-.33.23-.28.16-.2.29-.34c.09-.12.18-.24.28-.35l.23-.29.34-.42.29-.35.3-.38,0,0,.33-.38.33-.41v0l.4-.45c.14-.14.28-.32.41-.48l0-.05.53-.58.14-.15.3-.33c.2-.21.39-.42.6-.63l.52-.5c.22-.21.43-.43.66-.63s.5-.45.75-.68L31,3.59c.28-.23.56-.46.85-.68l.12-.11v0h-.06l-.15,0-.25.08h0l-.13,0H31.2l-.07,0h0l-.24,0a.54.54,0,0,0-.22,0c-.07.06-.17,0-.22.08h0l-.11,0h-.07s-.08,0-.11,0h0l-.23.05a.87.87,0,0,0-.22,0,1.81,1.81,0,0,1-.31.09c-.07,0-.15,0-.19,0s-.16,0-.22.08h0l-.12,0-.09,0s-.06,0-.08,0h0l-.22.05-.27.08h-.06l-.1,0-.08,0s-.07,0-.09,0h0a.37.37,0,0,0-.3.16l-.61.66-.48.56L26,5.76l-.47.54-.4.46-.33.4-.4.47L24,8l-.54.65L23.27,9l-.43.54-.39.5-.47.63-.36.48-.44.63c-.15.21-.31.43-.45.65-.3.46-.6.92-.89,1.39A16.21,16.21,0,0,0,19,15.31c-.1.21-.19.42-.28.63a1.42,1.42,0,0,0-.08.18s0,.05,0,.07l.2,0a.32.32,0,0,0,.26-.17,1.71,1.71,0,0,1,.21-.26v0a.41.41,0,0,1-.07.11,2.43,2.43,0,0,1-.2.25l0,.07-.09.26a.16.16,0,0,1,0,.07,1.73,1.73,0,0,1-.53.58,1.27,1.27,0,0,1-.27.18.37.37,0,0,1-.29,0l-.18-.07a.21.21,0,0,1-.13-.16.9.9,0,0,1,0-.46c0-.18.1-.37.15-.54s.08-.26.13-.38.12-.31.19-.46.11-.24.16-.36c.2-.45.44-.89.68-1.32l.27-.45.3-.51c.15-.24.31-.47.47-.71l.24-.36.27-.38.28-.4.18-.24L21,10.2l.15-.21.41-.54c.08-.11.18-.21.27-.32l.24-.33.19-.23.29-.35.37-.44s0,0,0,0l.36-.4c.14-.17.28-.33.41-.5l0,0,.44-.49,0,0,.54-.62.15-.17.87-.91.14-.18,0,0-.26.08h0l-.12,0h-.07s-.08,0-.1,0h0l-.25,0-.26.07h0l-.25.06-.07,0-.06,0-.13,0h0L24,4.9l-.08,0-.11,0-.07,0-.11,0-.06,0L23.5,5l-.14,0h0l-.26,0a.76.76,0,0,0-.2.06.41.41,0,0,1-.16,0h0c0,.06-.08,0-.12,0s-.07,0-.08,0h0l-.25.05-.29.08h0l-.13,0h-.06l-.12,0h0l-.24,0-.28.08h0l-.27.06a.59.59,0,0,0-.23,0,.33.33,0,0,1-.14,0l-.25.08h-.05l-.12,0h0L19.8,6h0l-.24,0-.3.08h0l-.26,0c-.06,0-.14,0-.17,0s-.17,0-.23.08h-.06l-.09,0h0l-.5.14-.33.13-.33.12-.87.4-.88.42a.26.26,0,0,1-.28,0h-.07A.16.16,0,0,1,15,7.34a.18.18,0,0,1,0-.09.18.18,0,0,0,.07-.17.3.3,0,0,1,0-.1,1,1,0,0,1,.35-.35c.55-.28,1.08-.58,1.63-.86A8.31,8.31,0,0,1,18,5.42c.25-.1.51-.18.77-.26L19,5.09l.17,0L19.43,5l.35-.1.43-.13.41-.11.5-.14.46-.13.4-.12.54-.15L22.77,4h0l.45-.12.37-.11.21,0c.12-.05.24-.08.36-.12l.54-.15L25,3.38l.23-.07.26-.08.33-.1L26.2,3,26.44,3l.24-.09.34-.1.41-.12.24-.06,0,0,1.06-1c.26-.25.52-.51.8-.75s.5-.46.74-.7c.05-.06.06,0,.11,0l.17.11a.16.16,0,0,1,.1.14.38.38,0,0,1,0,.21.62.62,0,0,1-.1.22,2.17,2.17,0,0,1-.24.29l-.84.86a1.15,1.15,0,0,0-.14.17L29.67,2l.58-.17.35-.1.95-.28.65-.18L33.06,1l.8-.2L34.92.56c.25-.05.49-.12.74-.16l.82-.13a.23.23,0,0,1,.19.09A.57.57,0,0,0,37,.54a.07.07,0,0,1,0,0l0,.06a.15.15,0,0,1,0,.18.12.12,0,0,0,0,.16.13.13,0,0,1,0,.06.92.92,0,0,1-.18.32l-.28.24a.05.05,0,0,1,0,0l-.31.07-.3.07H35.9l-.3.05c-.07,0-.15,0-.21,0L35,2l-.19,0-.2,0-.25.08h-.08s-.08,0-.1,0h0l-.33.08h0c-.11,0-.18.06-.26.12-.28.19-.55.39-.81.58l-.37.3c-.13.1-.26.2-.38.31l-.41.34-.6.57-.7.7L29,6.43l-.62.7-.63.76-.55.65-.3.37-.28.35-.3.37-.26.32-.26.33-.26.33-.25.31-.22.28-.46.59-.42.54-.22.3-.1.11,0,.07h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4988",
    "data-name": "Path 4988",
    className: "cls-3",
    d: "M17.93,17.35a.47.47,0,0,1-.17,0l-.12,0-.06,0a.23.23,0,0,1-.15-.18,1,1,0,0,1,0-.48c.05-.2.1-.37.15-.54s.08-.24.13-.37.13-.33.19-.47L18,15l.07-.14c.2-.44.42-.87.68-1.32l.18-.31.09-.14.09-.16.21-.35.37-.56.1-.15.24-.36.17-.24.1-.14.11-.16.17-.24.11-.15.07-.09.11-.15.1-.13.15-.21.11-.14.3-.4.15-.18c0-.06.08-.1.12-.15s.1-.13.15-.19l.1-.13a1.62,1.62,0,0,1,.18-.23l.16-.2.13-.16.31-.37.06-.07h0l0,0L23,7.58c.08-.08.15-.17.23-.26l.3-.35.12-.14h0l0,0,.43-.49h0l.58-.66.11-.13.33-.34.54-.58.09-.11,0,0-.14,0-.09,0h-.08l-.08,0h-.11s0,0,0,0l0,0h-.08l-.16,0-.19,0-.08,0h0l-.08,0-.17,0h-.07l-.06,0-.07,0-.05,0h0l-.07,0-.17,0,0,0h-.18l0,0h-.14l0,0H23.5l-.08,0h-.08l-.1,0-.16,0H23a.33.33,0,0,0-.13,0,.37.37,0,0,1-.15,0h0a.1.1,0,0,1-.1,0h-.06s0,0,0,0l0,0-.09,0-.16,0L22,5.45l-.1,0a0,0,0,0,1,0,0h0l-.06,0-.07,0h-.05l-.1,0h-.12l-.16,0-.19,0-.09,0h0l-.27,0-.07,0a.32.32,0,0,0-.14,0l-.1,0h-.05l-.15,0-.1,0h-.05l-.07,0h-.1l-.11,0h0l-.08,0-.16,0-.22.05-.1,0h-.1l-.18,0h-.05a.19.19,0,0,0-.1,0,.2.2,0,0,1-.13,0,.14.14,0,0,0-.1,0h-.06l-.07,0h0l-.15,0-.35.1-.22.08-.1,0-.11,0a2,2,0,0,0-.22.09c-.27.11-.55.25-.87.4l-.34.16-.54.25a.29.29,0,0,1-.31,0h0A.18.18,0,0,1,15,7.23a.24.24,0,0,0,.07-.16.19.19,0,0,1,0-.12.87.87,0,0,1,.36-.35c.21-.11.42-.22.62-.34l1-.52a7.19,7.19,0,0,1,.76-.32l.1,0,.63-.21.15,0,.1,0,.14,0,.11,0h.06l.1,0,.13,0,.18-.05.17,0,.2-.06.24-.07.21,0,.2-.06.26-.07.24-.07.23-.07.23-.06.21-.06L22,4.21l.25-.07.28-.08.17,0h.09l.13,0,.33-.08.18-.06.19-.05.08,0,.12,0A1,1,0,0,1,24,3.65l.14,0,.35-.1.18,0,.12,0,.11,0,.12,0,.12,0,.13,0,.12,0,.18-.05.16,0,.18-.05L26.18,3l.11,0,.12,0,.12,0,.12,0,.18-.06.16,0,.18-.06.23-.07.13,0,.11,0,0,0L28,2.2l.71-.7.08-.08c.23-.22.47-.46.72-.67s.52-.48.74-.7c.06-.07.09-.06.15,0a.64.64,0,0,0,.16.11.17.17,0,0,1,.11.16.54.54,0,0,1,0,.22.62.62,0,0,1-.1.22,1.81,1.81,0,0,1-.25.3l-.53.54-.31.31-.1.12h0l.2,0,.33-.1.25-.08.18-.05.17-.05.4-.11.55-.16.65-.18L33,1l.1,0,.7-.18.86-.2.2,0,.19,0L35.63.4l.55-.08.27,0a.23.23,0,0,1,.22.1.54.54,0,0,0,.26.16.1.1,0,0,1,.06,0l0,0v0a.18.18,0,0,1,0,.21.12.12,0,0,0,0,.13.1.1,0,0,1,0,.09.8.8,0,0,1-.19.32l-.28.25s0,0-.06,0l-.14,0-.17,0-.18,0-.12,0h-.17l-.2,0-.12,0h-.1A2,2,0,0,1,35,2L35,2l-.12,0h-.07l-.07,0a.61.61,0,0,0-.13,0l-.13,0-.12,0H34.2s-.05,0-.05,0,0,0,0,0h0l-.34.08h0a.32.32,0,0,0-.21.08l0,0L32.65,3l-.23.19-.13.11-.19.15-.2.16-.08.07L31.5,4c-.22.2-.42.38-.6.56s-.45.44-.7.7S29.44,6,29,6.47c-.2.2-.38.42-.56.63l-.06.07L28,7.66l-.22.26-.22.26-.33.4L27,8.8l-.12.14-.14.17-.15.18-.3.37-.18.23-.39.5-.2.26-.17.21-.13.17-.16.21-.07.09-.4.5-.16.21c-.09.1-.17.21-.26.32l-.12.17a.73.73,0,0,1-.1.13v0l.3-.26.21-.18.23-.21.27-.24.16-.13.19-.17.49-.44L25.9,11l.42-.37.49-.42.42-.35.32-.26.28-.23.25-.22h0l.54-.43.08-.06.74-.55c.22-.16.46-.32.68-.46s.19-.07.3.05a.74.74,0,0,0,.21.13h0a.28.28,0,0,1,.15.28.38.38,0,0,0,0,.1s0,0,0,.06v0a.2.2,0,0,1,0,.11,1.28,1.28,0,0,1-.21.38,8.21,8.21,0,0,1-.88.89c-.16.14-.32.28-.47.43L29,10.4l-.3.28-.5.44-.65.64-.45.45a5.86,5.86,0,0,0-.57.66,1.83,1.83,0,0,0-.13.16l-.22.29c-.11.16-.22.33-.32.5l0,.07c-.11.17-.22.36-.32.53l-.05.08-.15.25c-.1.16-.2.34-.3.51l-.24.32-.09.11a1,1,0,0,1-.13.16l-.15.13,0,0-.06,0a.1.1,0,0,0-.1.07v0h0l0,.06H24v-.05a0,0,0,0,1,0-.05A.93.93,0,0,0,24,16h0v0a.22.22,0,0,1,0-.1,1.23,1.23,0,0,1,0-.2,5.56,5.56,0,0,1,.25-.82l.09-.23a2.49,2.49,0,0,1,.11-.29c.08-.19.17-.38.25-.56l.13-.29s0,0,0-.05l-.07.06-.26.23-.31.26c-.3.26-.61.53-.92.78l-1,.81-.3.23-.31.23-.42.31a.54.54,0,0,1-.41.11l-.1,0,0,0-.06,0-.16-.07a.18.18,0,0,1-.07-.08.48.48,0,0,1,0-.29h0a1.2,1.2,0,0,0,.13-.31,1.11,1.11,0,0,1,.14-.29c.15-.24.31-.47.43-.65l.2-.27.07-.1.08-.1c.1-.14.2-.28.31-.41s.2-.25.29-.37l0,0,.14-.16.13-.17.23-.28.1-.12v0l.09-.1a2.43,2.43,0,0,0,.2-.25l.16-.2.1-.12.17-.2.1-.13.12-.15.13-.15.16-.2c.06-.06.12-.15.18-.22l.1-.12.23-.29.05-.06.29-.36.14-.18.15-.17.21-.27.11-.13,0,0,.1-.12.22-.25L26,8.63l.1-.13h0l.12-.14c.09-.1.19-.2.28-.31l.3-.35.11-.13v0l0,0,.53-.58.07-.08.07-.08.07-.08.22-.24L28,6.31l.47-.49.31-.3.21-.2.26-.25.4-.39.53-.47.22-.2.14-.13.35-.3.57-.46.28-.23a.27.27,0,0,0,.08-.07h0l-.14,0-.16,0-.08,0h-.08l-.09,0h-.09l0,0h0l-.17,0H30.8a.33.33,0,0,0-.14,0,.28.28,0,0,1-.12,0,.17.17,0,0,0-.1,0,.06.06,0,0,1-.05,0l-.06,0h0l-.07,0h0s0,0-.05,0l0,0-.23.05h-.07a.42.42,0,0,0-.15,0l-.27.08h-.11a.25.25,0,0,0-.11,0,.17.17,0,0,1-.12,0,.11.11,0,0,0-.09,0l0,0h-.06l-.07,0h-.11s0,0,0,0l0,0h-.08l-.14,0-.17.05-.1,0H28l-.05,0h-.06l-.07,0h-.07a.05.05,0,0,1-.05,0h0a.33.33,0,0,0-.27.15c-.1.12-.21.23-.32.34l-.29.32-.31.36-.17.2-.2.23L26,5.77l-.28.33-.34.4-.24.27c-.12.13-.23.27-.34.4l-.4.47L24,8l-.53.65,0,0L23.27,9l-.22.29-.2.26-.15.19-.24.3-.34.45-.24.33-.25.33-.44.63-.11.15-.34.5-.89,1.39c-.3.5-.58,1-.83,1.54-.06.15-.13.29-.19.43l-.09.2,0,.06-.06.12s0,0,0,0h0l.14,0a.25.25,0,0,0,.23-.15,2,2,0,0,1,.22-.27l0-.05v.07h0v.05l-.05.1a1.34,1.34,0,0,0-.11.14l-.09.11a.09.09,0,0,0,0,.06s0,.09-.05.13l0,.13a.3.3,0,0,1,0,.08,2.32,2.32,0,0,1-.54.59l-.27.17a.35.35,0,0,1-.14,0m7.91-13h0l0,0,0,0,0,.06-.1.12-.54.57-.32.35-.12.13-.58.65v0h0l-.44.48h0v0L23.6,7l-.3.35-.23.27-.13.14h0v0l-.06.07-.31.38-.13.15-.16.2-.19.23L22,9c0,.07-.1.13-.14.19l-.12.15-.15.18-.3.4-.11.14-.15.21-.1.13-.11.15-.07.09-.11.15-.17.24-.11.15-.1.15-.17.24-.24.36-.1.15-.37.56-.21.35-.09.16-.09.14-.18.31c-.26.45-.48.88-.68,1.31L18,15a2.14,2.14,0,0,0-.1.22c-.06.13-.12.28-.19.46a2.84,2.84,0,0,0-.13.38q-.07.24-.15.54a.82.82,0,0,0,0,.44.18.18,0,0,0,.12.15l.06,0,.12.05a.34.34,0,0,0,.26,0,1.78,1.78,0,0,0,.27-.17,2.25,2.25,0,0,0,.53-.58l0-.06a.93.93,0,0,0,0-.13c0-.05,0-.09.05-.13a.07.07,0,0,1,0-.06.3.3,0,0,1-.18.06h-.22v-.06s0,0,0-.06l.06-.12,0-.06.09-.2c.07-.14.13-.28.2-.43a13.46,13.46,0,0,1,.83-1.54c.29-.48.6-.95.89-1.39.11-.17.22-.34.34-.5l.11-.15c.14-.22.3-.43.44-.63s.17-.23.25-.34l.24-.32c.11-.15.23-.3.34-.46l.24-.3.15-.19.2-.26.22-.29c.06-.07.12-.15.19-.22l0,0L24,8l.34-.4.39-.47c.11-.14.23-.27.34-.4l.24-.28.34-.39.28-.33.22-.25.2-.23.17-.2.31-.36.29-.31c.1-.11.22-.23.32-.35a.42.42,0,0,1,.31-.17h0a.12.12,0,0,1,.08,0H28l.06,0h0l.1,0,.18,0,.14,0,.07,0a.08.08,0,0,1,.09,0h0l.08,0h.07l.05,0h0A.18.18,0,0,1,29,3.53a.12.12,0,0,0,.1,0,.24.24,0,0,1,.14,0h.1a1.12,1.12,0,0,0,.26-.08l.16,0h.07l.23-.05a.08.08,0,0,1,.09,0h.09l.05,0,.06,0h0a.16.16,0,0,1,.13,0,.19.19,0,0,0,.1,0,.28.28,0,0,1,.16-.05h.07l.09,0,.17,0a0,0,0,0,1,0,0h0l.06,0h.09l.08,0,0,0h0l.09,0,.16-.06.14,0h.1l0,0-.05.05-.08.07-.29.23c-.18.15-.38.3-.56.46l-.35.3-.14.13-.22.2-.53.47-.4.38c-.08.09-.17.17-.26.26l-.21.2-.31.3-.46.48-.14.15-.22.24-.07.08-.07.07L27.5,7,27,7.56l0,0,0,0-.11.13-.3.35-.27.31-.13.14h0l-.1.12c-.08.1-.15.2-.23.29l-.22.26-.1.12,0,0-.11.14-.21.26L25,9.94l-.14.17-.29.36-.05.06-.23.29-.1.12-.18.23-.16.2-.13.14-.12.15-.1.13-.16.2-.1.13-.16.2a2.54,2.54,0,0,0-.2.24l-.09.11h0l-.09.11-.23.29-.14.16-.13.16,0,.05-.3.36-.31.41-.07.1-.07.1a2.83,2.83,0,0,0-.2.28c-.12.17-.28.4-.43.64a.72.72,0,0,0-.13.28,1.23,1.23,0,0,1-.14.31.5.5,0,0,0,0,.27.07.07,0,0,0,.05,0l.15.07.06,0,0,0,.09,0a.5.5,0,0,0,.37-.1l.41-.32.31-.23.3-.22,1-.81c.31-.25.62-.52.92-.78l.32-.27.25-.22.12-.11h0l.05,0h0v0l0,.08-.13.28-.25.57c0,.09-.07.19-.11.29s-.05.15-.08.22a5,5,0,0,0-.25.81.46.46,0,0,0,0,.2.31.31,0,0,0,0,.08s0,0,0,.05h0l0,0a.23.23,0,0,0,0,.1h0s0,0,0,0v0h0a.18.18,0,0,1,.15-.1h0l0,0,.15-.13.13-.15.09-.11a3.71,3.71,0,0,0,.23-.32c.11-.17.21-.34.31-.51s.1-.17.14-.25l.05-.08c.1-.18.21-.36.32-.54l0-.06c.1-.16.21-.34.32-.5a3.25,3.25,0,0,1,.23-.29l.12-.16a5.27,5.27,0,0,1,.58-.66l.45-.45.65-.64c.16-.16.33-.3.5-.45l.3-.28.32-.29.47-.43a7.22,7.22,0,0,0,.87-.88,1.11,1.11,0,0,0,.2-.37.14.14,0,0,0,0-.09V8.23a.25.25,0,0,1,0-.12.24.24,0,0,0-.13-.23h0a.59.59,0,0,1-.23-.14c-.1-.1-.12-.1-.23,0s-.46.29-.69.45l-.74.55-.07.06-.55.43h0l-.26.21-.27.24-.33.27-.42.35-.49.42c-.14.12-.28.24-.41.37l-.08.06-.49.44-.19.16-.15.14-.27.24-.23.21-.21.18-.32.28-.16.12,0,0,0,0,0,0,0,0,.06-.07.09-.12.13-.18.26-.33.16-.2.39-.5.07-.09.17-.22.12-.16.17-.22.2-.26.4-.5.18-.23.3-.37.15-.18.14-.17L27,8.78l.18-.22.33-.4.22-.26.22-.26.42-.49.05-.07L29,6.44c.43-.45.86-.9,1.19-1.23l.7-.7.6-.57.32-.27.09-.07.2-.16.18-.15.13-.11.24-.2.81-.58,0,0a.3.3,0,0,1,.24-.09h0l.33-.08h0a.11.11,0,0,1,.09,0h.1l.12,0,.13,0,.14,0h.13l.13,0L35,2a2.14,2.14,0,0,0,.32-.08l.11,0,.11,0,.22,0H36l.12,0,.18,0,.17,0,.14,0,0,0,.28-.25a.64.64,0,0,0,.17-.3V1a.15.15,0,0,1,0-.2.12.12,0,0,0,0-.15l0,0,0,0,0,0a.62.62,0,0,1-.29-.18.21.21,0,0,0-.18-.09l-.27,0c-.18,0-.36,0-.54.09l-.55.12-.19,0-.2.05-.86.2c-.24.05-.47.12-.7.18l-.1,0-.86.23-.65.18L31,1.64l-.4.12-.18.05-.17.05L30,1.93l-.33.1-.2.05-.09,0-.06,0,0-.05a.65.65,0,0,1,.15-.18l.31-.32L30.32,1a3.7,3.7,0,0,0,.24-.29.67.67,0,0,0,.09-.21.67.67,0,0,0,0-.2.13.13,0,0,0-.08-.12L30.39.09s0,0-.08,0c-.22.22-.46.45-.74.7s-.48.45-.71.67l-.08.08-.71.7-.36.36-.06,0-.11,0-.13,0-.22.06L27,2.82l-.16.05-.18,0-.12,0-.13,0L26.3,3l-.11,0L26,3.13l-.18.05-.16,0-.18,0-.12,0-.13,0-.12,0-.12,0-.11,0-.12,0-.18,0-.35.1-.14,0a1,1,0,0,0-.22.08.7.7,0,0,1-.14,0l-.07,0-.19.06-.18.05L22.91,4l-.13,0h0l-.08,0-.17,0-.29.08L22,4.29l-.19,0-.2.06-.23.07-.23.06-.25.07-.25.07-.21.06-.21,0L20,4.85l-.2.06L19.6,5l-.18,0-.14,0-.1,0-.06,0-.1,0a.33.33,0,0,1-.14,0l-.1,0-.15,0c-.2.06-.42.13-.62.21l-.1,0a7.12,7.12,0,0,0-.76.31c-.34.17-.68.35-1,.53l-.63.33a.86.86,0,0,0-.34.34.12.12,0,0,0,0,.09.3.3,0,0,1-.08.2.12.12,0,0,0,0,.13.16.16,0,0,0,.11.1h.08a.24.24,0,0,0,.26,0L16,7.3l.33-.16.87-.4.23-.09.11,0,.1,0,.22-.08.35-.1.15,0h0l.07,0h.05a.13.13,0,0,1,.12,0,.17.17,0,0,0,.1,0,.35.35,0,0,1,.13-.05h.05l.18,0,.09,0h0l.1,0L19.53,6l.16,0h.11l.11,0H20l0,0,.08,0h.05l.1,0,.14,0h.05l.09,0a.48.48,0,0,1,.17,0h.07L21,5.67l.09,0,.2,0,.16,0h.11l.1,0h.06l.06,0,.07,0h0l.1,0,.19,0,.17,0,.08,0a.07.07,0,0,1,.08,0h.06s0,0,.06,0a0,0,0,0,1,0,0h0a.24.24,0,0,0,.12,0,.42.42,0,0,1,.16,0h.06l.16,0,.1,0h0l.06,0,.09,0,0,0h0l0,0h.14l0,0h.11l0,0H24l.17,0,.08,0h.06l.07,0,.06,0h.07l.18,0,.08,0,.08,0,.19,0,.16,0,.08,0a.08.08,0,0,1,.09,0h.1l.07,0,.05,0h0l.09,0,.17,0h0m-.61.19h0m2.51-.7h0m1.15-.32h0m1.5-.41h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4989",
    "data-name": "Path 4989",
    className: "cls-3",
    d: "M41.52,12.64l0,0c.1.05.12.11.07.2l0,0c-.13.15-.25.3-.39.45a.71.71,0,0,1-.14.1l-.34.17-.21.07-.13,0-.21.09h-.05l-.26.08h0l-.15,0-.24.06-.1,0h0s-.1,0-.13,0h0l-.3.06-.24,0-.2,0-.25.07h0l-.3.06-.26,0h-.09l-.05,0,0,0-.37.05-.35.05-.43.09c-.14,0-.26,0-.39,0a1.35,1.35,0,0,1-.29,0l-.37.08h0l-.39.06-.19,0h0l-.5.06H34l-.51.07h-.1l-.1,0c-.23,0-.46,0-.69.06s-.37,0-.55.06l-.46,0H29.7l-.27,0-.3,0-.46-.09a1.8,1.8,0,0,1-.32-.06,2,2,0,0,1-.23-.07h0l-.2,0-.23-.09c-.16-.08-.33-.15-.48-.24a2.21,2.21,0,0,1-.29-.22.94.94,0,0,1-.24-.93c0-.15.11-.3.16-.45a2,2,0,0,1,.23-.51l.13-.2a4.06,4.06,0,0,1,.44-.49A5.88,5.88,0,0,1,28.66,11a9.85,9.85,0,0,1,1.11-.59l1.09-.46.66-.24.73-.24.47-.13.61-.17L33.8,9l.41-.09,1-.17.69-.06a12.2,12.2,0,0,1,1.48-.05l.48.06a.66.66,0,0,1,.24.11l.17.1a.52.52,0,0,1,.23.21.44.44,0,0,1,.05.15,1.07,1.07,0,0,1,0,.25,1.7,1.7,0,0,1,0,.22,1.63,1.63,0,0,1-.33.49,3.17,3.17,0,0,1-.82.59,8.67,8.67,0,0,1-1.12.5l-.4.14-.19.07a1.17,1.17,0,0,1-.2.06l-.06,0-.11,0s-.06,0-.07,0h0l-.11,0-.21.06-.28.09h0l-.12,0h0l-.24.06-.09,0h-.16s-.07,0-.11,0a.12.12,0,0,0-.1,0s-.07,0-.11,0h0s-.06,0-.09,0-.09,0-.12,0-.07,0-.11,0l-.06,0-.05,0s-.11,0-.15,0h0c-.06,0-.12,0-.16,0h0l-.29.05-.18,0s-.07,0-.1,0-.06,0-.1,0l-.07,0h0l-.27.05-.3.08h-.1s-.07,0-.09,0h0l-.28,0c-.1,0-.2.06-.3.09h-.05c-.05,0-.11,0-.14,0h0l-.39.07a.16.16,0,0,1-.1,0l-.14,0s-.09,0-.1-.06a.19.19,0,0,1,0-.19.19.19,0,0,0,.06-.16.14.14,0,0,1,0-.06,1.55,1.55,0,0,1,.19-.24.38.38,0,0,1,.17-.08l.45-.11,1.23-.32.37-.09,1-.28c.13,0,.26-.08.38-.12l.5-.14.35-.12.8-.28A16.27,16.27,0,0,0,36.87,10l.31-.17.08,0v0l-.11,0-1,0H36l-.48,0-.24,0h-.08a4.43,4.43,0,0,0-.51.06l-.27,0c-.09,0-.17,0-.22,0S34,9.88,34,10s-.08,0-.12,0h0c0,.06-.07,0-.1,0l-.14,0h-.18s-.06,0-.1,0-.08,0-.11,0h0l-.25.06,0,0h0l-.25.06-.06,0v0l-.22,0-.24.07-.3.11c-.19.06-.39.12-.58.2l-.61.26a14.89,14.89,0,0,0-1.38.7,6.84,6.84,0,0,0-1,.69l-.25.2a1.41,1.41,0,0,0-.29.4.4.4,0,0,0-.06.3.24.24,0,0,0,.1.14,3.12,3.12,0,0,0,.43.15l.34.08.4.05a5.46,5.46,0,0,0,.57,0h1.4l.34,0,1-.06.66-.08,1.23-.16.86-.12.83-.13.85-.14,1.12-.18,1.12-.18,1-.14a6.29,6.29,0,0,1,1.3,0l.13,0,.23.13c.06,0,.05,0,.09,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4990",
    "data-name": "Path 4990",
    className: "cls-3",
    d: "M30.68,15.26H29.53l-.1,0h-.11l-.19,0a3,3,0,0,1-.32-.06l-.14,0-.1,0-.22,0L28.18,15l-.07,0h0L28,15l-.14,0a1.09,1.09,0,0,1-.23-.09l-.08,0a3.73,3.73,0,0,1-.4-.2,1.23,1.23,0,0,1-.29-.22.93.93,0,0,1-.24-1,1,1,0,0,1,.08-.25c0-.06.05-.13.07-.2a1.87,1.87,0,0,1,.24-.52l.12-.2a4,4,0,0,1,.39-.43l.06-.06a5.88,5.88,0,0,1,1-.81,8,8,0,0,1,1.12-.59c.34-.16.68-.3,1.08-.47l.56-.2.11,0,.73-.24.32-.09.15,0,.19-.06.43-.11.3-.07.16,0L34,9l.25-.05.15,0,.83-.15.44,0,.26,0a12.13,12.13,0,0,1,1.48,0,3.93,3.93,0,0,1,.48.06l.2.08.05,0,.08,0,.09.06a.54.54,0,0,1,.24.21.37.37,0,0,1,.05.17,1.07,1.07,0,0,1,0,.25.78.78,0,0,1,0,.22,1.41,1.41,0,0,1-.33.5,3,3,0,0,1-.83.6,8,8,0,0,1-1.12.51l-.24.08-.17.06-.09,0-.1,0a.47.47,0,0,1-.14,0l-.06,0h-.09l-.08,0h0a.05.05,0,0,1,0,0h-.12l-.13,0-.08,0-.28.08h-.05l-.1,0h0l-.08,0-.16,0h0l-.05,0h-.15a.1.1,0,0,1-.1,0h0l-.06,0-.09,0h-.07a.08.08,0,0,1-.08,0h-.06a.11.11,0,0,0-.07,0s-.05,0-.08,0h-.09l0,0h-.06s-.06,0-.08,0,0,0,0,0h-.06a.19.19,0,0,0-.1,0h0l-.09,0-.2,0-.09,0-.09,0h0s0,0,0,0-.05,0-.08,0h0l-.05,0H32l-.09,0-.18,0-.16.05-.14,0H31.3s0,0,0,0l0,0h-.1l-.18,0-.2.05-.1,0h-.11s-.05,0-.07,0h0l-.1,0-.29.05a.2.2,0,0,1-.11,0l-.14,0h0s-.08,0-.09-.07a.2.2,0,0,1,0-.21.2.2,0,0,0,.06-.14.15.15,0,0,1,0-.09l0-.05.15-.19a.46.46,0,0,1,.19-.08l.28-.07.16,0,.68-.17.56-.15.15,0,.22-.06h0l1-.27.23-.07.15,0,.22-.07.28-.08.27-.09.08,0,.24-.08.56-.2c.52-.2,1-.42,1.53-.67l.32-.17,0,0h0l-.06,0-1,0h-.29l-.36,0-.16,0h-.16l-.15,0-.36,0-.12,0-.15,0h-.1l-.11,0a.23.23,0,0,1-.14,0A.2.2,0,0,0,34,10a.13.13,0,0,1-.09,0H33.8a.1.1,0,0,1-.09,0h-.09l-.08,0h-.16a.08.08,0,0,1-.09,0h-.06s0,0-.06,0a0,0,0,0,1,0,0l-.08,0-.17,0h-.07l-.1,0-.14,0h-.05l0,0h-.08l-.13,0-.25.08-.16.06-.14.05-.19.06-.38.13-.34.15-.28.11a14.89,14.89,0,0,0-1.38.7,7.42,7.42,0,0,0-1,.69l-.07.06L28,12.6a1.24,1.24,0,0,0-.29.4.4.4,0,0,0-.05.28.2.2,0,0,0,.08.12,3.12,3.12,0,0,0,.43.15l.33.08.4,0,.57,0h1.74l.3,0,.69,0,.5-.06.17,0,.24,0,1-.13.59-.08.27-.05.26,0,.57-.09.85-.14.51-.08.61-.1,1.12-.18,1-.14a5.73,5.73,0,0,1,1.31,0l.14,0,.23.13h0a.1.1,0,0,1,.05,0h0l.07,0a.14.14,0,0,1,.1.18.07.07,0,0,1,0,.06v0l-.1.11-.29.33a.42.42,0,0,1-.14.09h0c-.1.05-.21.12-.33.17l-.15.05-.07,0-.12.05-.1,0-.12,0h0l-.25.07h-.07l-.13,0-.09,0-.14,0-.06,0,0,0h-.1s-.06,0-.07,0l0,0H39.1l-.21,0-.24.05-.11,0-.09,0-.17,0-.08,0h-.1l-.22,0-.26.05h-.16l-.37.06-.13,0-.22,0-.2,0-.23,0-.15,0-.23,0a.78.78,0,0,1-.22,0h-.07l-.26,0-.11,0h0l-.13,0-.25,0-.14,0h-.21l-.36,0-.07,0H34l-.25,0-.27,0h-.2l-.22,0a3.57,3.57,0,0,0-.46,0l-.33,0h-.23a3.55,3.55,0,0,1-.46,0h-.93M37,8.62c-.37,0-.73,0-1.08.05l-.25,0-.44.05-.83.14-.15,0L34,9l-.15,0-.17,0-.3.07-.42.11-.2.06-.15,0c-.1,0-.21,0-.31.09l-.73.24-.11,0a5.31,5.31,0,0,0-.56.2c-.4.16-.74.3-1.08.46a8.33,8.33,0,0,0-1.11.58,6.33,6.33,0,0,0-1.05.8l-.06.06a5,5,0,0,0-.37.43l-.13.2a2,2,0,0,0-.23.5l-.07.21a1.13,1.13,0,0,0-.08.24.88.88,0,0,0,.23.9,1.18,1.18,0,0,0,.28.22l.4.2.08,0,.22.09.14,0,.07,0h0l.08,0,.16,0,.21,0,.1,0,.14,0,.32.06.19,0h.2l.17,0h1.91a3.55,3.55,0,0,0,.46,0l.22,0,.33,0A3.75,3.75,0,0,1,33.1,15h.22l.06,0h0l.1,0,.26,0,.25,0h.14l.35,0,.14,0h.07l.14,0,.25,0,.13,0,.12,0,.26,0h.08l.21,0a1.6,1.6,0,0,1,.23,0l.15,0,.23-.05.2,0,.22,0,.13,0,.37-.05v0h0l.05,0h.09l.26,0,.22,0h.09l.08,0,.18,0,.09,0,.1,0a1.83,1.83,0,0,1,.25-.06l.21,0h.09a.1.1,0,0,1,.1,0h.09l0,0,.06,0,.15,0,.09,0,.13,0h.06l.25-.07h0l.12,0,.1,0,.12-.05.07,0,.14-.05.34-.16h0a.38.38,0,0,0,.13-.09c.1-.1.19-.21.28-.32l.1-.12h0a.19.19,0,0,0,0-.1s0-.05-.08-.07l0,0h0a.1.1,0,0,1-.05,0l0,0-.22-.13-.12,0a5.64,5.64,0,0,0-1.3,0l-1,.14-1.12.18-.61.1-.5.09-.85.13-.58.09-.26,0-.27,0-.58.09-1,.12-.24,0-.17,0-.5.05-.68.05-.31,0h-.12l-.22,0h-1.4l-.57,0-.4-.06a1.87,1.87,0,0,1-.34-.08,3.12,3.12,0,0,1-.43-.15.26.26,0,0,1-.12-.15.42.42,0,0,1,.06-.31,1.12,1.12,0,0,1,.3-.41l.17-.15.08-.06a6.34,6.34,0,0,1,1-.69,12.77,12.77,0,0,1,1.38-.7l.27-.12.35-.14.38-.14.19-.06.14-.05.17-.06.24-.07.14,0h.07l0,0h0l.05,0,.14,0,.1,0h0l0,0,.18,0,.07,0a.12.12,0,0,1,.1,0h.06s0,0,0,0,0,0,.06,0h.2l.07,0h0s0,0,0,0,0,0,0,0h.12a.17.17,0,0,1,.15-.05.24.24,0,0,0,.12,0,.32.32,0,0,1,.14,0l.09,0,.16,0,.11,0,.37-.05h.3l.17,0,.36,0h.29l1,0,.08,0h0v.05h0l0,0-.06,0-.31.17c-.5.25-1,.47-1.54.67l-.56.2-.24.08-.08,0L34.2,11l-.29.08-.21.07-.16,0-.23.07c-.33.1-.67.19-1,.27h0l-.22.06-.15,0-.56.14-.67.17-.16,0-.29.07a.46.46,0,0,0-.16.07l-.14.18,0,.06a.08.08,0,0,0,0,.05.21.21,0,0,1-.07.18.15.15,0,0,0,0,.16l.07,0h0l.13,0,.09,0,.28-.06h.11s.06-.05.11-.05h.08l.1,0,.2-.06.2,0,.08,0a.08.08,0,0,1,.09,0h.11l.13,0,.17-.05.18,0,.09,0h0l.06,0h.09a.11.11,0,0,1,.09,0h0l.09,0,.09,0,.2,0,.09,0h0a.18.18,0,0,1,.13,0H33a.13.13,0,0,1,.12,0h.1l.05,0h.09a.13.13,0,0,1,.1,0h.06s0,0,0,0,0,0,.06,0h.1a.21.21,0,0,1,.1,0h.06s0,0,.06,0,0,0,.06,0h.15l.05,0,.16,0,.08,0h0l.1,0h0l.29-.09.08,0,.13,0,.07,0h.06a.08.08,0,0,1,.08-.05h0l.08,0h.09l.06,0,.14,0,.09,0,.09,0,.18-.06.23-.08a9.33,9.33,0,0,0,1.12-.5,3.12,3.12,0,0,0,.81-.59,1.31,1.31,0,0,0,.32-.48,1.55,1.55,0,0,0,0-.21,1.24,1.24,0,0,0,0-.27.58.58,0,0,0-.05-.14.47.47,0,0,0-.22-.2l-.09-.06-.08-.05-.06,0a.51.51,0,0,0-.17-.07,2.63,2.63,0,0,0-.48-.06H37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4991",
    "data-name": "Path 4991",
    className: "cls-3",
    d: "M8.91,10.34H10v.5a1.25,1.25,0,0,1-.2.82,1.06,1.06,0,0,1-.9.34A1,1,0,0,1,8,11.65a1.18,1.18,0,0,1-.19-.82v-.62A1.17,1.17,0,0,1,8,9.34,1,1,0,0,1,8.85,9c.67,0,1,.27,1,.85l-.57,0a.39.39,0,0,0-.38-.4H8.86c-.35,0-.46.18-.46.72v.54c0,.54.11.71.47.71s.47-.16.47-.53v-.16H8.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4992",
    "data-name": "Path 4992",
    className: "cls-3",
    d: "M11,9.58h-.77v-.5h2.15v.5h-.77V12H11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    className: "cls-3",
    x: 12.51,
    y: 11.39,
    width: 0.62,
    height: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4993",
    "data-name": "Path 4993",
    className: "cls-3",
    d: "M44.67,9.07h1.14a.93.93,0,0,1,.68.18.77.77,0,0,1,.23.61.71.71,0,0,1-.24.59.77.77,0,0,1,.18.18,1,1,0,0,1,.11.51.75.75,0,0,1-.26.66,1,1,0,0,1-.65.15H44.67Zm1.1,1.17c.24,0,.34-.1.34-.34s-.1-.34-.34-.34h-.48v.68Zm0,1.22c.24,0,.34-.1.34-.37s-.1-.36-.34-.36h-.53v.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4994",
    "data-name": "Path 4994",
    className: "cls-3",
    d: "M47.86,12h-.62V9.07h1.09a.94.94,0,0,1,.74.21.8.8,0,0,1,.21.64c0,.5-.15.73-.52.84L49.38,12H48.7l-.54-1.15h-.3Zm.42-1.62c.28,0,.4-.1.4-.38s-.11-.39-.4-.39h-.43v.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    className: "cls-3",
    x: 49.78,
    y: 11.39,
    width: 0.62,
    height: 0.56
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.adf67b1bcab0d9ed8d5f84a2251546f7.svg";
export { ForwardRef as ReactComponent };